// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/home.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/vehicleCheck.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  :root {
    --color-neutral-0: #FAFAFA;
    --color-neutral-100: #F2F1F6;
    --color-neutral-200: #EEF0F4;
    --color-neutral-300: #D5D8DC;
    --color-neutral-400: #BEC1C6;
    --color-neutral-500: #A7ABB0;
    --color-neutral-600: #90959A;
    --color-neutral-700: #797E85;
    --color-neutral-800: #62686F;
    --color-neutral-900: #4B5259;
    --color-neutral-1000: #343B43;
    --color-neutral-1100: #1D252D;

    --color-neutral-blue-100: #CED6DD;
    --color-neutral-blue-200: #A9BAC7;

    --color-light-100: #ffffff;
    --color-dark-100: #09090B;

    --color-brand-100: #D5E8F7;
    --color-brand-200: #ABD0EF;
    --color-brand-300: #8FC1E9;
    --color-brand-400: #73B1E4;
    --color-brand-500: #3A92D9;
    --color-brand-600: #0072CE;
    --color-brand-700: #005090;
    --color-brand-800: #003763;
    --color-brand-900: #002C4F;
    --color-brand-1000: #00213B;

    --color-brand-50: #EAF4FB;
    --color-brand-50-100: rgba(213, 232, 247, 0.5);
    --color-brand-50-200: rgba(171, 208, 239, 0.5);
    --color-brand-50-300: rgba(143, 193, 233, 0.5);
    --color-brand-50-400: rgba(115, 177, 228, 0.5);
    --color-brand-50-500: rgba(58, 146, 217, 0.5);
    --color-brand-50-600: rgba(0, 114, 206, 0.5);
    --color-brand-50-700: rgba(0, 80, 144, 0.5);
    --color-brand-50-800: rgba(0, 55, 99, 0.5);
    --color-brand-50-900: rgba(0, 44, 79, 0.5);
    --color-brand-50-1000: rgba(0, 33, 59, 0.5);

    --color-red-100: 253 231 230;
    --color-red-200: 251 208 209;
    --color-red-300: 231 166 175;
    --color-red-400: 241 123 127;
    --color-red-500: 231 76 85;
    --color-red-600: 211 43 63;
    --color-red-700: 196 33 55;
    --color-red-800: 167 28 47;
    --color-red-900: 137 23 39;
    --color-red-1000: 71 10 20;

    --color-orange-200: 254 239 208;
    --color-orange-700: 250 173 20;

    --color-green-200: 220 246 222;
    --color-green-700: 80 208 93;
        --font-theme: 'Noto Sans', 'Noto Sans JP', 'NotoSansKR', 'NotoSansTC', 'NotoSansHK', 'sans-serif';

        --spacing-3xs:  0.25rem;
        --spacing-2xs: 0.5rem;
        --spacing-xs: 0.75rem;
        --spacing-s: 1rem;
        --spacing-m: 1.25rem;
        --spacing-l: 1.5rem;
        --spacing-xl: 1.75rem;
        --spacing-2xl: 2rem;
        --spacing-4xl: 3rem;
        --spacing-5xl: 7rem;

        --height-small-button: 36px;
        --height-normal-button: 56px;

        --text-xxxs: 0.625rem;
        --text-xxs: 0.75rem;
        --text-xs: 0.875rem;
        --text-s: 1rem;
        --text-m: 1.125rem;

        --text-icon: 1.5rem;

        --spacing-basket-items-top: 0;
        --spacing-basket-items-right: 0;

        --text-button-xs: var(--text-xs);
        --text-button-s: var(--text-s);
        --text-button-home: var(--text-m) ;

        --line-height-button: var(--spacing-s);

        --modal-max-width: 600px;
        --modal-max-height: 600px;

        /* COMMON COLORS */
        /** Colors neutral **/
        --color-neutral-white: var(--color-light-100);
        --color-neutral-lowest: var(--color-neutral-0);
        --color-neutral-default: var(--color-neutral-100);
        --color-neutral-high: var(--color-neutral-blue-100);
        --color-neutral-higher: var(--color-neutral-blue-200);
        --color-neutral-highest: var(--color-neutral-1100);
        --color-neutral-dark: var(--color-dark-100);

        /** Colors brand **/
        --color-brand-lowest: var(--color-brand-50-200);
        --color-brand-low: var(--color-neutral-higher);
        --color-brand-default: var(--color-brand-600);
        --color-brand-high: var(--color-brand-800);
        --color-brand-highest: var(--color-brand-1000);

        /** Colors text **/
        --color-default: var(--color-neutral-1100);
        --color-low: var(--color-neutral-900);
        --color-lowest: var(--color-neutral-800);
        --color-inverse: var(--color-light-100);

        /** Colors success **/
        --color-success-lowest: var(--color-green-200);
        --color-success-default: var(--color-green-700);

        /** Colors warning **/
        --color-warning-lowest: var(--color-orange-200);
        --color-warning-default: var(--color-orange-700);

        /** Colors danger **/
        --color-danger-lowest: var(--color-red-100);
        --color-danger-lower: var(--color-red-200);
        --color-danger-low: var(--color-red-300);
        --color-danger-default: var(--color-red-700);
        --color-danger-high: var(--color-red-800);
        --color-danger-highest: var(--color-red-900);

        --color-emergency-gradient-from: var(--color-red-400);
        --color-emergency-gradient-to: var(--color-red-700);

        /** Colors background **/
        --color-overlay: var(--color-neutral-default);

        /** Colors border **/
        --color-border-low: var(--color-neutral-100);
        --color-border-default: var(--color-neutral-blue-100);

        /* HOME */
        --color-logo-home: var(--color-neutral-white);
        --color-icon-home: var(--color-default);

        /* HEADER */
        --color-header-border: var(--color-border-low);
        --color-header-border-progress: var(--color-brand-high);

        /* BUTTONS */
        --size-btn-height: 56px;
        --size-refused-min-width: 112px;

        /** Button primary **/
        --color-btn-primary-bg: var(--color-neutral-white);
        --color-btn-primary-text: var(--color-default);
        --color-btn-primary-icon-text: var(--color-default);
        --color-btn-primary-icon-bg: var(--color-neutral-default);
        --color-btn-primary-hover-text: var(--color-default);
        --color-btn-primary-hover-bg: var(--color-neutral-white);
        --color-btn-primary-disabled-text: var(--color-default);
        --color-btn-primary-disabled-bg: rgba(255,255,255, .50);

        /** Button home **/
        --color-btn-home-primary-bg: var(--color-neutral-white);
        --color-btn-home-primary-text: var(--color-default);
        --color-btn-home-primary-icon-text: var(--color-default);
        --color-btn-home-primary-border: var(--color-neutral-white);
        --color-btn-home-primary-hover-bg: var(--color-neutral-white);

        --size-padding-btn-home-primary: var(--spacing-xl);

        /** Button secondary **/
        --color-btn-secondary-bg: var(--color-neutral-default);
        --color-btn-secondary-text: var(--color-default);
        --color-btn-secondary-border: var(--color-neutral-default);
        --color-btn-secondary-hover-bg: var(--color-neutral-high);
        --color-btn-secondary-hover-text: var(--color-brand-highest);
        --color-btn-secondary-hover-border: var(--color-neutral-default);
        --color-btn-secondary-disabled-text: var(--color-default);
        --color-btn-secondary-disabled-bg: var(--color-neutral-lowest);
        --color-btn-secondary-disabled-border: var(--color-neutral-default);

        /** Button tertiary **/
        --color-btn-tertiary-bg: var(--color-brand-high);
        --color-btn-tertiary-text: var(--color-neutral-white);
        --color-btn-tertiary-hover-bg: var(--color-brand-highest);
        --color-btn-tertiary-disabled-bg: var(--color-brand-low);
        --color-btn-tertiary-disabled-text: var(--color-neutral-white);

        /** Button error **/
        --color-btn-error-hover-bg: var(--color-red-800);
        --color-btn-error-disabled-bg: var(--color-red-300);

        --rounded-button: 9999px;
        --border-btn-primary-size: 0;
        --border-btn-secondary-size: 0;
        --border-btn-header-secondary-size: var(--border-btn-secondary-size);
        --font-btn-weight: 700;
        --size-btn-primary-icon-home: 80px;

        /** Card Radio Bullet **/
        --color-card-radio-bg: var(--color-neutral-white);
        --color-card-radio-title: var(--color-default);
        --color-card-radio-description: var(--color-default);
        --color-card-radio-border: var(--color-border-default);
        --color-card-radio-hover-bg: var(--color-brand-50-800);
        --color-card-radio-active-title: var(--color-inverse);
        --color-card-radio-active-description: var(--color-inverse);
        --color-card-radio-active-bg: var(--color-brand-high);
        --border-card-radio-size: 1px;

        /** Outline CTA **/
        --outline-default-size: 4px;
        --color-outline-color: var(--color-border-default);
        --outline-offset-default: 0px;

        /* FORM */
        /** Input **/
        --color-input-bg: var(--color-neutral-default);
        --color-input-label: var(--color-brand-800);
        --color-input-focus-label: var(--color-brand-high);
        --color-input-text: var(--color-low);
        --color-input-border: var(--color-neutral-default);
        --color-input-border-hover: var(--color-neutral-default);

        --color-input-multiple-tag-bg: var(--color-neutral-white);
        --color-input-multiple-tag-label: var(--color-low);

        --p-select-spacing: 0px;
        --rounded-select: 0px;
        --ring-select-border: var(--color-border-low);

        --rounded-input: 8px;
        --spacing-input-border-size: 0;

        /** Switch **/
        --color-switch-bg: var(--color-neutral-default);
        --color-switch-border: var(--color-neutral-default);
        --color-switch-span: var(--color-neutral-white);
        --border-switch-size: 2px;

        --color-switch-checked-bg: var(--color-brand-high);
        --color-switch-checked-border: var(--color-brand-high);
        --color-switch-checked-span: var(--color-neutral-white);

        --w-switch-small: 48px;
        --h-switch-small: 28px;

        /** Radio **/
        --color-radio-border: var(--color-default);
        --color-radio-active-bg: var(--color-inverse);
        --color-radio-active-border: var(--color-inverse);
        --color-radio-active-dot: var(--color-brand-high);

        --color-radio-secondary-border: var(--color-default);
        --color-radio-secondary-active-bg: var(--color-brand-high);
        --color-radio-secondary-active-border: var(--color-brand-high);
        --color-radio-secondary-active-dot: var(--color-neutral-white);
        --color-radio-secondary-active-text: var(--color-default);
        --color-radio-secondary-hover-border: var(--color-brand-high);

        --border-radio-size: 2px;

        /* CARDS */
        --rounded-card: 8px;
        --color-card-bg: var(--color-overlay);

        /* POPUP */
        --color-popup-bg: var(--color-neutral-white);

        /* MODALS */
        --rounded-t-modal: 1rem 1rem 0 0;
        --rounded-modal: 1rem;

        /* BUTTON LIST */
        --rounded-button-list: 42px;

        /* PANEL OPENING */
        --rounded-t-panel-opening: 228px;

        /* Chat */
        --rounded-chat: 1.5rem;

        /* Admin */
        --rounded-admin-card: 85px;
        --color-slot-number: var(--color-card-bg);

        /* Carousel */
        --color-carousel-step: var(--color-neutral-higher);
        --color-carousel-step-active: var(--color-default);
        --w-carousel-step: 0.375rem;
        --h-carousel-step: 0.375rem;
        --w-carousel-step-active: 0.625rem;
        --h-carousel-step-active: 0.625rem;
        --size-carousel: 40px;
        --size-carousel-footer: -40px;
        --spacing-navigation-top: 50%;
        --spacing-arrow-left-left: 12px;
        --spacing-arrow-left-right: inherit;
        --spacing-arrow-right-right: 12px;

        /* Scroll button */
        --spacing-scroll-button: 36px;

        --content-max-width: 768px;

        /* SCREENSAVER ANIMATION */
        /* Duration of the animations. It MUST BE in milliseconds */
        --screensaver-animation-duration: 600ms;
        /* Default delay before showing the 'out' animation */
        --screensaver-animation-out-delay: calc(20s - var(--screensaver-animation-duration));
  }

    :root[data-origin="KIOSK"] {

        --spacing-3xs:  0.5rem;
        --spacing-2xs: 1rem;
        --spacing-xs: 1.5rem;
        --spacing-s: 2rem;
        --spacing-m: 2.5rem;
        --spacing-l: 3rem;
        --spacing-xl: 3.5rem;
        --spacing-2xl: 4rem;
        --spacing-4xl: 6rem;
        --spacing-5xl: 14rem;

        --height-small-button: 72px;
        --height-normal-button: 112px;

        --text-xxxs: 1rem;
        --text-xxs: 1.25rem;
        --text-xs: 1.5rem;
        --text-s: 1.75rem;
        --text-m: 2rem;

        --text-icon: 2.5rem;

        --text-button-xs: var(--text-xxs);
        --text-button-s: var(--text-xs);

        --line-height-button: var(--spacing-s);

        --modal-max-width: 900px;
        --modal-max-height: 1200px;

        --size-btn-height: 112px;

        --rounded-input: 16px;

        --rounded-modal: 85px;

        --rounded-card: 16px;

        --rounded-button-list: 72px;

        --spacing-scroll-button: 74px;

        --content-max-width: 100vw;

        --size-refused-min-width: 168px;
    }

    :root[data-origin="SHAREBOX_INDOOR_KIOSK"] {

        --spacing-3xs:  0.375rem;
        --spacing-2xs: 0.75rem;
        --spacing-xs: 1rem;
        --spacing-s: 1.5rem;
        --spacing-m: 2rem;
        --spacing-l: 2.25rem;
        --spacing-xl: 2.5rem;
        --spacing-2xl: 3rem;
        --spacing-4xl: 5rem;
        --spacing-5xl: 10rem;

        --height-small-button: 54px;
        --height-nrmal-button: 84px;

        --text-xxxs: 0.875rem;
        --text-xxs: 1rem;
        --text-xs: 1.25rem;
        --text-s: 1.5rem;
        --text-m: 1.75rem;

        --text-icon: 2.25rem;

        --text-button-xs: var(--text-xxs);
        --text-button-s: var(--text-xs);

        --line-height-button: var(--spacing-s);

        --modal-max-width: 900px;
        --modal-max-height: 000px;

        --size-btn-height: 76px;

        --rounded-input: 16px;

        --rounded-card: 16px;

        --rounded-modal: 1.5rem;

        --spacing-scroll-button: 50px;

        --content-max-width: 768px;
        --size-refused-min-width: 168px;
    }
    :root[data-theme="PORSCHE"] {
        --font-theme: 'PorscheNext', 'Heiti SC', 'SimHei', 'sans-serif';

        --spacing-basket-items-top: -4px;
        --spacing-basket-items-right: -4px;

        /* COMMON COLORS */
        /** Colors neutral **/
        --color-neutral-white: #ffffff;
        --color-neutral-lowest: #D8D8DB;
        --color-neutral-lowest-rgb: 216, 216, 219;
        --color-neutral-default: #A2A2A9;
        --color-neutral-high: #949598;
        --color-neutral-high-rgb: 148, 149, 152;
        --color-neutral-higher: #6B6D70;
        --color-neutral-highest: #535457;
        --color-neutral-dark: #010205;
        --color-transparent: rgba(255,255,255, 0);
        --color-notification-success: #197E10;
        --color-notification-success-rgb: 25 126 16;
        --color-outline: #1a44ea;
        --color-neutral-1100: #010205;

        /* Colors brand */
        --color-brand-transparent-lowest: rgba(var(--color-neutral-lowest-rgb), .35);
        --color-brand-transparent-low: rgba(var(--color-neutral-high-rgb), .18);
        --color-brand-default: var(--color-neutral-higher);
        --color-brand-high: var(--color-neutral-highest);
        --color-brand-highest: var(--color-neutral-dark);

        /** Colors success **/
        --color-success-default: var(--color-notification-success-rgb);

        /** Colors background **/
        --color-overlay: var(--color-brand-transparent-lowest);

        /** Colors border **/
        --color-border-low: var(--color-brand-transparent-low);

        /* HOME */
        --color-logo-home: rgba(255,255,255,0);
        --color-icon-home: var(--color-neutral-white);

        /*BUTTONS */
        /** Button primary **/
        --color-btn-primary-bg: var(--color-neutral-white);
        --color-btn-primary-text: var(--color-brand-highest);
        --color-btn-primary-icon-text: var(--color-default);
        --color-btn-primary-icon-bg: var(--color-transparent);
        --color-btn-primary-border: var(--color-neutral-dark);
        --color-btn-primary-hover-bg: var(--color-brand-transparent-low);
        --color-btn-primary-hover-text: var(--color-brand-highest);
        --color-btn-primary-disabled-text: var(--color-brand-low);
        --color-btn-primary-hover-border: var(--color-neutral-higher);
        --color-btn-primary-disabled-bg: var(--color-neutral-white);

        --color-btn-home-primary-bg: var(--color-transparent);
        --color-btn-home-primary-text: var(--color-inverse);
        --color-btn-home-primary-icon-text: var(--color-inverse);
        --color-btn-home-primary-border: var(--color-neutral-white);
        --color-btn-home-primary-hover-bg:  var(--color-transparent);

        /** Button secondary **/
        --color-btn-secondary-bg: var(--color-brand-transparent-lowest);
        --color-btn-secondary-text: var(--color-brand-highest);
        --color-btn-secondary-border: var(--color-brand-transparent-lowest);
        --color-btn-secondary-hover-bg: var(--color-neutral-lowest);
        --color-btn-secondary-hover-border: var(--color-neutral-lowest);
        --color-btn-secondary-disabled-text: var(var(--color-brand-low));
        --color-btn-secondary-disabled-bg: var(--color-brand-transparent-lowest);
        --color-btn-secondary-disabled-border: var(--color-brand-transparent-lowest);

        /** Button tertiary **/
        --color-btn-tertiary-bg: var(--color-brand-highest);
        --color-btn-tertiary-hover-bg: var(--color-brand-high);

        --rounded-button: 4px;
        --border-btn-primary-size: 2px;
        --border-btn-secondary-size: 0px;
        --border-btn-header-secondary-size: var(--border-btn-secondary-size);
        --font-btn-weight: 400;
        --size-btn-primary-icon-home: 40px;


        /** Card Radio Bullet **/
        --color-card-radio-bg: var(--color-neutral-white);
        --color-card-radio-border: var(--color-neutral-lowest);
        --color-card-radio-hover-bg: var(--color-neutral-white);
        --color-card-radio-active-bg: var(--color-neutral-white);
        --color-card-radio-active-title: var(--color-default);
        --color-card-radio-active-description: var(--color-default);

        /** Outline CTA **/
        --outline-default-size: 2px;
        --color-outline-color: var(--color-outline);
        --outline-offset-default: 2px;

        /* FORM */
        /** Input **/
        --color-input-bg: var(--color-neutral-white);
        --color-input-label: var(--color-neutral-dark);
        --color-input-focus-label: var(--color-brand-high);
        --color-input-text: var(--color-neutral-dark);
        --color-input-border: var(--color-neutral-higher);
        --color-input-border-hover: var(--color-neutral-dark);

        --p-select-spacing: 6px;
        --ring-select-border: var(--color-neutral-lowest);

        --rounded-input: 4px;
        --rounded-select: 4px;
        --spacing-input-border-size: 2px;

        /** Switch **/
        --color-switch-bg: var(--color-transparent);
        --color-switch-border: var(--color-neutral-higher);
        --color-switch-span: var(--color-neutral-dark);
        --border-switch-size: 2px;

        --color-switch-checked-bg: var(--color-notification-success);
        --color-switch-checked-border: var(--color-notification-success);
        --color-switch-checked-span: var(--color-neutral-white);

        /** Radio **/
        --color-radio-border: var(--color-neutral-higher);
        --color-radio-active-bg: var(--color-default);
        --color-radio-active-border: var(--color-default);
        --color-radio-active-dot: var(--color-inverse);
        --color-radio-secondary-border: var(--color-neutral-higher);
        --color-radio-secondary-active-bg: var(--color-default);
        --color-radio-secondary-active-border: var(--color-default);
        --color-radio-secondary-hover-border: var(--color-neutral-higher);

        /* CARDS */
        --rounded-card: 4px;
        --color-card-bg: var(--color-overlay);

        /* MODALS */
        --rounded-t-modal: 8px 8px 0 0;
        --rounded-modal: 8px;

        /* BUTTON LIST */
        --rounded-button-list: 4px;

        /* PANEL OPENING */
        --rounded-t-panel-opening: 8px;

        /* Chat */
        --rounded-chat: 4px;

        /* Admin */
        --rounded-admin-card: 4px;
        --color-slot-number: var(--color-neutral-white);

        /* Carousel */
        --color-carousel-step: var(--color-neutral-higher);
        --w-carousel-step: 0.5rem;
        --h-carousel-step: 0.5rem;
        --w-carousel-step-active: 1.25rem;
        --h-carousel-step-active: 0.5rem;
        --size-carousel: 40px;
        --size-carousel-footer: -40px;
        --spacing-navigation-top: -20px;
        --spacing-arrow-left-left: inherit;
        --spacing-arrow-left-right: 40px;
        --spacing-arrow-right-right: 0px;
    }
    :root[data-theme="FORD"] {
        --font-theme: 'FordAntenna', 'Helvetica', 'Arial', 'sans-serif';

        /* COMMON COLORS */
        /** Colors neutral **/
        --color-neutral-white: #ffffff;
        --color-neutral-lowest: #f1f1f1;
        --color-neutral-default: #6e6e6e;
        --color-neutral-high: #4d4d4d;
        --color-neutral-high-rgb: 77, 77, 77;
        --color-neutral-higher: #1700f4;
        --color-neutral-highest: #00095b;
        --color-transparent: rgba(255,255,255, 0);
        --color-outline: #1700f4;

        --color-low: var(--color-neutral-highest);
        --color-default: var(--color-neutral-highest);

        /* Colors brand */
        --color-brand-transparent-lowest: var(--color-neutral-lowest);
        --color-brand-transparent-low: rgba(var(--color-neutral-high-rgb), .18);
        --color-brand-default: var(--color-neutral-higher);
        --color-brand-high: var(--color-neutral-higher);
        --color-brand-highest: var(--color-neutral-highest);

        /** Colors Danger **/
        --color-danger-default: 217 46 20;

        /** Colors background **/
        --color-overlay: var(--color-neutral-lowest);

        /** Colors border **/
        --color-border-low: var(--color-brand-transparent-low);

        /* HOME */
        --color-icon-home: #d92e14;

        /*BUTTONS */
        /** Button primary **/
        --color-btn-primary-bg: var(--color-neutral-white);
        --color-btn-primary-text: var(--color-brand-high);
        --color-btn-primary-icon-text: var(--color-default);
        --color-btn-primary-icon-bg: var(--color-transparent);
        --color-btn-primary-border: var(--color-brand-high);
        --color-btn-primary-hover-text: var(--color-neutral-white);
        --color-btn-primary-hover-bg: var(--color-brand-highest);
        --color-btn-primary-hover-border: var(--color-neutral-highest);
        --color-btn-primary-disabled-text: var(--color-brand-low);
        --color-btn-primary-disabled-bg: var(--color-neutral-white);

        --color-btn-home-primary-text: var(--color-brand-high);
        --color-btn-home-primary-icon-text: var(--color-brand-high);
        --color-btn-home-primary-border: rgba(255,255,255,0);
        --color-btn-home-primary-hover-bg: rgba(255,255,255,0.5);

        /** Button secondary **/
        --color-btn-secondary-bg: var(--color-neutral-white);
        --color-btn-secondary-text: var(--color-brand-high);
        --color-btn-secondary-border: var(--color-brand-high);
        --color-btn-secondary-hover-bg: var(--color-brand-highest);
        --color-btn-secondary-hover-text: var(--color-neutral-white);
        --color-btn-secondary-hover-border: var(--color-brand-highest);
        --color-btn-secondary-disabled-text: var(var(--color-brand-low));
        --color-btn-secondary-disabled-bg: var(--color-brand-transparent-lowest);
        --color-btn-secondary-disabled-border: var(--color-brand-transparent-lowest);

        /** Button tertiary **/
        --color-btn-tertiary-bg: var(--color-brand-high);
        --color-btn-tertiary-hover-bg: var(--color-brand-highest);
        --color-btn-tertiary-disabled-bg: #dedede;
        --color-btn-tertiary-disabled-text: #808080;

        --border-btn-primary-size: 2px;
        --border-btn-secondary-size: 2px;
        --border-btn-header-secondary-size: 0px;
        --font-btn-weight: 600;
        --size-btn-primary-icon-home: 80px;

        /** Card Radio Bullet **/
        --color-card-radio-hover-bg: var(--color-neutral-white);
        --color-card-radio-active-bg: var(--color-neutral-white);
        --color-card-radio-active-title: var(--color-brand-high);
        --color-card-radio-active-description: var(--color-default);
        --color-card-radio-active-border: var(--color-brand-high);

        /** Outline CTA **/
        --outline-default-size: 2px;
        --color-outline-color: var(--color-outline);
        --outline-offset-default: 2px;

        /* FORM */
        /** Input **/
        --color-input-bg: var(--color-neutral-white);
        --color-input-label: var(--color-brand-highest);
        --color-input-focus-label: var(--color-brand-highest);
        --color-input-text: var(--color-brand-highest);
        --color-input-border: var(--color-neutral-default);
        --color-input-border-hover: var(--color-neutral-dark);

        --p-select-spacing: 6px;
        --ring-select-border: var(--color-neutral-lowest);

        --rounded-select: 4px;
        --spacing-input-border-size: 2px;

        /** Switch **/
        --color-switch-bg: var(--color-overlay);
        --color-switch-border: var(--color-overlay);

        /** Radio **/
        --color-radio-border: var(--color-brand-highest);
        --color-radio-active-bg: var(--color-brand-high);
        --color-radio-active-border: var(--color-brand-high);
        --color-radio-active-dot: var(--color-inverse);
        --color-radio-secondary-border: var(--color-card-radio-border);
        --color-radio-secondary-active-text: var(--color-brand-default);

        /* CARDS */
        --rounded-card: 16px;

        /* MODALS */
        --rounded-t-modal: 20px 20px 0 0;
        --rounded-modal: 20px;

        /* BUTTON LIST */
        --rounded-button-list: 20px;

        /* PANEL OPENING */
        --rounded-t-panel-opening: 8px;

    }
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
i {
    font-style: normal;
  }
*hover i {
    text-decoration: none;
  }
*:focus {
  outline-color: var(--color-outline-color);
}
html,
  body {
  touch-action: none;
  --tw-pan-x: pan-x;
  --tw-pan-y: pan-y;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  font-family: var(--font-theme);
    font-optical-sizing: auto;
}
.header-home .header-icon {
  fill: var(--color-icon-home);
}
p spanh1,p span
  h1 a,p span
  h1 span {
  color: var(--color-default);
}
h1,
  h1 a,
  h1 span {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 2.5rem;
  color: var(--color-default);
}
html[data-origin="KIOSK"] h1,html[data-origin="KIOSK"] 
  h1 a,html[data-origin="KIOSK"] 
  h1 span {
  font-size: 3.75rem;
  line-height: 1;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] h1,html[data-origin="SHAREBOX_INDOOR_KIOSK"] 
  h1 a,html[data-origin="SHAREBOX_INDOOR_KIOSK"] 
  h1 span {
  line-height: 1;
  font-size: 2.25rem;
  line-height: 2.5rem;
}
@media (max-width: 320px) {

  h1,
  h1 a,
  h1 span {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
h1.home {
  margin-top: 1.5rem;
  text-align: center;
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 400;
  color: var(--color-inverse);
}
html[data-origin="KIOSK"] h1.home {
  font-size: 3rem;
  line-height: 4.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] h1.home {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
@media (max-width: 320px) {

  h1.home {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
p spanh2,p span
  h2 a,p span
  h2 span {
  color: var(--color-default);
}
h2,
  h2 a,
  h2 span {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 2.5rem;
  color: var(--color-default);
}
html[data-origin="KIOSK"] h2,html[data-origin="KIOSK"] 
  h2 a,html[data-origin="KIOSK"] 
  h2 span {
  font-size: 3rem;
  line-height: 4.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] h2,html[data-origin="SHAREBOX_INDOOR_KIOSK"] 
  h2 a,html[data-origin="SHAREBOX_INDOOR_KIOSK"] 
  h2 span {
  font-size: 1.750rem;
  line-height: 2.625rem;
}
@media (max-width: 320px) {

  h2,
  h2 a,
  h2 span {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
h2.home {
    word-break: keep-all;
    margin-top: 0.25rem;
    text-align: center;
    font-size: 1.5rem;
    line-height: 2rem;
    color: var(--color-inverse);
  }
html[data-origin="KIOSK"] h2.home {
  margin-top: 0.75rem;
  font-size: 3.75rem;
  line-height: 1;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] h2.home {
  margin-top: 0.75rem;
  line-height: 1;
  font-size: 3rem;
  line-height: 4.5rem;
}
@media (max-width: 320px) {

  h2.home {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
h2.title_card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 1rem;
  line-height: 1.5rem;
  color: var(--color-default);
}
html[data-origin="KIOSK"] h2.title_card {
  font-size: 1.5rem;
  line-height: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] h2.title_card {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
p spanh3 {
  color: var(--color-default);
}
h3 {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 2.5rem;
  color: var(--color-default);
}
html[data-origin="KIOSK"] h3 {
  font-size: 1.750rem;
  line-height: 2.625rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] h3 {
  font-size: 1.5rem;
  line-height: 2rem;
}
p spanh4 {
  color: var(--color-default);
}
h4 {
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 2.5rem;
  color: var(--color-default);
}
html[data-origin="KIOSK"] h4 {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] h4 {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
p,
  a,
  span,
  h2.title_card span,
  label {
  font-size: 1rem;
  line-height: 1.5rem;
}
html[data-origin="KIOSK"] p,html[data-origin="KIOSK"] 
  a,html[data-origin="KIOSK"] 
  span,html[data-origin="KIOSK"] 
  h2.title_card span,html[data-origin="KIOSK"] 
  label {
  font-size: 1.750rem;
  line-height: 2.625rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] p,html[data-origin="SHAREBOX_INDOOR_KIOSK"] 
  a,html[data-origin="SHAREBOX_INDOOR_KIOSK"] 
  span,html[data-origin="SHAREBOX_INDOOR_KIOSK"] 
  h2.title_card span,html[data-origin="SHAREBOX_INDOOR_KIOSK"] 
  label {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
@media (max-width: 320px) {

  p,
  a,
  span,
  h2.title_card span,
  label {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
html[data-origin="KIOSK"] p.\\!small {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] p.\\!small {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
html[data-origin="KIOSK"] p.small {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] p.small {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
span,
  p {
  color: var(--color-low);
}
p span.font-bold,
  p strong {
  color: var(--color-default);
}
.input {
  display: block;
  width: 100%;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-radius: var(--rounded-input);
  border-width: var(--spacing-input-border-size);
  border-color: var(--color-input-border);
  background-color: transparent;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 1.5rem;
  padding-bottom: 0.5rem;
  font-weight: 600;
  color: var(--color-default);
}
.input:hover {
  border-color: var(--color-input-border-hover);
}
html[data-origin="KIOSK"] .input {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  padding-top: 3.5rem;
  padding-bottom: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .input {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  padding-top: 3.5rem;
  padding-bottom: 2rem;
}
input[disabled].\\!text-black {
    -webkit-text-fill-color: black !important;
  }
input[disabled].text-black {
    -webkit-text-fill-color: black;
  }
.input-label {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 1rem;
  z-index: 0;
  transform-origin: 0;
  --tw-translate-y: -0.625rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--color-input-label);
  transition-duration: 300ms;
}
.peer:-moz-placeholder ~ .input-label {
  left: 0px;
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  color: var(--color-input-label);
}
.peer:placeholder-shown ~ .input-label {
  left: 0px;
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  color: var(--color-input-label);
}
html[data-origin="KIOSK"] .peer:-moz-placeholder ~ .input-label {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="KIOSK"] .peer:placeholder-shown ~ .input-label {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .peer:-moz-placeholder ~ .input-label {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .peer:placeholder-shown ~ .input-label {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:-moz-placeholder ~ .input-label {
  font-size: 1rem;
  line-height: 1.5rem;
}
.peer:placeholder-shown ~ .input-label {
  font-size: 1rem;
  line-height: 1.5rem;
}
html[data-origin="KIOSK"] .peer:-moz-placeholder ~ .input-label {
  font-size: 1.5rem;
  line-height: 2rem;
}
html[data-origin="KIOSK"] .peer:placeholder-shown ~ .input-label {
  font-size: 1.5rem;
  line-height: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .peer:-moz-placeholder ~ .input-label {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .peer:placeholder-shown ~ .input-label {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.peer:focus ~ .input-label {
  --tw-translate-y: -0.625rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--color-input-focus-label);
}
html[data-origin="KIOSK"] .input-label {
  top: 3rem;
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  font-size: 1.25rem;
  line-height: 1.75rem;
}
html[data-origin="KIOSK"] .peer:focus ~ .input-label {
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  font-size: 1.25rem;
  line-height: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .input-label {
  top: 3rem;
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  font-size: 1.25rem;
  line-height: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .peer:focus ~ .input-label {
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  font-size: 1.25rem;
  line-height: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .input-label {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.label-no-value {
  left: 0px;
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  color: var(--color-input-label);
}
html[data-origin="KIOSK"] .label-no-value {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .label-no-value {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
p span.textarea {
  color: var(--color-default);
}
.textarea {
  margin-top: 3rem;
  margin-bottom: 1.25rem;
  display: block;
  width: 100%;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-radius: var(--rounded-input);
  border-width: var(--spacing-input-border-size);
  border-color: var(--color-input-border);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 0.5rem;
  font-weight: 700;
  color: var(--color-input-text);
}
.textarea:hover {
  border-color: var(--color-input-border-hover);
}
html[data-origin="KIOSK"] .textarea {
  margin-top: 6rem;
  margin-bottom: 2.5rem;
  padding: 1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .textarea {
  margin-top: 6rem;
  margin-bottom: 2.5rem;
  padding: 1rem;
}
.textarea::-moz-placeholder {
  font-weight: 400;
}
.textarea::placeholder {
  font-weight: 400;
}
.textarea-label {
  position: absolute;
  top: 1.5rem;
  z-index: 0;
  transform-origin: 0;
  --tw-translate-y: -0.625rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  color: var(--color-input-label);
}
html[data-origin="KIOSK"] .textarea-label {
  top: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .textarea-label {
  top: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.input,
  .label-no-value,
  .textarea,
  .textarea-label {
  font-size: 1rem;
  line-height: 1.5rem;
}
html[data-origin="KIOSK"] .input,html[data-origin="KIOSK"] 
  .label-no-value,html[data-origin="KIOSK"] 
  .textarea,html[data-origin="KIOSK"] 
  .textarea-label {
  font-size: 1.5rem;
  line-height: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .input,html[data-origin="SHAREBOX_INDOOR_KIOSK"] 
  .label-no-value,html[data-origin="SHAREBOX_INDOOR_KIOSK"] 
  .textarea,html[data-origin="SHAREBOX_INDOOR_KIOSK"] 
  .textarea-label {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
 .no-cursor .switch {
  cursor: none !important;
}

  .no-transition .switch {
  animation: none !important;
  transition-property: none !important;
  transition-delay: 0s !important;
  transition-duration: 0s !important;
}
.switch {
  position: relative;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  display: inline-flex;
  height: 2rem;
  width: 3.5rem;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 9999px;
  border-width: var(--border-switch-size);
  border-color: var(--color-switch-border);
  background-color: var(--color-switch-bg);
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
  transition-property: all;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
html[data-origin="KIOSK"] .switch {
  height: 4rem;
  width: 7rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .switch {
  height: 4rem;
  width: 7rem;
}
.switch[aria-checked='true'] {
  border-color: var(--color-switch-checked-border);
  background-color: var(--color-switch-checked-bg);
}
.switch.disabled {
  cursor: not-allowed;
}
.switch.\\!disabled {
  cursor: not-allowed;
}
.switch.disabled {
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.05));
  }
.switch.\\!disabled {
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.05)) !important;
  }

  .no-transition .switch > span {
  animation: none !important;
  transition-property: none !important;
  transition-delay: 0s !important;
  transition-duration: 0s !important;
}
.switch > span {
  margin-top: auto;
  margin-bottom: auto;
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 9999px;
  background-color: var(--color-switch-span);
  transition-property: all;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
html[data-origin="KIOSK"] .switch > span {
  width: 3rem !important;
  height: 3rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .switch > span {
  width: 3rem !important;
  height: 3rem !important;
}
.switch > span.checked {
  --tw-translate-x: 1.625rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  background-color: var(--color-switch-checked-span);
}
.switch > span.\\!checked {
  --tw-translate-x: 1.625rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  background-color: var(--color-switch-checked-span);
}
.switch.small {
  height: var(--h-switch-small);
  width: var(--w-switch-small);
}
.switch.\\!small {
  height: var(--h-switch-small);
  width: var(--w-switch-small);
}
.switch.small > span {
  width: 1.25rem;
  height: 1.25rem;
}
.switch.\\!small > span {
  width: 1.25rem;
  height: 1.25rem;
}
.switch.small > span.checked {
  --tw-translate-x: 1.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.switch.\\!small > span.checked {
  --tw-translate-x: 1.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.switch.small > span.\\!checked {
  --tw-translate-x: 1.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
button:focus-visible {
  outline-style: solid;
  outline-width: var(--outline-default-size);
  outline-offset: var(--outline-offset-default);
  outline-color: var(--color-outline-color);
}
button p {
    color: inherit;
  }
button div > span,
  button > span {
    color: inherit;
  }
button.footer-button {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: var(--size-btn-height);
  width: 24rem;
  align-items: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
html[data-origin="KIOSK"] button.footer-button {
  justify-content: center;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] button.footer-button {
  justify-content: center;
}
.btn-home-primary {
  border-color: var(--color-btn-home-primary-border) !important;
  background-color: var(--color-btn-home-primary-bg) !important;
  padding: var(--size-padding-btn-home-primary) !important;
  font-size: var(--text-button-home) !important;
  color: var(--color-btn-home-primary-text) !important;
}
.btn-home-primary:hover {
  background-color: var(--color-btn-home-primary-hover-bg) !important;
}
.btn-header {
  border-width: var(--border-btn-header-secondary-size) !important;
}
.nextButton {
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 20;
  margin-bottom: 0px !important;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  padding-bottom: calc(2rem + env(safe-area-inset-bottom));
  padding-top: 1rem;
}
html[data-origin="KIOSK"] .nextButton {
  padding-left: 3rem;
  padding-right: 3rem;
  padding-top: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .nextButton {
  padding-left: 3rem;
  padding-right: 3rem;
  padding-top: 2rem;
  background-color: rgb(255 255 255 / 0.9);
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.nextButton::before {
    content: '';
    position: absolute;
    left: 1.75rem;
    right: 1.75rem;
    top: 0px;
    height: 1px;
    border-radius: 0.25rem;
    background-color: var(--color-header-border);
  }
html[data-origin="KIOSK"] .nextButton::before {
  left: 3rem;
  right: 3rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .nextButton::before {
  left: 3rem;
  right: 3rem;
}
a {
  text-decoration-line: underline;
}
.main-content,
  .homePage {
  min-height: 100svh;
}
.homePage:after {
    content: '';
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
    --tw-gradient-from: rgb(17 24 39 / 0.8) var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
    --tw-gradient-to: rgb(17 24 39 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), rgb(17 24 39 / 0) var(--tw-gradient-via-position), var(--tw-gradient-to);
    --tw-gradient-via-position: 70%;
    --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  }
.homePage:before {
    content: '';
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
    background-image: linear-gradient(to top, var(--tw-gradient-stops));
    --tw-gradient-from: rgb(17 24 39 / 0.8) var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
    --tw-gradient-to: rgb(17 24 39 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), rgb(17 24 39 / 0) var(--tw-gradient-via-position), var(--tw-gradient-to);
    --tw-gradient-via-position: 70%;
    --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  }
.\\!content {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  padding-bottom: 8rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .\\!content {
  padding-bottom: 6rem;
}
.content {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  padding-bottom: 8rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .content {
  padding-bottom: 6rem;
}
.\\!content > * {
  margin-bottom: 1.25rem;
}
.\\!content > *:last-child {
  margin-bottom: 0px;
}
html[data-origin="KIOSK"] .\\!content > * {
  margin-bottom: 2.5rem;
}
html[data-origin="KIOSK"] .\\!content > *:last-child {
  margin-bottom: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .\\!content > * {
  margin-bottom: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .\\!content > *:last-child {
  margin-bottom: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .\\!content > * {
  margin-bottom: 1.5rem;
}
.content > * {
  margin-bottom: 1.25rem;
}
.content > *:last-child {
  margin-bottom: 0px;
}
html[data-origin="KIOSK"] .content > * {
  margin-bottom: 2.5rem;
}
html[data-origin="KIOSK"] .content > *:last-child {
  margin-bottom: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .content > * {
  margin-bottom: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .content > *:last-child {
  margin-bottom: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .content > * {
  margin-bottom: 1.5rem;
}
.main-content {
  margin: auto;
  max-width: 56rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: 1rem;
  padding-top: 4rem;
}
html[data-origin="KIOSK"] .main-content {
  padding-left: 3rem;
  padding-right: 3rem;
  padding-bottom: 7rem;
  padding-top: 11rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .main-content {
  padding-left: 3rem;
  padding-right: 3rem;
  padding-bottom: 7rem;
  padding-top: 11rem;
}
@media (min-width: 1024px) {

  .main-content {
    max-width: 72rem;
  }
}
main, .main-content {
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}
main > *:first-child {
  padding-top: 1.5rem;
}
main > *, .main-content footer {
  margin-bottom: 1.25rem;
}
main > *:last-child, .main-content footer:last-child {
  margin-bottom: 0px;
}
html[data-origin="KIOSK"] main > *,html[data-origin="KIOSK"]  .main-content footer {
  margin-bottom: 2.5rem;
}
html[data-origin="KIOSK"] main > *:last-child,html[data-origin="KIOSK"]  .main-content footer:last-child {
  margin-bottom: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] main > *,html[data-origin="SHAREBOX_INDOOR_KIOSK"]  .main-content footer {
  margin-bottom: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] main > *:last-child,html[data-origin="SHAREBOX_INDOOR_KIOSK"]  .main-content footer:last-child {
  margin-bottom: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] main > *,html[data-origin="SHAREBOX_INDOOR_KIOSK"]  .main-content footer {
  margin-bottom: 1.25rem;
}
main h1 {
  text-align: center;
}
.main-content_admin {
  padding-top: 22rem !important;
}
input[disabled].warning-alert {
    -webkit-text-fill-color: black;
  }
.warning-alert {
  display: flex;
  align-items: center;
  border-width: 1px;
  border-color: rgb(var(--color-warning-default));
  padding: 1rem;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
html[data-origin="KIOSK"] .warning-alert {
  padding: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .warning-alert {
  padding: 1.5rem;
}
.warning-alert {
    border-radius: 30px;
    background: linear-gradient(0deg, rgba(255, 183, 0, 0.1), rgba(255, 183, 0, 0.1)), #ffffff;
  }
.no-cursor, .no-cursor *, .no-cursor a, .no-cursor button, .no-cursor .cursor-pointer {
  cursor: none !important;
}
.no-transition,
  .no-transition .transition,
  .no-transition .transition-all,
  .no-transition .transition-colors,
  .no-transition .transition-shadow,
  .no-transition .transition-opacity,
  .no-transition *:not(.animate-spin),
  .no-transition .transition-transform {
  animation: none !important;
  transition-property: none !important;
  transition-delay: 0s !important;
  transition-duration: 0s !important;
}
.no-blur,
  .no-blur *,
  .no-blur [class^="blur-"],
  .no-blur [class^="shadow-"],
  .no-blur [class^="backdrop-"],
  .no-blur [class^="drop-shadow-"] {
    /* Do not use tailwind classname to avoid recursive call */
    filter: none !important;
    box-shadow: 0 0 #0000 !important;
    backdrop-filter: none !important;
  }
.messages {
    height: calc(50vh - 106px);
  }
.carousel:not(.carousel-card).multiMedia:not(.fixed) {
  margin-top: var(--size-carousel);
  margin-bottom: var(--size-carousel);
  padding-bottom: var(--size-carousel);
}
.carousel.carousel-card {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}
.carousel .carousel-leftArrow {
  left: 0.75rem;
}
.carousel .carousel-rightArrow {
  right: 0.75rem;
}
.carousel:not(.fixed):not(.carousel-card) .carousel-leftArrow {
  left: var(--spacing-arrow-left-left);
  right: var(--spacing-arrow-left-right);
}
.carousel:not(.fixed):not(.carousel-card) .carousel-rightArrow {
  right: var(--spacing-arrow-right-right);
}
.carousel .navigation {
  top: 50%;
}
.carousel:not(.fixed):not(.carousel-card) .navigation {
  top: var(--spacing-navigation-top);
}
.carousel:not(.fixed):not(.carousel-card) .carousel-footer {
  position: absolute;
  background-image: none;
}
.carousel.carousel-card .carousel-footer {
  margin-top: 0px;
  margin-bottom: 0px;
}
.carousel .carousel-footer .step-indicator {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  height: var(--h-carousel-step);
  width: var(--w-carousel-step);
  border-radius: 9999px;
  background-color: var(--color-carousel-step);
  opacity: 0.3;
}
.carousel.carousel-card .carousel-footer .step-indicator {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  opacity: 1;
}
.carousel .carousel-footer .step-indicator.active {
  height: var(--h-carousel-step-active) !important;
  width: var(--w-carousel-step-active) !important;
  background-color: var(--color-carousel-step-active) !important;
  opacity: 1;
}
@media screen and (max-height: 552px) {
    .nextButton {
    position: relative;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 1rem;
  }

      .nextButton .scrollBtn {
        display: none;
      }
    .content {
    padding-bottom: 0px;
  }
    .main-content {
    padding-top: 5rem;
  }
    main > *, .main-content footer {
    margin-bottom: 1.25rem;
  }
    main > *:last-child, .main-content footer:last-child {
    margin-bottom: 0px;
  }
    .signature {
    height: 15rem !important;
  }
     {
    position: relative;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 1rem;
        display: none !important;
  }
    .\\!content {
    padding-bottom: 0px;
  }
     {
    padding-top: 5rem;
    margin-bottom: 1.25rem;
  }
    :last-child {
    margin-bottom: 0px;
  }
     {
    height: 15rem !important;
    position: relative;
    padding-left: 0px;
    padding-right: 0px;
        display: none !important;
        padding-bottom: 0px;
        padding-top: 5rem;
        margin-bottom: 1.25rem;
  }
    :last-child {
    margin-bottom: 0px;
  }
    .\\!signature {
    height: 15rem !important;
  }
  }
.logo-home {
  height: auto;
  width: 5rem;
}
@media (min-width: 768px) {

  .logo-home {
    width: 7rem;
  }
}
.break-word {
    word-break: break-word;
  }
.modal {
  width: 100%;
}
.modal-large {
  width: 100%;
  max-width: var(--modal-max-width);
}
@media (min-width: 768px) {
    .modal {
      width: min(100% - 40px, 896px);
      margin-inline: auto;
    }
  }
@media (max-width: 932px) and (orientation: landscape) {
    .\\!content {
    padding-bottom: 0px;
  }
     {
    position: relative;
    padding-left: 0px;
    padding-right: 0px;
  }
    .content {
    padding-bottom: 0px;
  }
    .nextButton {
    position: relative;
    padding-left: 0px;
    padding-right: 0px;
  }
  }
@media (max-width: 420px) {
    .step-indicator {
    margin-left: 0.125rem !important;
    margin-right: 0.125rem !important;
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  }
@supports not (aspect-ratio: 16 / 9) {
    .aspect-video::before {
      float: left;
      padding-top: 56.25%;
      content: '';
    }
    .aspect-video::after {
      display: block;
      content: '';
      clear: both;
    }
  }
/* Hide number input arrows */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
  }
/* Hide input number for the admin pin code */
input[type='number'].adminPinCode {
    -webkit-text-security: disc;
  }

  .no-transition .key-modal-transition--slide-up {
  animation: none !important;
  transition-property: none !important;
  transition-delay: 0s !important;
  transition-duration: 0s !important;
}
.key-modal-transition--slide-up {
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 100%;
  height: auto;
  opacity: 0;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 500ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.key-modal-transition--slide-up-enter {
  bottom: 0px;
  height: auto;
  opacity: 1;
    top: 450px;
    min-height: calc(100vh - 450px);
}

  .no-transition .admin-content-transition--fade-out {
  animation: none !important;
  transition-property: none !important;
  transition-delay: 0s !important;
  transition-duration: 0s !important;
}
.admin-content-transition--fade-out {
  opacity: 1;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 500ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.admin-content-transition--fade-out-leave {
  opacity: 0;
}
.hide-play-button .play-button {
  display: none;
}
@keyframes vertical-pulse {
    0%,
    100% {
      opacity: 0;
    }
    20%,
    80% {
      opacity: 0.5;
    }
    40%,
    60% {
      opacity: 1;
    }
  }
.\\!text-shadow-lg{
    text-shadow: 0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1), 0px 4px 8px rgb(0 0 0 / 0.1) !important;
  }
.pointer-events-none {
  pointer-events: none;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.\\!top-4 {
  top: 1rem !important;
}
.-left-3 {
  left: -0.75rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-3 {
  top: -0.75rem;
}
.-top-5 {
  top: -1.25rem;
}
.-top-btn-scroll {
  top: calc(var(--spacing-scroll-button) * -1);
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1\\.5 {
  bottom: 0.375rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-1\\/3 {
  left: 33.333333%;
}
.left-\\[16\\%\\] {
  left: 16%;
}
.left-\\[50vw\\] {
  left: 50vw;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-8 {
  right: 2rem;
}
.right-\\[16\\%\\] {
  right: 16%;
}
.right-auto {
  right: auto;
}
.right-basket-items-right {
  right: var(--spacing-basket-items-right);
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-12 {
  top: 3rem;
}
.top-20 {
  top: 5rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-basket-items-top {
  top: var(--spacing-basket-items-top);
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-60 {
  z-index: 60;
}
.z-max {
  z-index: 100;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.\\!m-2 {
  margin: 0.5rem !important;
}
.\\!m-auto {
  margin: auto !important;
}
.m-0 {
  margin: 0px;
}
.m-1 {
  margin: 0.25rem;
}
.m-2 {
  margin: 0.5rem;
}
.m-auto {
  margin: auto;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-2xs {
  margin-left: var(--spacing-2xs);
  margin-right: var(--spacing-2xs);
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-12 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-16 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-2xs {
  margin-top: var(--spacing-2xs);
  margin-bottom: var(--spacing-2xs);
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-l {
  margin-top: var(--spacing-l);
  margin-bottom: var(--spacing-l);
}
.my-s {
  margin-top: var(--spacing-s);
  margin-bottom: var(--spacing-s);
}
.my-xs {
  margin-top: var(--spacing-xs);
  margin-bottom: var(--spacing-xs);
}
.\\!mb-0 {
  margin-bottom: 0px !important;
}
.\\!mb-\\[30px\\] {
  margin-bottom: 30px !important;
}
.\\!mb-s {
  margin-bottom: var(--spacing-s) !important;
}
.\\!ml-0 {
  margin-left: 0px !important;
}
.\\!mr-0 {
  margin-right: 0px !important;
}
.\\!mr-1 {
  margin-right: 0.25rem !important;
}
.\\!mt-1 {
  margin-top: 0.25rem !important;
}
.\\!mt-2\\.5 {
  margin-top: 0.625rem !important;
}
.\\!mt-8 {
  margin-top: 2rem !important;
}
.-mb-0\\.5 {
  margin-bottom: -0.125rem;
}
.-mb-2 {
  margin-bottom: -0.5rem;
}
.-mr-1\\.5 {
  margin-right: -0.375rem;
}
.-mr-4 {
  margin-right: -1rem;
}
.-mt-1\\.5 {
  margin-top: -0.375rem;
}
.-mt-4 {
  margin-top: -1rem;
}
.-mt-5 {
  margin-top: -1.25rem;
}
.-mt-l {
  margin-top: calc(var(--spacing-l) * -1);
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-14 {
  margin-bottom: 3.5rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-24 {
  margin-bottom: 6rem;
}
.mb-28 {
  margin-bottom: 7rem;
}
.mb-2xs {
  margin-bottom: var(--spacing-2xs);
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-36 {
  margin-bottom: 9rem;
}
.mb-3xs {
  margin-bottom: var(--spacing-3xs);
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-l {
  margin-bottom: var(--spacing-l);
}
.mb-s {
  margin-bottom: var(--spacing-s);
}
.mb-xs {
  margin-bottom: var(--spacing-xs);
}
.ml-0 {
  margin-left: 0px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-7 {
  margin-left: 1.75rem;
}
.ml-auto {
  margin-left: auto;
}
.ml-xs {
  margin-left: var(--spacing-xs);
}
.mr-0 {
  margin-right: 0px;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-2xs {
  margin-right: var(--spacing-2xs);
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mr-6 {
  margin-right: 1.5rem;
}
.mr-7 {
  margin-right: 1.75rem;
}
.mr-8 {
  margin-right: 2rem;
}
.mr-s {
  margin-right: var(--spacing-s);
}
.mr-xs {
  margin-right: var(--spacing-xs);
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-2xs {
  margin-top: var(--spacing-2xs);
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mt-3xs {
  margin-top: var(--spacing-3xs);
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-96 {
  margin-top: 24rem;
}
.mt-l {
  margin-top: var(--spacing-l);
}
.mt-s {
  margin-top: var(--spacing-s);
}
.mt-xs {
  margin-top: var(--spacing-xs);
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-4\\/3 {
  aspect-ratio: 4 / 3;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.\\!size-1\\/2 {
  width: 50% !important;
  height: 50% !important;
}
.\\!size-full {
  width: 100% !important;
  height: 100% !important;
}
.size-0 {
  width: 0px;
  height: 0px;
}
.size-10 {
  width: 2.5rem;
  height: 2.5rem;
}
.size-12 {
  width: 3rem;
  height: 3rem;
}
.size-14 {
  width: 3.5rem;
  height: 3.5rem;
}
.size-16 {
  width: 4rem;
  height: 4rem;
}
.size-2\\/5 {
  width: 40%;
  height: 40%;
}
.size-20 {
  width: 5rem;
  height: 5rem;
}
.size-24 {
  width: 6rem;
  height: 6rem;
}
.size-28 {
  width: 7rem;
  height: 7rem;
}
.size-2xl {
  width: var(--spacing-2xl);
  height: var(--spacing-2xl);
}
.size-3 {
  width: 0.75rem;
  height: 0.75rem;
}
.size-3\\.5 {
  width: 0.875rem;
  height: 0.875rem;
}
.size-36 {
  width: 9rem;
  height: 9rem;
}
.size-40 {
  width: 10rem;
  height: 10rem;
}
.size-48 {
  width: 12rem;
  height: 12rem;
}
.size-5 {
  width: 1.25rem;
  height: 1.25rem;
}
.size-52 {
  width: 13rem;
  height: 13rem;
}
.size-6 {
  width: 1.5rem;
  height: 1.5rem;
}
.size-64 {
  width: 16rem;
  height: 16rem;
}
.size-7 {
  width: 1.75rem;
  height: 1.75rem;
}
.size-8 {
  width: 2rem;
  height: 2rem;
}
.size-80 {
  width: 20rem;
  height: 20rem;
}
.size-btn-primary-icon-home {
  width: var(--size-btn-primary-icon-home);
  height: var(--size-btn-primary-icon-home);
}
.size-full {
  width: 100%;
  height: 100%;
}
.size-l {
  width: var(--spacing-l);
  height: var(--spacing-l);
}
.size-s {
  width: var(--spacing-s);
  height: var(--spacing-s);
}
.\\!h-1\\/2 {
  height: 50% !important;
}
.\\!h-28 {
  height: 7rem !important;
}
.\\!h-6 {
  height: 1.5rem !important;
}
.\\!h-auto {
  height: auto !important;
}
.\\!h-fit {
  height: -moz-fit-content !important;
  height: fit-content !important;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\/2 {
  height: 50%;
}
.h-10 {
  height: 2.5rem;
}
.h-102 {
  height: 28rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-52 {
  height: 13rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-80 {
  height: 20rem;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[320px\\] {
  height: 320px;
}
.h-\\[50svh\\] {
  height: 50svh;
}
.h-\\[586px\\] {
  height: 586px;
}
.h-auto {
  height: auto;
}
.h-btn {
  height: var(--size-btn-height);
}
.h-dvh {
  height: 100dvh;
}
.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-max {
  height: -moz-max-content;
  height: max-content;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.h-svh {
  height: 100svh;
}
.max-h-1\\/2-screen {
  max-height: 50vh;
}
.max-h-28 {
  max-height: 7rem;
}
.max-h-44 {
  max-height: 11rem;
}
.max-h-52 {
  max-height: 13rem;
}
.max-h-\\[160px\\] {
  max-height: 160px;
}
.max-h-\\[50vh\\] {
  max-height: 50vh;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[95vh\\] {
  max-height: 95vh;
}
.max-h-full {
  max-height: 100%;
}
.max-h-svh {
  max-height: 100svh;
}
.min-h-2 {
  min-height: 0.5rem;
}
.min-h-32 {
  min-height: 8rem;
}
.min-h-6 {
  min-height: 1.5rem;
}
.min-h-8 {
  min-height: 2rem;
}
.min-h-80 {
  min-height: 20rem;
}
.min-h-9 {
  min-height: 2.25rem;
}
.min-h-\\[2px\\] {
  min-height: 2px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[56px\\] {
  min-height: 56px;
}
.min-h-\\[68px\\] {
  min-height: 68px;
}
.min-h-\\[calc\\(100svh-104px\\)\\] {
  min-height: calc(100svh - 104px);
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-1\\/2 {
  width: 50% !important;
}
.\\!w-28 {
  width: 7rem !important;
}
.\\!w-6 {
  width: 1.5rem !important;
}
.\\!w-\\[20px\\] {
  width: 20px !important;
}
.\\!w-auto {
  width: auto !important;
}
.\\!w-fit {
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-1\\/12 {
  width: 8.333333%;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/2-screen {
  width: 50vh;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/6 {
  width: 16.666667%;
}
.w-10\\/12 {
  width: 83.333333%;
}
.w-118 {
  width: 29.5rem;
}
.w-12 {
  width: 3rem;
}
.w-16 {
  width: 4rem;
}
.w-176 {
  width: 44rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-2\\/5 {
  width: 40%;
}
.w-20 {
  width: 5rem;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\/12 {
  width: 41.666667%;
}
.w-5\\/6 {
  width: 83.333333%;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-\\[385px\\] {
  width: 385px;
}
.w-\\[586px\\] {
  width: 586px;
}
.w-\\[82px\\] {
  width: 82px;
}
.w-\\[calc\\(100\\%-6rem\\)\\] {
  width: calc(100% - 6rem);
}
.w-\\[calc\\(25\\%-0\\.5rem\\)\\] {
  width: calc(25% - 0.5rem);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-screen {
  width: 100vw;
}
.w-svw {
  width: 100svw;
}
.\\!min-w-96 {
  min-width: 24rem !important;
}
.\\!min-w-\\[50px\\] {
  min-width: 50px !important;
}
.min-w-18 {
  min-width: 18rem;
}
.min-w-2 {
  min-width: 0.5rem;
}
.min-w-32 {
  min-width: 8rem;
}
.min-w-4 {
  min-width: 1rem;
}
.min-w-\\[10rem\\] {
  min-width: 10rem;
}
.min-w-refused {
  min-width: var(--size-refused-min-width);
}
.\\!max-w-\\[100px\\] {
  max-width: 100px !important;
}
.\\!max-w-none {
  max-width: none !important;
}
.max-w-1\\/2-screen {
  max-width: 50vh;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-40 {
  max-width: 10rem;
}
.max-w-48 {
  max-width: 12rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[85\\%\\] {
  max-width: 85%;
}
.max-w-content {
  max-width: var(--content-max-width);
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-min {
  max-width: -moz-min-content;
  max-width: min-content;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-auto {
  flex: 1 1 auto;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.\\!flex-grow-0 {
  flex-grow: 0 !important;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.origin-top-left {
  transform-origin: top left;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-4 {
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-30 {
  --tw-rotate: -30deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-500 {
  --tw-scale-x: 5;
  --tw-scale-y: 5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounceOnceAnimation {

  0%, 100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }
}
.animate-bounceOnce {
  animation: bounceOnceAnimation 0.3s ease-out 1.5s forwards;
}
@keyframes fleetback-ping {

  0%, 100% {
    transform: scale(.6);
  }

  50% {
    transform: scale(.9);
  }
}
.animate-fleetback-ping {
  animation: fleetback-ping 2.2s ease infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes shadow-leave {

  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
.animate-shadow-leave {
  animation: shadow-leave 0.6s ease-out forwards;
}
@keyframes shadow-leave {

  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
.animate-shorter-shadow-leave {
  animation: shadow-leave 0.3s ease-out 0.3s forwards;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
@keyframes translation-in {

  0% {
    transform: translateY(180px);
    opacity: 0;
  }

  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
.animate-translation-in {
  animation: translation-in 0.6s ease-out 0.1s forwards;
}
.\\!cursor-not-allowed {
  cursor: not-allowed !important;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.grid-flow-row {
  grid-auto-flow: row;
}
.auto-rows-auto {
  grid-auto-rows: auto;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.place-items-center {
  place-items: center;
}
.content-center {
  align-content: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-items-center {
  justify-items: center;
}
.gap-0 {
  gap: 0px;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-14 {
  gap: 3.5rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-2xs {
  gap: var(--spacing-2xs);
}
.gap-3 {
  gap: 0.75rem;
}
.gap-32 {
  gap: 8rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-52 {
  gap: 13rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-l {
  gap: var(--spacing-l);
}
.gap-xs {
  gap: var(--spacing-xs);
}
.gap-x-4 {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.gap-x-5 {
  -moz-column-gap: 1.25rem;
       column-gap: 1.25rem;
}
.gap-x-8 {
  -moz-column-gap: 2rem;
       column-gap: 2rem;
}
.gap-y-12 {
  row-gap: 3rem;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.\\!overflow-visible {
  overflow: visible !important;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.overflow-ellipsis {
  text-overflow: ellipsis;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre {
  white-space: pre;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.text-nowrap {
  text-wrap: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.\\!rounded-3xl {
  border-radius: 1.5rem !important;
}
.\\!rounded-none {
  border-radius: 0px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-5xl {
  border-radius: 100px;
}
.rounded-admin-card {
  border-radius: var(--rounded-admin-card);
}
.rounded-button {
  border-radius: var(--rounded-button);
}
.rounded-button-list {
  border-radius: var(--rounded-button-list);
}
.rounded-card {
  border-radius: var(--rounded-card);
}
.rounded-chat {
  border-radius: var(--rounded-chat);
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-input {
  border-radius: var(--rounded-input);
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-modal {
  border-radius: var(--rounded-modal);
}
.rounded-select {
  border-radius: var(--rounded-select);
}
.rounded-t-modal {
  border-radius: var(--rounded-t-modal);
}
.rounded-xl {
  border-radius: 0.75rem;
}
.\\!rounded-l-none {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.\\!rounded-r-none {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
.rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-card {
  border-top-left-radius: var(--rounded-card);
  border-top-right-radius: var(--rounded-card);
}
.rounded-t-modal {
  border-top-left-radius: var(--rounded-modal);
  border-top-right-radius: var(--rounded-modal);
}
.rounded-t-panel-opening {
  border-top-left-radius: var(--rounded-t-panel-opening);
  border-top-right-radius: var(--rounded-t-panel-opening);
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-40 {
  border-width: 40px;;
}
.border-btn-primary-size {
  border-width: var(--border-btn-primary-size);
}
.border-btn-secondary-size {
  border-width: var(--border-btn-secondary-size);
}
.border-card-radio-size {
  border-width: var(--border-card-radio-size);
}
.border-radio-size {
  border-width: var(--border-radio-size);
}
.border-x-\\[94px\\] {
  border-left-width: 94px;
  border-right-width: 94px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-60 {
  border-bottom-width: 60px;;
}
.border-b-\\[37px\\] {
  border-bottom-width: 37px;
}
.border-r-60 {
  border-right-width: 60px;;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.\\!border-none {
  border-style: none !important;
}
.border-none {
  border-style: none;
}
.\\!border-card-radio-active-border {
  border-color: var(--color-card-radio-active-border) !important;
}
.\\!border-danger-low {
  border-color: rgb(var(--color-danger-low)) !important;
}
.\\!border-radio-secondary-active-border {
  border-color: var(--color-radio-secondary-active-border) !important;
}
.border-\\[\\#CED6DD\\] {
  --tw-border-opacity: 1;
  border-color: rgb(206 214 221 / var(--tw-border-opacity, 1));
}
.border-border-default {
  border-color: var(--color-border-default);
}
.border-border-low {
  border-color: var(--color-border-low);
}
.border-brand-high {
  border-color: var(--color-brand-high);
}
.border-btn-primary-border {
  border-color: var(--color-btn-primary-border);
}
.border-btn-secondary-border {
  border-color: var(--color-btn-secondary-border);
}
.border-card-radio-border {
  border-color: var(--color-card-radio-border);
}
.border-danger-default {
  border-color: rgb(var(--color-danger-default));
}
.border-danger-low {
  border-color: rgb(var(--color-danger-low));
}
.border-default {
  border-color: var(--color-default);
}
.border-header-border {
  border-color: var(--color-header-border);
}
.border-neutral-100 {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity, 1));
}
.border-radio-border {
  border-color: var(--color-radio-border);
}
.border-radio-secondary-border {
  border-color: var(--color-radio-secondary-border);
}
.border-transparent {
  border-color: transparent;
}
.border-warning-default {
  border-color: rgb(var(--color-warning-default));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-x-transparent {
  border-left-color: transparent;
  border-right-color: transparent;
}
.border-b-white {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-r-danger-default {
  border-right-color: rgb(var(--color-danger-default));
}
.border-r-success-default {
  border-right-color: rgb(var(--color-success-default));
}
.border-r-warning-default {
  border-right-color: rgb(var(--color-warning-default));
}
.\\!bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7) !important;
}
.\\!bg-card-bg {
  background-color: var(--color-card-bg) !important;
}
.\\!bg-card-radio-active-bg {
  background-color: var(--color-card-radio-active-bg) !important;
}
.\\!bg-danger-default {
  background-color: rgb(var(--color-danger-default)) !important;
}
.\\!bg-danger-lowest {
  background-color: rgb(var(--color-danger-lowest)) !important;
}
.\\!bg-gray-300 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-input-bg {
  background-color: var(--color-input-bg) !important;
}
.\\!bg-popup-bg {
  background-color: var(--color-popup-bg) !important;
}
.\\!bg-slot-number {
  background-color: var(--color-slot-number) !important;
}
.\\!bg-success-lowest {
  background-color: rgb(var(--color-success-lowest)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7) !important;
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-border-default {
  background-color: var(--color-border-default);
}
.bg-brand-50 {
  background-color: var(--color-brand-50);
}
.bg-brand-default {
  background-color: var(--color-brand-default);
}
.bg-brand-high {
  background-color: var(--color-brand-high);
}
.bg-btn-primary-bg {
  background-color: var(--color-btn-primary-bg);
}
.bg-btn-primary-icon-bg {
  background-color: var(--color-btn-primary-icon-bg);
}
.bg-btn-secondary-bg {
  background-color: var(--color-btn-secondary-bg);
}
.bg-btn-tertiary-bg {
  background-color: var(--color-btn-tertiary-bg);
}
.bg-card-bg {
  background-color: var(--color-card-bg);
}
.bg-card-radio-bg {
  background-color: var(--color-card-radio-bg);
}
.bg-danger-default {
  background-color: rgb(var(--color-danger-default));
}
.bg-danger-default\\/20 {
  background-color: rgb(var(--color-danger-default) / 0.2);
}
.bg-danger-lowest {
  background-color: rgb(var(--color-danger-lowest));
}
.bg-danger-lowest\\/75 {
  background-color: rgb(var(--color-danger-lowest) / 0.75);
}
.bg-default {
  background-color: var(--color-default);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-900\\/25 {
  background-color: rgb(17 24 39 / 0.25);
}
.bg-input-bg {
  background-color: var(--color-input-bg);
}
.bg-input-border {
  background-color: var(--color-input-border);
}
.bg-input-multiple-tag-bg {
  background-color: var(--color-input-multiple-tag-bg);
}
.bg-logo-home {
  background-color: var(--color-logo-home);
}
.bg-neutral-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.bg-neutral-blue-100 {
  background-color: var(--color-neutral-blue-100);
}
.bg-overlay {
  background-color: var(--color-overlay);
}
.bg-popup-bg {
  background-color: var(--color-popup-bg);
}
.bg-radio-secondary-active-bg {
  background-color: var(--color-radio-secondary-active-bg);
}
.bg-success-default {
  background-color: rgb(var(--color-success-default));
}
.bg-success-default\\/20 {
  background-color: rgb(var(--color-success-default) / 0.2);
}
.bg-success-lowest {
  background-color: rgb(var(--color-success-lowest));
}
.bg-transparent {
  background-color: transparent;
}
.bg-warning-default {
  background-color: rgb(var(--color-warning-default));
}
.bg-warning-lowest {
  background-color: rgb(var(--color-warning-lowest));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/40 {
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-opacity-25 {
  --tw-bg-opacity: 0.25;
}
.bg-opacity-95 {
  --tw-bg-opacity: 0.95;
}
.bg-gradient-radial-white {
  background-image: radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.18) 100%);
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-home {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.bg-vehicleCheck {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.from-emergency-gradient-from {
  --tw-gradient-from: rgb(var(--color-emergency-gradient-from)) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--color-emergency-gradient-from) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900\\/40 {
  --tw-gradient-from: rgb(15 23 42 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-emergency-gradient-to {
  --tw-gradient-to: rgb(var(--color-emergency-gradient-to)) var(--tw-gradient-to-position);
}
.bg-120 {
  background-size: 120%;
}
.bg-contain {
  background-size: contain;
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.bg-origin-padding {
  background-origin: padding-box;
}
.fill-white {
  fill: #fff;
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.\\!p-0 {
  padding: 0px !important;
}
.\\!p-1 {
  padding: 0.25rem !important;
}
.\\!p-1\\.5 {
  padding: 0.375rem !important;
}
.\\!p-2 {
  padding: 0.5rem !important;
}
.\\!p-3 {
  padding: 0.75rem !important;
}
.\\!p-3xs {
  padding: var(--spacing-3xs) !important;
}
.\\!p-4 {
  padding: 1rem !important;
}
.\\!p-6 {
  padding: 1.5rem !important;
}
.\\!p-7 {
  padding: 1.75rem !important;
}
.\\!p-s {
  padding: var(--spacing-s) !important;
}
.\\!p-xs {
  padding: var(--spacing-xs) !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-14 {
  padding: 3.5rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2xs {
  padding: var(--spacing-2xs);
}
.p-3 {
  padding: 0.75rem;
}
.p-32 {
  padding: 8rem;
}
.p-3xs {
  padding: var(--spacing-3xs);
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.p-8 {
  padding: 2rem;
}
.p-l {
  padding: var(--spacing-l);
}
.p-s {
  padding: var(--spacing-s);
}
.p-select-spacing {
  padding: var(--p-select-spacing);
}
.p-xs {
  padding: var(--spacing-xs);
}
.\\!px-8 {
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.\\!py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.\\!py-10 {
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}
.\\!py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.\\!py-5 {
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2xs {
  padding-left: var(--spacing-2xs);
  padding-right: var(--spacing-2xs);
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3xs {
  padding-left: var(--spacing-3xs);
  padding-right: var(--spacing-3xs);
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-4xl {
  padding-left: var(--spacing-4xl);
  padding-right: var(--spacing-4xl);
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[20\\%\\] {
  padding-left: 20%;
  padding-right: 20%;
}
.px-l {
  padding-left: var(--spacing-l);
  padding-right: var(--spacing-l);
}
.px-s {
  padding-left: var(--spacing-s);
  padding-right: var(--spacing-s);
}
.px-xs {
  padding-left: var(--spacing-xs);
  padding-right: var(--spacing-xs);
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.\\!pb-0 {
  padding-bottom: 0px !important;
}
.\\!pb-2 {
  padding-bottom: 0.5rem !important;
}
.\\!pl-12 {
  padding-left: 3rem !important;
}
.\\!pl-s {
  padding-left: var(--spacing-s) !important;
}
.\\!pt-120 {
  padding-top: 30rem !important;
}
.\\!pt-24 {
  padding-top: 6rem !important;
}
.\\!pt-44 {
  padding-top: 11rem !important;
}
.\\!pt-8 {
  padding-top: 2rem !important;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-2xs {
  padding-bottom: var(--spacing-2xs);
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-xs {
  padding-bottom: var(--spacing-xs);
}
.pl-0 {
  padding-left: 0px;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-\\[26px\\] {
  padding-left: 26px;
}
.pl-xs {
  padding-left: var(--spacing-xs);
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-20 {
  padding-right: 5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-60 {
  padding-top: 15rem;
}
.pt-7 {
  padding-top: 1.75rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-m {
  padding-top: var(--spacing-m);
}
.pt-s {
  padding-top: var(--spacing-s);
}
.pt-xs {
  padding-top: var(--spacing-xs);
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
.align-middle {
  vertical-align: middle;
}
.\\!text-2xl {
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.\\!text-4xl {
  font-size: 2.25rem !important;
  line-height: 2.5rem !important;
}
.\\!text-5xl {
  font-size: 3rem !important;
  line-height: 4.5rem !important;
}
.\\!text-7xl {
  font-size: 4.5rem !important;
  line-height: 1 !important;
}
.\\!text-base {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.\\!text-button-s {
  font-size: var(--text-button-s) !important;
}
.\\!text-button-xs {
  font-size: var(--text-button-xs) !important;
}
.\\!text-lg {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.\\!text-s {
  font-size: var(--text-s) !important;
}
.\\!text-xl {
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.\\!text-xs {
  font-size: var(--text-xs) !important;
}
.\\!text-xxs {
  font-size: var(--text-xxs) !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.750rem;
  line-height: 2.625rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 4.5rem;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-9xl {
  font-size: 8rem;
  line-height: 1;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-button-s {
  font-size: var(--text-button-s);
}
.text-button-xs {
  font-size: var(--text-button-xs);
}
.text-icon {
  font-size: var(--text-icon);
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-s {
  font-size: var(--text-s);
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: var(--text-xs);
}
.text-xxs {
  font-size: var(--text-xxs);
}
.text-xxxs {
  font-size: var(--text-xxxs);
}
.font-bold {
  font-weight: 700;
}
.font-btn-weight {
  font-weight: var(--font-btn-weight);
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.\\!leading-10 {
  line-height: 2.5rem !important;
}
.\\!leading-6 {
  line-height: 1.5rem !important;
}
.\\!leading-8 {
  line-height: 2rem !important;
}
.\\!leading-none {
  line-height: 1 !important;
}
.\\!leading-normal {
  line-height: 1.5 !important;
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-l {
  line-height: var(--spacing-l);
}
.leading-m {
  line-height: var(--spacing-m);
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-xl {
  line-height: var(--spacing-xl);
}
.tracking-\\[10px\\] {
  letter-spacing: 10px;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-card-radio-active-description {
  color: var(--color-card-radio-active-description) !important;
}
.\\!text-card-radio-active-title {
  color: var(--color-card-radio-active-title) !important;
}
.\\!text-danger-default {
  color: rgb(var(--color-danger-default)) !important;
}
.\\!text-default {
  color: var(--color-default) !important;
}
.\\!text-inverse {
  color: var(--color-inverse) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-white\\/30 {
  color: rgb(255 255 255 / 0.3) !important;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-border-default {
  color: var(--color-border-default);
}
.text-brand-default {
  color: var(--color-brand-default);
}
.text-brand-high {
  color: var(--color-brand-high);
}
.text-btn-home-primary-icon-text {
  color: var(--color-btn-home-primary-icon-text);
}
.text-btn-home-primary-text {
  color: var(--color-btn-home-primary-text);
}
.text-btn-primary-text {
  color: var(--color-btn-primary-text);
}
.text-btn-secondary-text {
  color: var(--color-btn-secondary-text);
}
.text-btn-tertiary-text {
  color: var(--color-btn-tertiary-text);
}
.text-card-radio-description {
  color: var(--color-card-radio-description);
}
.text-card-radio-title {
  color: var(--color-card-radio-title);
}
.text-danger-default {
  color: rgb(var(--color-danger-default));
}
.text-danger-high {
  color: rgb(var(--color-danger-high));
}
.text-default {
  color: var(--color-default);
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-input-bg {
  color: var(--color-input-bg);
}
.text-input-multiple-tag-label {
  color: var(--color-input-multiple-tag-label);
}
.text-inverse {
  color: var(--color-inverse);
}
.text-low {
  color: var(--color-low);
}
.text-lowest {
  color: var(--color-lowest);
}
.text-neutral-600 {
  --tw-text-opacity: 1;
  color: rgb(82 82 82 / var(--tw-text-opacity, 1));
}
.text-neutral-900 {
  --tw-text-opacity: 1;
  color: rgb(23 23 23 / var(--tw-text-opacity, 1));
}
.text-radio-active-dot {
  color: var(--color-radio-active-dot);
}
.text-radio-secondary-active-dot {
  color: var(--color-radio-secondary-active-dot);
}
.text-radio-secondary-active-text {
  color: var(--color-radio-secondary-active-text);
}
.text-success-default {
  color: rgb(var(--color-success-default));
}
.text-warning-default {
  color: rgb(var(--color-warning-default));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.placeholder-neutral-600::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(82 82 82 / var(--tw-placeholder-opacity, 1));
}
.placeholder-neutral-600::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(82 82 82 / var(--tw-placeholder-opacity, 1));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_3px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.07\\)\\] {
  --tw-shadow: 0 4px 3px 0 rgba(0,0,0,0.07);
  --tw-shadow-colored: 0 4px 3px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\!ring-8 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-8 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[36px\\] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(36px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity, 1));
}
.ring-danger-default {
  --tw-ring-color: rgb(var(--color-danger-default));
}
.ring-select-border {
  --tw-ring-color: var(--ring-select-border);
}
.ring-success-default {
  --tw-ring-color: rgb(var(--color-success-default));
}
.ring-opacity-5 {
  --tw-ring-opacity: 0.05;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-2xl {
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06)) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-none {
  --tw-drop-shadow: drop-shadow(0 0 #0000);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-watermark {
  --tw-drop-shadow: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.25));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-xl {
  --tw-drop-shadow: drop-shadow(0 20px 13px rgb(0 0 0 / 0.03)) drop-shadow(0 8px 5px rgb(0 0 0 / 0.08));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-none {
  transition-property: none;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-linear {
  transition-timing-function: linear;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-transform {
  will-change: transform;
}
.\\[x\\:string\\] {
  x: string;
}
/* Noto Sans */
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Thin.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Thin.woff") format('woff');
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-ThinItalic.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-ThinItalic.woff") format('woff');
  font-weight: 100;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-ExtraLight.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-ExtraLight.woff") format('woff');
  font-weight: 200;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-ExtraLightItalic.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-ExtraLightItalic.woff") format('woff');
  font-weight: 200;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Light.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Light.woff") format('woff');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-LightItalic.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-LightItalic.woff") format('woff');
  font-weight: 300;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Regular.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Regular.woff") format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Italic.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Italic.woff") format('woff');
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Medium.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Medium.woff") format('woff');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-MediumItalic.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-MediumItalic.woff") format('woff');
  font-weight: 500;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-SemiBoldItalic.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-SemiBoldItalic.woff") format('woff');
  font-weight: 600;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-SemiBold.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-SemiBold.woff") format('woff');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Bold.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Bold.woff") format('woff');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-BoldItalic.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-BoldItalic.woff") format('woff');
  font-weight: 700;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-ExtraBold.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-ExtraBold.woff") format('woff');
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-ExtraBoldItalic.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-ExtraBoldItalic.woff") format('woff');
  font-weight: 800;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Black.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-Black.woff") format('woff');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-BlackItalic.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSans-BlackItalic.woff") format('woff');
  font-weight: 900;
  font-style: italic;
  font-display: swap;
}
/* Noto Sans JP */
@font-face {
  font-family: 'Noto Sans JP';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-Thin.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-Thin.woff") format('woff');
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans JP';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-ExtraLight.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-ExtraLight.woff") format('woff');
  font-weight: 200;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans JP';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-Light.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-Light.woff") format('woff');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans JP';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-Regular.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-Regular.woff") format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans JP';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-Medium.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-Medium.woff") format('woff');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Noto Sans JP';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-SemiBold.woff2") format('woff2'),
      url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-SemiBold.woff") format('woff');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
    font-family: 'Noto Sans JP';
    src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-Bold.woff2") format('woff2'),
        url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-Bold.woff") format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}
@font-face {
    font-family: 'Noto Sans JP';
    src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-ExtraBold.woff2") format('woff2'),
        url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-ExtraBold.woff") format('woff');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
}
@font-face {
    font-family: 'Noto Sans JP';
    src: url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-Black.woff2") format('woff2'),
        url("https://assets.test.fleetback.com/public/themes/default/fonts/NotoSans/NotoSansJP-Black.woff") format('woff');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
}
/* Oooh Baby */
@font-face {
  font-family: 'Ooooh Baby';
  src: url("https://assets.test.fleetback.com/public/themes/default/fonts/OooohBaby/OoohBaby.ttf") format('TrueType');
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
/* NotoSansKR */
@font-face {
    font-family: 'NotoSansKR';
    font-display: swap;
    font-weight: 900;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_KR/NotoSansKR-Black.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansKR';
    font-display: swap;
    font-weight: 700;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_KR/NotoSansKR-Bold.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansKR';
    font-display: swap;
    font-weight: 800;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_KR/NotoSansKR-ExtraBold.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansKR';
    font-display: swap;
    font-weight: 200;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_KR/NotoSansKR-ExtraLight.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansKR';
    font-display: swap;
    font-weight: 300;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_KR/NotoSansKR-Light.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansKR';
    font-display: swap;
    font-weight: 500;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_KR/NotoSansKR-Medium.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansKR';
    font-display: swap;
    font-weight: 400;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_KR/NotoSansKR-Regular.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansKR';
    font-display: swap;
    font-weight: 600;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_KR/NotoSansKR-SemiBold.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansKR';
    font-display: swap;
    font-weight: 100;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_KR/NotoSansKR-Thin.ttf") format('truetype');
}
/* NotoSansTC */
@font-face {
    font-family: 'NotoSansTC';
    font-display: swap;
    font-weight: 900;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_TC/NotoSansTC-Black.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansTC';
    font-display: swap;
    font-weight: 700;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_TC/NotoSansTC-Bold.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansTC';
    font-display: swap;
    font-weight: 800;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_TC/NotoSansTC-ExtraBold.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansTC';
    font-display: swap;
    font-weight: 200;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_TC/NotoSansTC-ExtraLight.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansTC';
    font-display: swap;
    font-weight: 300;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_TC/NotoSansTC-Light.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansTC';
    font-display: swap;
    font-weight: 500;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_TC/NotoSansTC-Medium.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansTC';
    font-display: swap;
    font-weight: 400;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_TC/NotoSansTC-Regular.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansTC';
    font-display: swap;
    font-weight: 600;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_TC/NotoSansTC-SemiBold.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansTC';
    font-display: swap;
    font-weight: 100;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_TC/NotoSansTC-Thin.ttf") format('truetype');
}
/*NotoSansHK */
@font-face {
    font-family: 'NotoSansHK';
    font-display: swap;
    font-weight: 900;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_HK/NotoSansHK-Black.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansHK';
    font-display: swap;
    font-weight: 700;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_HK/NotoSansHK-Bold.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansHK';
    font-display: swap;
    font-weight: 800;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_HK/NotoSansHK-ExtraBold.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansHK';
    font-display: swap;
    font-weight: 200;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_HK/NotoSansHK-ExtraLight.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansHK';
    font-display: swap;
    font-weight: 300;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_HK/NotoSansHK-Light.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansHK';
    font-display: swap;
    font-weight: 500;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_HK/NotoSansHK-Medium.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansHK';
    font-display: swap;
    font-weight: 400;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_HK/NotoSansHK-Regular.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansHK';
    font-display: swap;
    font-weight: 600;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_HK/NotoSansHK-SemiBold.ttf") format('truetype');
}
@font-face {
    font-family: 'NotoSansHK';
    font-display: swap;
    font-weight: 100;
    font-style: normal;
    src: url("https://assets.test.fleetback.com/public/themes/default/themes/default/fonts/Noto_Sans_HK/NotoSansHK-Thin.ttf") format('truetype');
}
@font-face {
    font-family: 'PorscheNext';
    src:    local('PorscheNext'),
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-Regular.eot") format('embedded-opentype'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-Regular.woff2") format('woff2'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-Regular.woff") format('woff'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextTT/PorscheNextTT-Regular.ttf") format('truetype'); /* Safari, Android, iOS */
}
@font-face {
    font-family: 'PorscheNext';
    font-style: italic;
    src:    local('PorscheNext'),
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-RegularItalic.eot") format('embedded-opentype'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-RegularItalic.woff2") format('woff2'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-RegularItalic.woff") format('woff'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextTT/PorscheNextTT-RegularItalic.ttf") format('truetype'); /* Safari, Android, iOS */
}
@font-face {
    font-family: 'PorscheNext';
    font-weight: 500;
    src:    local('PorscheNext'),
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-SemiBold.eot") format('embedded-opentype'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-SemiBold.woff2") format('woff2'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-SemiBold.woff") format('woff'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextTT/PorscheNextTT-SemiBold.ttf") format('truetype'); /* Safari, Android, iOS */
}
@font-face {
    font-family: 'PorscheNext';
    font-weight: 500;
    font-style: italic;
    src:    local('PorscheNext'),
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-SemiBoldItalic.eot") format('embedded-opentype'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-SemiBoldItalic.woff2") format('woff2'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-SemiBoldItalic.woff") format('woff'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextTT/PorscheNextTT-SemiBoldItalic.ttf") format('truetype'); /* Safari, Android, iOS */
}
@font-face {
    font-family: 'PorscheNext';
    font-weight: 700;
    src:    local('PorscheNext'),
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-Bold.eot") format('embedded-opentype'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-Bold.woff2") format('woff2'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextWLa/PorscheNextWLa-Bold.woff") format('woff'), 
            url("https://assets.test.fleetback.com/public/themes/porsche/fonts/PorscheNextTT/PorscheNextTT-Bold.ttf") format('truetype'); /* Safari, Android, iOS */
}
@font-face {
    font-family: 'FordAntenna';
    src:    local('FordAntenna'),
            url("https://assets.test.fleetback.com/public/themes/ford/fonts/Ford-Antenna/Ford-Antenna-Regular.eot") format('embedded-opentype'), 
            url("https://assets.test.fleetback.com/public/themes/ford/fonts/Ford-Antenna/Ford-Antenna-Regular.woff2") format('woff2'), 
            url("https://assets.test.fleetback.com/public/themes/ford/fonts/Ford-Antenna/Ford-Antenna-Regular.woff") format('woff'), 
            url("https://assets.test.fleetback.com/public/themes/ford/fonts/Ford-Antenna/Ford-Antenna-Regular.ttf") format('truetype'); /* Safari, Android, iOS */
}
@font-face {
    font-family: 'FordAntenna';
    font-weight: 600;
    src:    local('FordAntenna'),
            url("https://assets.test.fleetback.com/public/themes/ford/fonts/Ford-Antenna/Ford-Antenna-Semibold.eot") format('embedded-opentype'), 
            url("https://assets.test.fleetback.com/public/themes/ford/fonts/Ford-Antenna/Ford-Antenna-Semibold.woff2") format('woff2'), 
            url("https://assets.test.fleetback.com/public/themes/ford/fonts/Ford-Antenna/Ford-Antenna-Semibold.woff") format('woff'), 
            url("https://assets.test.fleetback.com/public/themes/ford/fonts/Ford-Antenna/Ford-Antenna-Semibold.ttf") format('truetype'); /* Safari, Android, iOS */
}
@font-face {
    font-family: 'FordAntenna';
    font-weight: 700;
    src:    local('FordAntenna'),
            url("https://assets.test.fleetback.com/public/themes/ford/fonts/Ford-Antenna/Ford-Antenna-Bold.eot") format('embedded-opentype'), 
            url("https://assets.test.fleetback.com/public/themes/ford/fonts/Ford-Antenna/Ford-Antenna-Bold.woff2") format('woff2'), 
            url("https://assets.test.fleetback.com/public/themes/ford/fonts/Ford-Antenna/Ford-Antenna-Bold.woff") format('woff'), 
            url("https://assets.test.fleetback.com/public/themes/ford/fonts/Ford-Antenna/Ford-Antenna-Bold.ttf") format('truetype'); /* Safari, Android, iOS */
}
.loader {
  position: relative;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  display: block;
  width: 2rem;
  height: 2rem;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  box-shadow: -58px 0 #fff, 58px 0 #fff;
  animation: shadowPulse 2s linear infinite;
}
.loader.emergency {
    animation: emergencyShadowPulse 2s linear infinite;
  }
@keyframes shadowPulse {
  33% {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    box-shadow: -58px 0 var(--color-brand-high), 58px 0 #fff;
  }
  66% {
    background-color: var(--color-brand-high);
    box-shadow: -58px 0 #fff, 58px 0 #fff;
  }
  100% {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    box-shadow: -58px 0 #fff, 58px 0 var(--color-brand-high);
  }
}
@keyframes emergencyShadowPulse {
  33% {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    box-shadow: -58px 0 var(--color-danger-default), 58px 0 #fff;
  }
  66% {
    background-color: rgb(var(--color-danger-default));
    box-shadow: -58px 0 #fff, 58px 0 #fff;
  }
  100% {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    box-shadow: -58px 0 #fff, 58px 0 var(--color-danger-default);
  }
}
.before\\:content::before {
    content: var(--tw-content);
    display: grid;
    width: 100%;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    padding-bottom: 8rem;
  }
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .before\\:content::before {
  padding-bottom: 6rem;
}
.before\\:content > *::before {
    content: var(--tw-content);
    margin-bottom: 1.25rem;
  }
.before\\:content > *:last-child::before {
  margin-bottom: 0px;
}
html[data-origin="KIOSK"] .before\\:content > *::before {
  margin-bottom: 2.5rem;
}
html[data-origin="KIOSK"] .before\\:content > *:last-child::before {
  margin-bottom: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .before\\:content > *::before {
  margin-bottom: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .before\\:content > *:last-child::before {
  margin-bottom: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .before\\:content > *::before {
  margin-bottom: 1.5rem;
}
@media screen and (max-height: 552px) {
    .before\\:content::before {
      content: var(--tw-content);
      padding-bottom: 0px;
    }
  }
@media (max-width: 932px) and (orientation: landscape) {
    .before\\:content::before {
      content: var(--tw-content);
      padding-bottom: 0px;
    }
  }
.after\\:content::after {
    content: var(--tw-content);
    display: grid;
    width: 100%;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    padding-bottom: 8rem;
  }
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .after\\:content::after {
  padding-bottom: 6rem;
}
.after\\:content > *::after {
    content: var(--tw-content);
    margin-bottom: 1.25rem;
  }
.after\\:content > *:last-child::after {
  margin-bottom: 0px;
}
html[data-origin="KIOSK"] .after\\:content > *::after {
  margin-bottom: 2.5rem;
}
html[data-origin="KIOSK"] .after\\:content > *:last-child::after {
  margin-bottom: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .after\\:content > *::after {
  margin-bottom: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .after\\:content > *:last-child::after {
  margin-bottom: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .after\\:content > *::after {
  margin-bottom: 1.5rem;
}
@media screen and (max-height: 552px) {
    .after\\:content::after {
      content: var(--tw-content);
      padding-bottom: 0px;
    }
  }
@media (max-width: 932px) and (orientation: landscape) {
    .after\\:content::after {
      content: var(--tw-content);
      padding-bottom: 0px;
    }
  }
.first-letter\\:uppercase::first-letter {
  text-transform: uppercase;
}
.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}
.before\\:inset-0::before {
  content: var(--tw-content);
  inset: 0px;
}
.before\\:z-10::before {
  content: var(--tw-content);
  z-index: 10;
}
.before\\:m-auto::before {
  content: var(--tw-content);
  margin: auto;
}
.before\\:h-6::before {
  content: var(--tw-content);
  height: 1.5rem;
}
.before\\:w-6::before {
  content: var(--tw-content);
  width: 1.5rem;
}
.before\\:w-\\[--progress-width\\]::before {
  content: var(--tw-content);
  width: var(--progress-width);
}
.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}
.before\\:border-b-2::before {
  content: var(--tw-content);
  border-bottom-width: 2px;
}
.before\\:border-header-border-progress::before {
  content: var(--tw-content);
  border-color: var(--color-header-border-progress);
}
.before\\:bg-white::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.before\\:content-\\[\\'\\'\\]::before {
  --tw-content: '';
  content: var(--tw-content);
}
.before\\:content-\\[open-quote\\]::before {
  --tw-content: open-quote;
  content: var(--tw-content);
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-0::after {
  content: var(--tw-content);
  inset: 0px;
}
.after\\:bottom-0::after {
  content: var(--tw-content);
  bottom: 0px;
}
.after\\:bottom-1::after {
  content: var(--tw-content);
  bottom: 0.25rem;
}
.after\\:left-0::after {
  content: var(--tw-content);
  left: 0px;
}
.after\\:right-0::after {
  content: var(--tw-content);
  right: 0px;
}
.after\\:z-20::after {
  content: var(--tw-content);
  z-index: 20;
}
.after\\:m-auto::after {
  content: var(--tw-content);
  margin: auto;
}
.after\\:h-1::after {
  content: var(--tw-content);
  height: 0.25rem;
}
.after\\:h-3\\.5::after {
  content: var(--tw-content);
  height: 0.875rem;
}
.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}
.after\\:h-full::after {
  content: var(--tw-content);
  height: 100%;
}
.after\\:w-12::after {
  content: var(--tw-content);
  width: 3rem;
}
.after\\:w-3\\.5::after {
  content: var(--tw-content);
  width: 0.875rem;
}
.after\\:w-full::after {
  content: var(--tw-content);
  width: 100%;
}
.after\\:w-px::after {
  content: var(--tw-content);
  width: 1px;
}
@keyframes ping {

  75%, 100% {
    content: var(--tw-content);
    transform: scale(2);
    opacity: 0;
  }
}
.after\\:animate-ping::after {
  content: var(--tw-content);
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
.after\\:rounded::after {
  content: var(--tw-content);
  border-radius: 0.25rem;
}
.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:border-2::after {
  content: var(--tw-content);
  border-width: 2px;
}
.after\\:border-danger-high::after {
  content: var(--tw-content);
  border-color: rgb(var(--color-danger-high));
}
.after\\:bg-brand-high::after {
  content: var(--tw-content);
  background-color: var(--color-brand-high);
}
.after\\:bg-default::after {
  content: var(--tw-content);
  background-color: var(--color-default);
}
.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.after\\:content-\\[close-quote\\]::after {
  --tw-content: close-quote;
  content: var(--tw-content);
}
.first\\:mt-0:first-child {
  margin-top: 0px;
}
.first\\:border-0:first-child {
  border-width: 0px;
}
.first\\:pt-0:first-child {
  padding-top: 0px;
}
.first\\:pt-xs:first-child {
  padding-top: var(--spacing-xs);
}
.last\\:mb-0:last-child {
  margin-bottom: 0px;
}
.last\\:border-0:last-child {
  border-width: 0px;
}
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.last\\:pb-0:last-child {
  padding-bottom: 0px;
}
.first-of-type\\:mt-2:first-of-type {
  margin-top: 0.5rem;
}
.hover\\:border-border-default:hover {
  border-color: var(--color-border-default);
}
.hover\\:\\!bg-black\\/90:hover {
  background-color: rgb(0 0 0 / 0.9) !important;
}
.hover\\:\\!bg-white\\/90:hover {
  background-color: rgb(255 255 255 / 0.9) !important;
}
.hover\\:bg-black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-btn-error-hover-bg:hover {
  background-color: var(--color-btn-error-hover-bg);
}
.hover\\:bg-card-radio-active-bg:hover {
  background-color: var(--color-card-radio-active-bg);
}
.hover\\:bg-card-radio-hover-bg:hover {
  background-color: var(--color-card-radio-hover-bg);
}
.hover\\:bg-lowest:hover {
  background-color: var(--color-lowest);
}
.hover\\:bg-overlay:hover {
  background-color: var(--color-overlay);
}
.hover\\:bg-white\\/90:hover {
  background-color: rgb(255 255 255 / 0.9);
}
.hover\\:no-underline:hover {
  text-decoration-line: none;
}
.focus\\:border-danger-default:focus {
  border-color: rgb(var(--color-danger-default));
}
.focus\\:no-underline:focus {
  text-decoration-line: none;
}
.focus\\:shadow-focus:focus {
  --tw-shadow: 0 0 0 4px #CFD8DE;
  --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-btn-error-disabled-bg:focus {
  --tw-ring-color: var(--color-btn-error-disabled-bg);
}
.focus\\:hover\\:shadow-none:hover:focus {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.active\\:\\!bg-white:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.active\\:bg-black:active {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.disabled\\:cursor-default:disabled {
  cursor: default;
}
.disabled\\:border-btn-secondary-disabled-border:disabled {
  border-color: var(--color-btn-secondary-disabled-border);
}
.disabled\\:bg-btn-error-disabled-bg:disabled {
  background-color: var(--color-btn-error-disabled-bg);
}
.disabled\\:bg-btn-primary-disabled-bg:disabled {
  background-color: var(--color-btn-primary-disabled-bg);
}
.disabled\\:bg-btn-secondary-disabled-bg:disabled {
  background-color: var(--color-btn-secondary-disabled-bg);
}
.disabled\\:bg-btn-tertiary-disabled-bg:disabled {
  background-color: var(--color-btn-tertiary-disabled-bg);
}
.disabled\\:bg-white\\/50:disabled {
  background-color: rgb(255 255 255 / 0.5);
}
.disabled\\:font-normal:disabled {
  font-weight: 400;
}
.disabled\\:text-btn-primary-disabled-text:disabled {
  color: var(--color-btn-primary-disabled-text);
}
.disabled\\:text-btn-secondary-disabled-text:disabled {
  color: var(--color-btn-secondary-disabled-text);
}
.disabled\\:text-btn-tertiary-disabled-text:disabled {
  color: var(--color-btn-tertiary-disabled-text);
}
.disabled\\:no-underline:disabled {
  text-decoration-line: none;
}
.disabled\\:opacity-100:disabled {
  opacity: 1;
}
.disabled\\:opacity-25:disabled {
  opacity: 0.25;
}
.disabled\\:hover\\:\\!bg-black\\/70:hover:disabled {
  background-color: rgb(0 0 0 / 0.7) !important;
}
.disabled\\:hover\\:\\!bg-white\\/70:hover:disabled {
  background-color: rgb(255 255 255 / 0.7) !important;
}
.disabled\\:hover\\:text-default:hover:disabled {
  color: var(--color-default);
}
.group:hover .group-hover\\:border-radio-secondary-hover-border {
  border-color: var(--color-radio-secondary-hover-border);
}
.peer:focus ~ .peer-focus\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (hover: hover) and (pointer: fine) {

  .has-hover\\:border-btn-primary-text {
    border-color: var(--color-btn-primary-text);
  }

  .has-hover\\:hover\\:border-btn-primary-hover-border:hover {
    border-color: var(--color-btn-primary-hover-border);
  }

  .has-hover\\:hover\\:border-btn-secondary-hover-border:hover {
    border-color: var(--color-btn-secondary-hover-border);
  }

  .has-hover\\:hover\\:bg-btn-primary-hover-bg:hover {
    background-color: var(--color-btn-primary-hover-bg);
  }

  .has-hover\\:hover\\:bg-btn-secondary-hover-bg:hover {
    background-color: var(--color-btn-secondary-hover-bg);
  }

  .has-hover\\:hover\\:bg-btn-tertiary-hover-bg:hover {
    background-color: var(--color-btn-tertiary-hover-bg);
  }

  .has-hover\\:hover\\:text-btn-primary-hover-text:hover {
    color: var(--color-btn-primary-hover-text);
  }

  .has-hover\\:hover\\:text-btn-secondary-hover-text:hover {
    color: var(--color-btn-secondary-hover-text);
  }

  .has-hover\\:hover\\:disabled\\:bg-btn-tertiary-disabled-bg:disabled:hover {
    background-color: var(--color-btn-tertiary-disabled-bg);
  }
}
.iconBtn\\:px-2xs:has(>svg:only-child) {
  padding-left: var(--spacing-2xs);
  padding-right: var(--spacing-2xs);
}
.iconBtn\\:px-s:has(>svg:only-child) {
  padding-left: var(--spacing-s);
  padding-right: var(--spacing-s);
}
.disabledStyle\\:border-btn-secondary-disabled-border[data-fake-disabled="true"] {
  border-color: var(--color-btn-secondary-disabled-border);
}
.disabledStyle\\:bg-btn-error-disabled-bg[data-fake-disabled="true"] {
  background-color: var(--color-btn-error-disabled-bg);
}
.disabledStyle\\:bg-btn-primary-disabled-bg[data-fake-disabled="true"] {
  background-color: var(--color-btn-primary-disabled-bg);
}
.disabledStyle\\:bg-btn-secondary-disabled-bg[data-fake-disabled="true"] {
  background-color: var(--color-btn-secondary-disabled-bg);
}
.disabledStyle\\:bg-btn-tertiary-disabled-bg[data-fake-disabled="true"] {
  background-color: var(--color-btn-tertiary-disabled-bg);
}
.disabledStyle\\:bg-white\\/50[data-fake-disabled="true"] {
  background-color: rgb(255 255 255 / 0.5);
}
.disabledStyle\\:text-btn-primary-disabled-text[data-fake-disabled="true"] {
  color: var(--color-btn-primary-disabled-text);
}
.disabledStyle\\:text-btn-secondary-disabled-text[data-fake-disabled="true"] {
  color: var(--color-btn-secondary-disabled-text);
}
.disabledStyle\\:hover\\:text-default:hover[data-fake-disabled="true"] {
  color: var(--color-default);
}
html[data-origin="KIOSK"] .kiosk\\:fixed {
  position: fixed;
}
html[data-origin="KIOSK"] .kiosk\\:bottom-8 {
  bottom: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:right-10 {
  right: 2.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:right-3 {
  right: 0.75rem;
}
html[data-origin="KIOSK"] .kiosk\\:right-8 {
  right: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:top-0 {
  top: 0px;
}
html[data-origin="KIOSK"] .kiosk\\:top-11 {
  top: 2.75rem;
}
html[data-origin="KIOSK"] .kiosk\\:top-3 {
  top: 0.75rem;
}
html[data-origin="KIOSK"] .kiosk\\:top-8 {
  top: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:z-40 {
  z-index: 40;
}
html[data-origin="KIOSK"] .kiosk\\:m-2 {
  margin: 0.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:m-4 {
  margin: 1rem;
}
html[data-origin="KIOSK"] .kiosk\\:mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
html[data-origin="KIOSK"] .kiosk\\:mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
html[data-origin="KIOSK"] .kiosk\\:my-12 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
html[data-origin="KIOSK"] .kiosk\\:my-14 {
  margin-top: 3.5rem;
  margin-bottom: 3.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:my-20 {
  margin-top: 5rem;
  margin-bottom: 5rem;
}
html[data-origin="KIOSK"] .kiosk\\:my-36 {
  margin-top: 9rem;
  margin-bottom: 9rem;
}
html[data-origin="KIOSK"] .kiosk\\:my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:\\!mt-16 {
  margin-top: 4rem !important;
}
html[data-origin="KIOSK"] .kiosk\\:-mr-4 {
  margin-right: -1rem;
}
html[data-origin="KIOSK"] .kiosk\\:-mt-4 {
  margin-top: -1rem;
}
html[data-origin="KIOSK"] .kiosk\\:mb-10 {
  margin-bottom: 2.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:mb-14 {
  margin-bottom: 3.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:mb-20 {
  margin-bottom: 5rem;
}
html[data-origin="KIOSK"] .kiosk\\:mb-24 {
  margin-bottom: 6rem;
}
html[data-origin="KIOSK"] .kiosk\\:mb-4 {
  margin-bottom: 1rem;
}
html[data-origin="KIOSK"] .kiosk\\:mb-5 {
  margin-bottom: 1.25rem;
}
html[data-origin="KIOSK"] .kiosk\\:mb-52 {
  margin-bottom: 13rem;
}
html[data-origin="KIOSK"] .kiosk\\:mb-8 {
  margin-bottom: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:ml-10 {
  margin-left: 2.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:ml-5 {
  margin-left: 1.25rem;
}
html[data-origin="KIOSK"] .kiosk\\:ml-6 {
  margin-left: 1.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:mr-0 {
  margin-right: 0px;
}
html[data-origin="KIOSK"] .kiosk\\:mr-5 {
  margin-right: 1.25rem;
}
html[data-origin="KIOSK"] .kiosk\\:mr-6 {
  margin-right: 1.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:mr-8 {
  margin-right: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:mt-0 {
  margin-top: 0px;
}
html[data-origin="KIOSK"] .kiosk\\:mt-1 {
  margin-top: 0.25rem;
}
html[data-origin="KIOSK"] .kiosk\\:mt-10 {
  margin-top: 2.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:mt-12 {
  margin-top: 3rem;
}
html[data-origin="KIOSK"] .kiosk\\:mt-14 {
  margin-top: 3.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:mt-20 {
  margin-top: 5rem;
}
html[data-origin="KIOSK"] .kiosk\\:mt-4 {
  margin-top: 1rem;
}
html[data-origin="KIOSK"] .kiosk\\:mt-5 {
  margin-top: 1.25rem;
}
html[data-origin="KIOSK"] .kiosk\\:mt-6 {
  margin-top: 1.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:mt-8 {
  margin-top: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:inline-flex {
  display: inline-flex;
}
html[data-origin="KIOSK"] .kiosk\\:aspect-square {
  aspect-ratio: 1 / 1;
}
html[data-origin="KIOSK"] .kiosk\\:size-10 {
  width: 2.5rem;
  height: 2.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:size-12 {
  width: 3rem;
  height: 3rem;
}
html[data-origin="KIOSK"] .kiosk\\:size-14 {
  width: 3.5rem;
  height: 3.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:size-16 {
  width: 4rem;
  height: 4rem;
}
html[data-origin="KIOSK"] .kiosk\\:size-20 {
  width: 5rem;
  height: 5rem;
}
html[data-origin="KIOSK"] .kiosk\\:size-28 {
  width: 7rem;
  height: 7rem;
}
html[data-origin="KIOSK"] .kiosk\\:size-36 {
  width: 9rem;
  height: 9rem;
}
html[data-origin="KIOSK"] .kiosk\\:size-48 {
  width: 12rem;
  height: 12rem;
}
html[data-origin="KIOSK"] .kiosk\\:size-52 {
  width: 13rem;
  height: 13rem;
}
html[data-origin="KIOSK"] .kiosk\\:size-6 {
  width: 1.5rem;
  height: 1.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:\\!h-36 {
  height: 9rem !important;
}
html[data-origin="KIOSK"] .kiosk\\:\\!h-96 {
  height: 24rem !important;
}
html[data-origin="KIOSK"] .kiosk\\:h-12 {
  height: 3rem;
}
html[data-origin="KIOSK"] .kiosk\\:h-16 {
  height: 4rem;
}
html[data-origin="KIOSK"] .kiosk\\:h-192 {
  height: 48rem;
}
html[data-origin="KIOSK"] .kiosk\\:h-24 {
  height: 6rem;
}
html[data-origin="KIOSK"] .kiosk\\:h-28 {
  height: 7rem;
}
html[data-origin="KIOSK"] .kiosk\\:h-36 {
  height: 9rem;
}
html[data-origin="KIOSK"] .kiosk\\:h-44 {
  height: 11rem;
}
html[data-origin="KIOSK"] .kiosk\\:h-8 {
  height: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:h-full {
  height: 100%;
}
html[data-origin="KIOSK"] .kiosk\\:max-h-52 {
  max-height: 13rem;
}
html[data-origin="KIOSK"] .kiosk\\:max-h-96 {
  max-height: 24rem;
}
html[data-origin="KIOSK"] .kiosk\\:max-h-\\[40vh\\] {
  max-height: 40vh;
}
html[data-origin="KIOSK"] .kiosk\\:min-h-12 {
  min-height: 3rem;
}
html[data-origin="KIOSK"] .kiosk\\:min-h-8 {
  min-height: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:min-h-\\[120px\\] {
  min-height: 120px;
}
html[data-origin="KIOSK"] .kiosk\\:min-h-\\[620px\\] {
  min-height: 620px;
}
html[data-origin="KIOSK"] .kiosk\\:min-h-svh {
  min-height: 100svh;
}
html[data-origin="KIOSK"] .kiosk\\:\\!w-36 {
  width: 9rem !important;
}
html[data-origin="KIOSK"] .kiosk\\:w-128 {
  width: 32rem;
}
html[data-origin="KIOSK"] .kiosk\\:w-16 {
  width: 4rem;
}
html[data-origin="KIOSK"] .kiosk\\:w-52 {
  width: 13rem;
}
html[data-origin="KIOSK"] .kiosk\\:w-72 {
  width: 18rem;
}
html[data-origin="KIOSK"] .kiosk\\:w-8 {
  width: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:w-96 {
  width: 24rem;
}
html[data-origin="KIOSK"] .kiosk\\:w-full {
  width: 100%;
}
html[data-origin="KIOSK"] .kiosk\\:\\!max-w-2xl {
  max-width: 42rem !important;
}
html[data-origin="KIOSK"] .kiosk\\:max-w-4xl {
  max-width: 56rem;
}
html[data-origin="KIOSK"] .kiosk\\:max-w-xl {
  max-width: 36rem;
}
html[data-origin="KIOSK"] .kiosk\\:flex-1 {
  flex: 1 1 0%;
}
html[data-origin="KIOSK"] .kiosk\\:flex-auto {
  flex: 1 1 auto;
}
html[data-origin="KIOSK"] .kiosk\\:flex-grow-0 {
  flex-grow: 0;
}
html[data-origin="KIOSK"] .kiosk\\:\\!translate-x-\\[3\\.25rem\\] {
  --tw-translate-x: 3.25rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
html[data-origin="KIOSK"] .kiosk\\:-translate-y-6 {
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="KIOSK"] .kiosk\\:-translate-y-7 {
  --tw-translate-y: -1.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="KIOSK"] .kiosk\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="KIOSK"] .kiosk\\:flex-row {
  flex-direction: row;
}
html[data-origin="KIOSK"] .kiosk\\:flex-row-reverse {
  flex-direction: row-reverse;
}
html[data-origin="KIOSK"] .kiosk\\:justify-end {
  justify-content: flex-end;
}
html[data-origin="KIOSK"] .kiosk\\:justify-center {
  justify-content: center;
}
html[data-origin="KIOSK"] .kiosk\\:justify-between {
  justify-content: space-between;
}
html[data-origin="KIOSK"] .kiosk\\:gap-4 {
  gap: 1rem;
}
html[data-origin="KIOSK"] .kiosk\\:gap-5 {
  gap: 1.25rem;
}
html[data-origin="KIOSK"] .kiosk\\:gap-6 {
  gap: 1.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:gap-8 {
  gap: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:rounded-4xl {
  border-radius: 85px;
}
html[data-origin="KIOSK"] .kiosk\\:rounded-admin-card {
  border-radius: var(--rounded-admin-card);
}
html[data-origin="KIOSK"] .kiosk\\:border-t-2 {
  border-top-width: 2px;
}
html[data-origin="KIOSK"] .kiosk\\:\\!p-3 {
  padding: 0.75rem !important;
}
html[data-origin="KIOSK"] .kiosk\\:\\!p-4 {
  padding: 1rem !important;
}
html[data-origin="KIOSK"] .kiosk\\:p-0 {
  padding: 0px;
}
html[data-origin="KIOSK"] .kiosk\\:p-10 {
  padding: 2.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:p-20 {
  padding: 5rem;
}
html[data-origin="KIOSK"] .kiosk\\:p-3 {
  padding: 0.75rem;
}
html[data-origin="KIOSK"] .kiosk\\:p-4 {
  padding: 1rem;
}
html[data-origin="KIOSK"] .kiosk\\:p-6 {
  padding: 1.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:p-8 {
  padding: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:p-9 {
  padding: 2.25rem;
}
html[data-origin="KIOSK"] .kiosk\\:\\!py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
html[data-origin="KIOSK"] .kiosk\\:px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
html[data-origin="KIOSK"] .kiosk\\:px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
html[data-origin="KIOSK"] .kiosk\\:px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:px-24 {
  padding-left: 6rem;
  padding-right: 6rem;
}
html[data-origin="KIOSK"] .kiosk\\:px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
html[data-origin="KIOSK"] .kiosk\\:px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
html[data-origin="KIOSK"] .kiosk\\:px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
html[data-origin="KIOSK"] .kiosk\\:py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
html[data-origin="KIOSK"] .kiosk\\:py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
html[data-origin="KIOSK"] .kiosk\\:\\!pt-8 {
  padding-top: 2rem !important;
}
html[data-origin="KIOSK"] .kiosk\\:pb-0 {
  padding-bottom: 0px;
}
html[data-origin="KIOSK"] .kiosk\\:pb-10 {
  padding-bottom: 2.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:pb-20 {
  padding-bottom: 5rem;
}
html[data-origin="KIOSK"] .kiosk\\:pl-6 {
  padding-left: 1.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:pr-20 {
  padding-right: 5rem;
}
html[data-origin="KIOSK"] .kiosk\\:pr-4 {
  padding-right: 1rem;
}
html[data-origin="KIOSK"] .kiosk\\:pt-12 {
  padding-top: 3rem;
}
html[data-origin="KIOSK"] .kiosk\\:pt-20 {
  padding-top: 5rem;
}
html[data-origin="KIOSK"] .kiosk\\:pt-4 {
  padding-top: 1rem;
}
html[data-origin="KIOSK"] .kiosk\\:pt-8 {
  padding-top: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:text-center {
  text-align: center;
}
html[data-origin="KIOSK"] .kiosk\\:\\!text-2xl {
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
html[data-origin="KIOSK"] .kiosk\\:\\!text-base {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
html[data-origin="KIOSK"] .kiosk\\:\\!text-lg {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
html[data-origin="KIOSK"] .kiosk\\:text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
html[data-origin="KIOSK"] .kiosk\\:text-3xl {
  font-size: 1.750rem;
  line-height: 2.625rem;
}
html[data-origin="KIOSK"] .kiosk\\:text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:text-5xl {
  font-size: 3rem;
  line-height: 4.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
html[data-origin="KIOSK"] .kiosk\\:text-7xl {
  font-size: 4.5rem;
  line-height: 1;
}
html[data-origin="KIOSK"] .kiosk\\:text-8xl {
  font-size: 6rem;
  line-height: 1;
}
html[data-origin="KIOSK"] .kiosk\\:text-9xl {
  font-size: 8rem;
  line-height: 1;
}
html[data-origin="KIOSK"] .kiosk\\:text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
html[data-origin="KIOSK"] .kiosk\\:text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
html[data-origin="KIOSK"] .kiosk\\:font-normal {
  font-weight: 400;
}
html[data-origin="KIOSK"] .kiosk\\:\\!leading-11 {
  line-height: 2.625rem !important;
}
html[data-origin="KIOSK"] .kiosk\\:\\!leading-l {
  line-height: var(--spacing-l) !important;
}
html[data-origin="KIOSK"] .kiosk\\:leading-10 {
  line-height: 2.5rem;
}
html[data-origin="KIOSK"] .kiosk\\:placeholder\\:text-lg::-moz-placeholder {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
html[data-origin="KIOSK"] .kiosk\\:placeholder\\:text-lg::placeholder {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
html[data-origin="KIOSK"] .peer:focus ~ .kiosk\\:peer-focus\\:-translate-y-6 {
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="KIOSK"] .peer:focus ~ .kiosk\\:peer-focus\\:-translate-y-7 {
  --tw-translate-y: -1.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="KIOSK"] .peer:focus ~ .kiosk\\:peer-focus\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:fixed {
  position: fixed;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:bottom-8 {
  bottom: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:right-10 {
  right: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:right-3 {
  right: 0.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:right-8 {
  right: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:top-0 {
  top: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:top-11 {
  top: 2.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:top-3 {
  top: 0.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:top-8 {
  top: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:z-40 {
  z-index: 40;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:m-2 {
  margin: 0.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:m-4 {
  margin: 1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:my-12 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:my-14 {
  margin-top: 3.5rem;
  margin-bottom: 3.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:my-20 {
  margin-top: 5rem;
  margin-bottom: 5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:my-36 {
  margin-top: 9rem;
  margin-bottom: 9rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!mt-16 {
  margin-top: 4rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:-mr-4 {
  margin-right: -1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:-mt-4 {
  margin-top: -1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mb-10 {
  margin-bottom: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mb-14 {
  margin-bottom: 3.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mb-20 {
  margin-bottom: 5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mb-24 {
  margin-bottom: 6rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mb-4 {
  margin-bottom: 1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mb-5 {
  margin-bottom: 1.25rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mb-52 {
  margin-bottom: 13rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mb-8 {
  margin-bottom: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:ml-10 {
  margin-left: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:ml-5 {
  margin-left: 1.25rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:ml-6 {
  margin-left: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mr-0 {
  margin-right: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mr-5 {
  margin-right: 1.25rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mr-6 {
  margin-right: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mr-8 {
  margin-right: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mt-0 {
  margin-top: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mt-1 {
  margin-top: 0.25rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mt-10 {
  margin-top: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mt-12 {
  margin-top: 3rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mt-14 {
  margin-top: 3.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mt-20 {
  margin-top: 5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mt-4 {
  margin-top: 1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mt-5 {
  margin-top: 1.25rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mt-6 {
  margin-top: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:mt-8 {
  margin-top: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:inline-flex {
  display: inline-flex;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:aspect-square {
  aspect-ratio: 1 / 1;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:size-10 {
  width: 2.5rem;
  height: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:size-12 {
  width: 3rem;
  height: 3rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:size-14 {
  width: 3.5rem;
  height: 3.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:size-16 {
  width: 4rem;
  height: 4rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:size-20 {
  width: 5rem;
  height: 5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:size-28 {
  width: 7rem;
  height: 7rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:size-36 {
  width: 9rem;
  height: 9rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:size-48 {
  width: 12rem;
  height: 12rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:size-52 {
  width: 13rem;
  height: 13rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:size-6 {
  width: 1.5rem;
  height: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!h-36 {
  height: 9rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!h-96 {
  height: 24rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:h-12 {
  height: 3rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:h-16 {
  height: 4rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:h-192 {
  height: 48rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:h-24 {
  height: 6rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:h-28 {
  height: 7rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:h-36 {
  height: 9rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:h-44 {
  height: 11rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:h-8 {
  height: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:h-full {
  height: 100%;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:max-h-52 {
  max-height: 13rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:max-h-96 {
  max-height: 24rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:max-h-\\[40vh\\] {
  max-height: 40vh;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:min-h-12 {
  min-height: 3rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:min-h-8 {
  min-height: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:min-h-\\[120px\\] {
  min-height: 120px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:min-h-\\[620px\\] {
  min-height: 620px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:min-h-svh {
  min-height: 100svh;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!w-36 {
  width: 9rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:w-128 {
  width: 32rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:w-16 {
  width: 4rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:w-52 {
  width: 13rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:w-72 {
  width: 18rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:w-8 {
  width: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:w-96 {
  width: 24rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:w-full {
  width: 100%;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!max-w-2xl {
  max-width: 42rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:max-w-4xl {
  max-width: 56rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:max-w-xl {
  max-width: 36rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:flex-1 {
  flex: 1 1 0%;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:flex-auto {
  flex: 1 1 auto;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:flex-grow-0 {
  flex-grow: 0;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!translate-x-\\[3\\.25rem\\] {
  --tw-translate-x: 3.25rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:-translate-y-6 {
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:-translate-y-7 {
  --tw-translate-y: -1.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:flex-row {
  flex-direction: row;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:flex-row-reverse {
  flex-direction: row-reverse;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:justify-end {
  justify-content: flex-end;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:justify-center {
  justify-content: center;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:justify-between {
  justify-content: space-between;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:gap-4 {
  gap: 1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:gap-5 {
  gap: 1.25rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:gap-6 {
  gap: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:gap-8 {
  gap: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:rounded-4xl {
  border-radius: 85px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:rounded-admin-card {
  border-radius: var(--rounded-admin-card);
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:border-t-2 {
  border-top-width: 2px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!p-3 {
  padding: 0.75rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!p-4 {
  padding: 1rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:p-0 {
  padding: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:p-10 {
  padding: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:p-20 {
  padding: 5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:p-3 {
  padding: 0.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:p-4 {
  padding: 1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:p-6 {
  padding: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:p-8 {
  padding: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:p-9 {
  padding: 2.25rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:px-24 {
  padding-left: 6rem;
  padding-right: 6rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!pt-8 {
  padding-top: 2rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:pb-0 {
  padding-bottom: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:pb-10 {
  padding-bottom: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:pb-20 {
  padding-bottom: 5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:pl-6 {
  padding-left: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:pr-20 {
  padding-right: 5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:pr-4 {
  padding-right: 1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:pt-12 {
  padding-top: 3rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:pt-20 {
  padding-top: 5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:pt-4 {
  padding-top: 1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:pt-8 {
  padding-top: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:text-center {
  text-align: center;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!text-2xl {
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!text-base {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!text-lg {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:text-3xl {
  font-size: 1.750rem;
  line-height: 2.625rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:text-5xl {
  font-size: 3rem;
  line-height: 4.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:text-7xl {
  font-size: 4.5rem;
  line-height: 1;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:text-8xl {
  font-size: 6rem;
  line-height: 1;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:text-9xl {
  font-size: 8rem;
  line-height: 1;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:font-normal {
  font-weight: 400;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!leading-11 {
  line-height: 2.625rem !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:\\!leading-l {
  line-height: var(--spacing-l) !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:leading-10 {
  line-height: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:placeholder\\:text-lg::-moz-placeholder {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kiosk\\:placeholder\\:text-lg::placeholder {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .peer:focus ~ .kiosk\\:peer-focus\\:-translate-y-6 {
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .peer:focus ~ .kiosk\\:peer-focus\\:-translate-y-7 {
  --tw-translate-y: -1.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .peer:focus ~ .kiosk\\:peer-focus\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:bottom-6 {
  bottom: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:mb-10 {
  margin-bottom: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:mb-8 {
  margin-bottom: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:mt-10 {
  margin-top: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:mt-4 {
  margin-top: 1rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:mt-6 {
  margin-top: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:mt-7 {
  margin-top: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:mt-8 {
  margin-top: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:grid {
  display: grid;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:size-10 {
  width: 2.5rem;
  height: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:h-28 {
  height: 7rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:h-40 {
  height: 10rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:max-h-96 {
  max-height: 24rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:min-h-\\[400px\\] {
  min-height: 400px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:w-96 {
  width: 24rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:w-full {
  width: 100%;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:max-w-2xl {
  max-width: 42rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:gap-8 {
  gap: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:\\!p-0 {
  padding: 0px !important;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:p-5 {
  padding: 1.25rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:p-7 {
  padding: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:pb-10 {
  padding-bottom: 2.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:pb-40 {
  padding-bottom: 10rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:pb-5 {
  padding-bottom: 1.25rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:pt-6 {
  padding-top: 1.5rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
html[data-origin="SHAREBOX_INDOOR_KIOSK"] .kioskSharebox\\:text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
html[data-origin="KIOSK"] .kioskPartteam\\:min-h-\\[600px\\] {
  min-height: 600px;
}
html[data-origin="KIOSK"] .kioskPartteam\\:w-\\[512px\\] {
  width: 512px;
}
html[data-origin="KIOSK"] .kioskPartteam\\:w-full {
  width: 100%;
}
html[data-origin="KIOSK"] .kioskPartteam\\:pb-48 {
  padding-bottom: 12rem;
}
.data-checked\\:border-radio-active-border[data-checked] {
  border-color: var(--color-radio-active-border);
}
.data-checked\\:bg-radio-active-bg[data-checked] {
  background-color: var(--color-radio-active-bg);
}
.ui-selected\\:rounded-full[data-headlessui-state~="selected"] {
  border-radius: 9999px;
}
.ui-selected\\:bg-white[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:rounded-full {
  border-radius: 9999px;
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
@media (min-width: 640px) {

  .sm\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .sm\\:my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .sm\\:mb-0 {
    margin-bottom: 0px;
  }

  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }

  .sm\\:ml-1 {
    margin-left: 0.25rem;
  }

  .sm\\:ml-2 {
    margin-left: 0.5rem;
  }

  .sm\\:mr-1 {
    margin-right: 0.25rem;
  }

  .sm\\:w-1\\/2 {
    width: 50%;
  }

  .sm\\:w-\\[calc\\(20\\%-1rem\\)\\] {
    width: calc(20% - 1rem);
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:max-w-none {
    max-width: none;
  }

  .sm\\:grow-0 {
    flex-grow: 0;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:rounded-2xl {
    border-radius: 1rem;
  }

  .sm\\:rounded-card {
    border-radius: var(--rounded-card);
  }

  .sm\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .sm\\:\\!pb-0 {
    padding-bottom: 0px !important;
  }

  .sm\\:\\!pt-6 {
    padding-top: 1.5rem !important;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:odd\\:border-r-2:nth-child(odd) {
    border-right-width: 2px;
  }

  .sm\\:odd\\:last\\:border-r-0:last-child:nth-child(odd) {
    border-right-width: 0px;
  }
}
@media (min-width: 768px) {

  .md\\:h-32 {
    height: 8rem;
  }

  .md\\:w-1\\/3 {
    width: 33.333333%;
  }

  .md\\:w-32 {
    width: 8rem;
  }

  .md\\:max-w-96 {
    max-width: 24rem;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:rounded-modal {
    border-radius: var(--rounded-modal);
  }
}
@media (min-width: 1024px) {

  .lg\\:w-2\\/3 {
    width: 66.666667%;
  }

  .lg\\:w-56 {
    width: 14rem;
  }

  .lg\\:p-4 {
    padding: 1rem;
  }
}
@media (max-width: 320px) {

  .xs\\:w-64 {
    width: 16rem;
  }

  .xs\\:w-\\[calc\\(50\\%-0\\.5rem\\)\\] {
    width: calc(50% - 0.5rem);
  }

  .xs\\:p-6 {
    padding: 1.5rem;
  }

  .xs\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
@media (orientation: landscape) {

  .landscape\\:max-w-64 {
    max-width: 16rem;
  }

  .landscape\\:max-w-lg {
    max-width: 32rem;
  }

  .landscape\\:items-center {
    align-items: center;
  }

  .landscape\\:pt-16 {
    padding-top: 4rem;
  }

  @media (min-width: 768px) {

    .landscape\\:md\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
}
@media (min-width: 1024px) {

  @media (orientation: landscape) {

    .lg\\:landscape\\:max-w-full {
      max-width: 100%;
    }
  }
}
.\\[\\&\\>\\#keys-modal-actions\\]\\:flex-col>#keys-modal-actions {
  flex-direction: column;
}
.\\[\\&\\>a\\]\\:text-xs>a {
  font-size: var(--text-xs);
}
.\\[\\&\\>div\\>div\\]\\:\\!bg-neutral-50>div>div {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1)) !important;
}
.\\[\\&\\>div\\]\\:\\!m-0>div {
  margin: 0px !important;
}
.\\[\\&\\>div\\]\\:\\!size-16>div {
  width: 4rem !important;
  height: 4rem !important;
}
.\\[\\&\\>div\\]\\:size-4xl>div {
  width: var(--spacing-4xl);
  height: var(--spacing-4xl);
}
.\\[\\&\\>div\\]\\:size-5xl>div {
  width: var(--spacing-5xl);
  height: var(--spacing-5xl);
}
.\\[\\&\\>div\\]\\:\\!flex-initial>div {
  flex: 0 1 auto !important;
}
.\\[\\&\\>div\\]\\:\\!flex-shrink-0>div {
  flex-shrink: 0 !important;
}
.\\[\\&\\>img\\]\\:hidden>img {
  display: none;
}
.\\[\\&\\>img\\]\\:rounded-lg>img {
  border-radius: 0.5rem;
}
.\\[\\&\\>p\\]\\:mx-1>p {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.\\[\\&\\>p\\]\\:inline>p {
  display: inline;
}
.\\[\\&\\>span\\]\\:text-xs>span {
  font-size: var(--text-xs);
}
.\\[\\&\\[data-selected\\]\\]\\:bg-white[data-selected] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.\\[\\&\\[data-selected\\]\\]\\:shadow-sm[data-selected] {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
`, "",{"version":3,"sources":["webpack://./node_modules/tailwindcss/base.css","webpack://./node_modules/tailwindcss/components.css","webpack://./src/styles/index.css","webpack://./node_modules/tailwindcss/utilities.css","webpack://./src/styles/variables.css","webpack://./src/styles/themes/porsche/variables.css","webpack://./src/styles/themes/ford/variables.css","<no source>"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,0BAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,6BAAc;IAAd,6BAAc;;IAAd,iCAAc;IAAd,iCAAc;;IAAd,0BAAc;IAAd,yBAAc;;IAAd,0BAAc;IAAd,0BAAc;IAAd,0BAAc;IAAd,0BAAc;IAAd,0BAAc;IAAd,0BAAc;IAAd,0BAAc;IAAd,0BAAc;IAAd,0BAAc;IAAd,2BAAc;;IAAd,yBAAc;IAAd,8CAAc;IAAd,8CAAc;IAAd,8CAAc;IAAd,8CAAc;IAAd,6CAAc;IAAd,4CAAc;IAAd,2CAAc;IAAd,0CAAc;IAAd,0CAAc;IAAd,2CAAc;;IAAd,4BAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,0BAAc;IAAd,0BAAc;IAAd,0BAAc;IAAd,0BAAc;IAAd,0BAAc;IAAd,0BAAc;;IAAd,+BAAc;IAAd,8BAAc;;IAAd,8BAAc;IAAd,4BAAc;QAAd,iGAAc;;QAAd,uBAAc;QAAd,qBAAc;QAAd,qBAAc;QAAd,iBAAc;QAAd,oBAAc;QAAd,mBAAc;QAAd,qBAAc;QAAd,mBAAc;QAAd,mBAAc;QAAd,mBAAc;;QAAd,2BAAc;QAAd,4BAAc;;QAAd,qBAAc;QAAd,mBAAc;QAAd,mBAAc;QAAd,cAAc;QAAd,kBAAc;;QAAd,mBAAc;;QAAd,6BAAc;QAAd,+BAAc;;QAAd,gCAAc;QAAd,8BAAc;QAAd,kCAAc;;QAAd,sCAAc;;QAAd,wBAAc;QAAd,yBAAc;;QAAd,kBAAc;QAAd,qBAAc;QAAd,6CAAc;QAAd,8CAAc;QAAd,iDAAc;QAAd,mDAAc;QAAd,qDAAc;QAAd,kDAAc;QAAd,2CAAc;;QAAd,mBAAc;QAAd,+CAAc;QAAd,8CAAc;QAAd,6CAAc;QAAd,0CAAc;QAAd,8CAAc;;QAAd,kBAAc;QAAd,0CAAc;QAAd,qCAAc;QAAd,wCAAc;QAAd,uCAAc;;QAAd,qBAAc;QAAd,8CAAc;QAAd,+CAAc;;QAAd,qBAAc;QAAd,+CAAc;QAAd,gDAAc;;QAAd,oBAAc;QAAd,2CAAc;QAAd,0CAAc;QAAd,wCAAc;QAAd,4CAAc;QAAd,yCAAc;QAAd,4CAAc;;QAAd,qDAAc;QAAd,mDAAc;;QAAd,wBAAc;QAAd,6CAAc;;QAAd,oBAAc;QAAd,4CAAc;QAAd,qDAAc;;QAAd,SAAc;QAAd,6CAAc;QAAd,uCAAc;;QAAd,WAAc;QAAd,8CAAc;QAAd,uDAAc;;QAAd,YAAc;QAAd,uBAAc;QAAd,+BAAc;;QAAd,qBAAc;QAAd,kDAAc;QAAd,8CAAc;QAAd,mDAAc;QAAd,yDAAc;QAAd,oDAAc;QAAd,wDAAc;QAAd,uDAAc;QAAd,uDAAc;;QAAd,kBAAc;QAAd,uDAAc;QAAd,mDAAc;QAAd,wDAAc;QAAd,2DAAc;QAAd,6DAAc;;QAAd,kDAAc;;QAAd,uBAAc;QAAd,sDAAc;QAAd,gDAAc;QAAd,0DAAc;QAAd,yDAAc;QAAd,4DAAc;QAAd,gEAAc;QAAd,yDAAc;QAAd,8DAAc;QAAd,mEAAc;;QAAd,sBAAc;QAAd,gDAAc;QAAd,qDAAc;QAAd,yDAAc;QAAd,wDAAc;QAAd,8DAAc;;QAAd,mBAAc;QAAd,gDAAc;QAAd,mDAAc;;QAAd,wBAAc;QAAd,4BAAc;QAAd,8BAAc;QAAd,oEAAc;QAAd,sBAAc;QAAd,kCAAc;;QAAd,wBAAc;QAAd,iDAAc;QAAd,8CAAc;QAAd,oDAAc;QAAd,sDAAc;QAAd,sDAAc;QAAd,qDAAc;QAAd,2DAAc;QAAd,qDAAc;QAAd,6BAAc;;QAAd,kBAAc;QAAd,2BAAc;QAAd,kDAAc;QAAd,6BAAc;;QAAd,SAAc;QAAd,YAAc;QAAd,8CAAc;QAAd,2CAAc;QAAd,kDAAc;QAAd,oCAAc;QAAd,kDAAc;QAAd,wDAAc;;QAAd,yDAAc;QAAd,kDAAc;;QAAd,uBAAc;QAAd,qBAAc;QAAd,6CAAc;;QAAd,oBAAc;QAAd,8BAAc;;QAAd,aAAc;QAAd,+CAAc;QAAd,mDAAc;QAAd,+CAAc;QAAd,yBAAc;;QAAd,kDAAc;QAAd,sDAAc;QAAd,uDAAc;;QAAd,sBAAc;QAAd,sBAAc;;QAAd,YAAc;QAAd,0CAAc;QAAd,6CAAc;QAAd,iDAAc;QAAd,iDAAc;;QAAd,oDAAc;QAAd,0DAAc;QAAd,8DAAc;QAAd,8DAAc;QAAd,yDAAc;QAAd,6DAAc;;QAAd,wBAAc;;QAAd,UAAc;QAAd,mBAAc;QAAd,qCAAc;;QAAd,UAAc;QAAd,4CAAc;;QAAd,WAAc;QAAd,gCAAc;QAAd,qBAAc;;QAAd,gBAAc;QAAd,2BAAc;;QAAd,kBAAc;QAAd,gCAAc;;QAAd,SAAc;QAAd,sBAAc;;QAAd,UAAc;QAAd,0BAAc;QAAd,yCAAc;;QAAd,aAAc;QAAd,kDAAc;QAAd,kDAAc;QAAd,2BAAc;QAAd,2BAAc;QAAd,kCAAc;QAAd,kCAAc;QAAd,qBAAc;QAAd,6BAAc;QAAd,6BAAc;QAAd,+BAAc;QAAd,mCAAc;QAAd,iCAAc;;QAAd,kBAAc;QAAd,6BAAc;;QAAd,0BAAc;;QAAd,0BAAc;QAAd,2DAAc;QAAd,uCAAc;QAAd,qDAAc;QAAd,oFAAc;EAAA;;IAAd;;QAAA,sBAAc;QAAd,mBAAc;QAAd,oBAAc;QAAd,iBAAc;QAAd,mBAAc;QAAd,iBAAc;QAAd,oBAAc;QAAd,mBAAc;QAAd,mBAAc;QAAd,oBAAc;;QAAd,2BAAc;QAAd,6BAAc;;QAAd,iBAAc;QAAd,mBAAc;QAAd,iBAAc;QAAd,iBAAc;QAAd,cAAc;;QAAd,mBAAc;;QAAd,iCAAc;QAAd,+BAAc;;QAAd,sCAAc;;QAAd,wBAAc;QAAd,0BAAc;;QAAd,wBAAc;;QAAd,qBAAc;;QAAd,qBAAc;;QAAd,oBAAc;;QAAd,2BAAc;;QAAd,6BAAc;;QAAd,0BAAc;;QAAd,+BAAc;IAAA;;IAAd;;QAAA,wBAAc;QAAd,sBAAc;QAAd,kBAAc;QAAd,mBAAc;QAAd,iBAAc;QAAd,oBAAc;QAAd,oBAAc;QAAd,mBAAc;QAAd,mBAAc;QAAd,oBAAc;;QAAd,2BAAc;QAAd,2BAAc;;QAAd,qBAAc;QAAd,gBAAc;QAAd,kBAAc;QAAd,gBAAc;QAAd,iBAAc;;QAAd,oBAAc;;QAAd,iCAAc;QAAd,+BAAc;;QAAd,sCAAc;;QAAd,wBAAc;QAAd,yBAAc;;QAAd,uBAAc;;QAAd,qBAAc;;QAAd,oBAAc;;QAAd,uBAAc;;QAAd,6BAAc;;QAAd,0BAAc;QAAd,+BAAc;IAAA;IAAd;QAAA,+DAAc;;QAAd,gCAAc;QAAd,kCAAc;;QAAd,kBAAc;QAAd,qBAAc;QAAd,8BAAc;QAAd,+BAAc;QAAd,yCAAc;QAAd,gCAAc;QAAd,6BAAc;QAAd,uCAAc;QAAd,+BAAc;QAAd,gCAAc;QAAd,6BAAc;QAAd,yCAAc;QAAd,qCAAc;QAAd,2CAAc;QAAd,wBAAc;QAAd,6BAAc;;QAAd,iBAAc;QAAd,4EAAc;QAAd,uEAAc;QAAd,kDAAc;QAAd,gDAAc;QAAd,gDAAc;;QAAd,qBAAc;QAAd,8DAAc;;QAAd,wBAAc;QAAd,sDAAc;;QAAd,oBAAc;QAAd,sDAAc;;QAAd,SAAc;QAAd,sCAAc;QAAd,6CAAc;;QAAd,WAAc;QAAd,qBAAc;QAAd,kDAAc;QAAd,oDAAc;QAAd,mDAAc;QAAd,qDAAc;QAAd,qDAAc;QAAd,gEAAc;QAAd,0DAAc;QAAd,yDAAc;QAAd,6DAAc;QAAd,2DAAc;;QAAd,qDAAc;QAAd,mDAAc;QAAd,wDAAc;QAAd,2DAAc;QAAd,4DAAc;;QAAd,uBAAc;QAAd,+DAAc;QAAd,sDAAc;QAAd,mEAAc;QAAd,2DAAc;QAAd,+DAAc;QAAd,gEAAc;QAAd,wEAAc;QAAd,4EAAc;;QAAd,sBAAc;QAAd,mDAAc;QAAd,sDAAc;;QAAd,qBAAc;QAAd,8BAAc;QAAd,gCAAc;QAAd,oEAAc;QAAd,sBAAc;QAAd,kCAAc;;;QAAd,wBAAc;QAAd,iDAAc;QAAd,sDAAc;QAAd,uDAAc;QAAd,wDAAc;QAAd,qDAAc;QAAd,2DAAc;;QAAd,kBAAc;QAAd,2BAAc;QAAd,2CAAc;QAAd,6BAAc;;QAAd,SAAc;QAAd,YAAc;QAAd,4CAAc;QAAd,8CAAc;QAAd,kDAAc;QAAd,6CAAc;QAAd,iDAAc;QAAd,qDAAc;;QAAd,uBAAc;QAAd,iDAAc;;QAAd,oBAAc;QAAd,qBAAc;QAAd,gCAAc;;QAAd,aAAc;QAAd,2CAAc;QAAd,kDAAc;QAAd,8CAAc;QAAd,yBAAc;;QAAd,4DAAc;QAAd,gEAAc;QAAd,uDAAc;;QAAd,YAAc;QAAd,iDAAc;QAAd,6CAAc;QAAd,iDAAc;QAAd,8CAAc;QAAd,2DAAc;QAAd,uDAAc;QAAd,2DAAc;QAAd,iEAAc;;QAAd,UAAc;QAAd,mBAAc;QAAd,qCAAc;;QAAd,WAAc;QAAd,8BAAc;QAAd,oBAAc;;QAAd,gBAAc;QAAd,0BAAc;;QAAd,kBAAc;QAAd,8BAAc;;QAAd,SAAc;QAAd,mBAAc;;QAAd,UAAc;QAAd,yBAAc;QAAd,+CAAc;;QAAd,aAAc;QAAd,kDAAc;QAAd,yBAAc;QAAd,yBAAc;QAAd,iCAAc;QAAd,gCAAc;QAAd,qBAAc;QAAd,6BAAc;QAAd,+BAAc;QAAd,kCAAc;QAAd,gCAAc;QAAd,gCAAc;IAAA;IAAd;QAAA,+DAAc;;QAAd,kBAAc;QAAd,qBAAc;QAAd,8BAAc;QAAd,+BAAc;QAAd,gCAAc;QAAd,6BAAc;QAAd,oCAAc;QAAd,+BAAc;QAAd,gCAAc;QAAd,yCAAc;QAAd,wBAAc;;QAAd,yCAAc;QAAd,6CAAc;;QAAd,iBAAc;QAAd,6DAAc;QAAd,uEAAc;QAAd,kDAAc;QAAd,+CAAc;QAAd,mDAAc;;QAAd,oBAAc;QAAd,iCAAc;;QAAd,wBAAc;QAAd,4CAAc;;QAAd,oBAAc;QAAd,sDAAc;;QAAd,SAAc;QAAd,0BAAc;;QAAd,WAAc;QAAd,qBAAc;QAAd,kDAAc;QAAd,iDAAc;QAAd,mDAAc;QAAd,qDAAc;QAAd,mDAAc;QAAd,0DAAc;QAAd,wDAAc;QAAd,8DAAc;QAAd,yDAAc;QAAd,2DAAc;;QAAd,sDAAc;QAAd,2DAAc;QAAd,oDAAc;QAAd,wDAAc;;QAAd,uBAAc;QAAd,oDAAc;QAAd,mDAAc;QAAd,qDAAc;QAAd,0DAAc;QAAd,4DAAc;QAAd,8DAAc;QAAd,gEAAc;QAAd,wEAAc;QAAd,4EAAc;;QAAd,sBAAc;QAAd,gDAAc;QAAd,yDAAc;QAAd,yCAAc;QAAd,2CAAc;;QAAd,8BAAc;QAAd,gCAAc;QAAd,uCAAc;QAAd,sBAAc;QAAd,kCAAc;;QAAd,wBAAc;QAAd,uDAAc;QAAd,wDAAc;QAAd,wDAAc;QAAd,2DAAc;QAAd,yDAAc;;QAAd,kBAAc;QAAd,2BAAc;QAAd,2CAAc;QAAd,6BAAc;;QAAd,SAAc;QAAd,YAAc;QAAd,4CAAc;QAAd,+CAAc;QAAd,qDAAc;QAAd,8CAAc;QAAd,kDAAc;QAAd,qDAAc;;QAAd,uBAAc;QAAd,iDAAc;;QAAd,qBAAc;QAAd,gCAAc;;QAAd,aAAc;QAAd,uCAAc;QAAd,2CAAc;;QAAd,YAAc;QAAd,gDAAc;QAAd,gDAAc;QAAd,oDAAc;QAAd,8CAAc;QAAd,8DAAc;QAAd,+DAAc;;QAAd,UAAc;QAAd,oBAAc;;QAAd,WAAc;QAAd,gCAAc;QAAd,qBAAc;;QAAd,gBAAc;QAAd,2BAAc;;QAAd,kBAAc;QAAd,8BAAc;;IAAA;ACAd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;ACOlB;IACE,kBAAkB;EACpB;AACA;IACE,qBAAqB;EACvB;AAEE;EAAA;AAA4B;AAI5B;;EAAA,kBAA6D;EAA7D,iBAA6D;EAA7D,iBAA6D;EAA7D,kEAA6D;EAA7D,kBAA6D;EAA7D,4DAA6D;EAA7D,8BAA6D;IAC7D;AAD6D;AAS7D;EAAA;AAAqB;AAMrB;;;EAAA;AAAkG;AAAlG;;;EAAA,iBAAkG;EAAlG,gBAAkG;EAAlG,mBAAkG;EAAlG;AAAkG;AAAlG;;;EAAA,kBAAkG;EAAlG;AAAkG;AAAlG;;;EAAA,cAAkG;EAAlG,kBAAkG;EAAlG;AAAkG;AAAlG;;EAAA;;;IAAA,kBAAkG;IAAlG;EAAkG;AAAA;AAGlG;EAAA,kBAA2G;EAA3G,kBAA2G;EAA3G,kBAA2G;EAA3G,oBAA2G;EAA3G,gBAA2G;EAA3G;AAA2G;AAA3G;EAAA,eAA2G;EAA3G;AAA2G;AAA3G;EAAA,kBAA2G;EAA3G;AAA2G;AAA3G;;EAAA;IAAA,eAA2G;IAA3G;EAA2G;AAAA;AAM3G;;;EAAA;AAAiG;AAAjG;;;EAAA,kBAAiG;EAAjG,gBAAiG;EAAjG,mBAAiG;EAAjG;AAAiG;AAAjG;;;EAAA,eAAiG;EAAjG;AAAiG;AAAjG;;;EAAA,mBAAiG;EAAjG;AAAiG;AAAjG;;EAAA;;;IAAA,mBAAiG;IAAjG;EAAiG;AAAA;AAGjG;IAAA,oBAA0H;IAA1H,mBAA0H;IAA1H,kBAA0H;IAA1H,iBAA0H;IAA1H,iBAA0H;IAA1H,2BAA0H;EAAA;AAA1H;EAAA,mBAA0H;EAA1H,kBAA0H;EAA1H;AAA0H;AAA1H;EAAA,mBAA0H;EAA1H,cAA0H;EAA1H,eAA0H;EAA1H;AAA0H;AAA1H;;EAAA;IAAA,mBAA0H;IAA1H;EAA0H;AAAA;AAG1H;EAAA,aAA4F;EAA5F,sBAA4F;EAA5F,uBAA4F;EAA5F,eAA4F;EAA5F,mBAA4F;EAA5F;AAA4F;AAA5F;EAAA,iBAA4F;EAA5F;AAA4F;AAA5F;EAAA,kBAA4F;EAA5F;AAA4F;AAG5F;EAAA;AAAsF;AAAtF;EAAA,kBAAsF;EAAtF,gBAAsF;EAAtF,mBAAsF;EAAtF;AAAsF;AAAtF;EAAA,mBAAsF;EAAtF;AAAsF;AAAtF;EAAA,iBAAsF;EAAtF;AAAsF;AAGtF;EAAA;AAAoF;AAApF;EAAA,mBAAoF;EAApF,gBAAoF;EAApF,mBAAoF;EAApF;AAAoF;AAApF;EAAA,kBAAoF;EAApF;AAAoF;AAApF;EAAA,mBAAoF;EAApF;AAAoF;AAOpF;;;;;EAAA,eAAgE;EAAhE;AAAgE;AAAhE;;;;;EAAA,mBAAgE;EAAhE;AAAgE;AAAhE;;;;;EAAA,kBAAgE;EAAhE;AAAgE;AAAhE;;EAAA;;;;;IAAA,mBAAgE;IAAhE;EAAgE;AAAA;AAIhE;EAAA,kBAA0C;EAA1C;AAA0C;AAA1C;EAAA,mBAA0C;EAA1C;AAA0C;AAA1C;EAAA,kBAA0C;EAA1C;AAA0C;AAA1C;EAAA,mBAA0C;EAA1C;AAA0C;AAK1C;;EAAA;AAAe;AAKf;;EAAA;AAAmB;AAInB;EAAA,cAA0N;EAA1N,WAA0N;EAA1N,wBAA0N;KAA1N,qBAA0N;UAA1N,gBAA0N;EAA1N,mCAA0N;EAA1N,8CAA0N;EAA1N,uCAA0N;EAA1N,6BAA0N;EAA1N,qBAA0N;EAA1N,sBAA0N;EAA1N,mBAA0N;EAA1N,sBAA0N;EAA1N,gBAA0N;EAA1N;AAA0N;AAA1N;EAAA;AAA0N;AAA1N;EAAA,oBAA0N;EAA1N,qBAA0N;EAA1N,mBAA0N;EAA1N;AAA0N;AAA1N;EAAA,oBAA0N;EAA1N,qBAA0N;EAA1N,mBAA0N;EAA1N;AAA0N;AAE5N;IACE,yCAA8B;EAChC;AAFA;IACE,8BAA8B;EAChC;AAEE;EAAA,kBAAoY;EAApY,SAAoY;EAApY,UAAoY;EAApY,SAAoY;EAApY,UAAoY;EAApY,mBAAoY;EAApY,2BAAoY;EAApY,+LAAoY;EAApY,gBAAoY;EAApY,uBAAoY;EAApY,mBAAoY;EAApY,qBAAoY;EAApY,sBAAoY;EAApY,mBAAoY;EAApY,oBAAoY;EAApY,+BAAoY;EAApY;AAAoY;AAApY;EAAA,SAAoY;EAApY,qBAAoY;EAApY,+LAAoY;EAApY;AAAoY;AAApY;EAAA,SAAoY;EAApY,qBAAoY;EAApY,+LAAoY;EAApY;AAAoY;AAApY;EAAA,qBAAoY;EAApY;AAAoY;AAApY;EAAA,qBAAoY;EAApY;AAAoY;AAApY;EAAA,qBAAoY;EAApY;AAAoY;AAApY;EAAA,qBAAoY;EAApY;AAAoY;AAApY;EAAA,eAAoY;EAApY;AAAoY;AAApY;EAAA,eAAoY;EAApY;AAAoY;AAApY;EAAA,iBAAoY;EAApY;AAAoY;AAApY;EAAA,iBAAoY;EAApY;AAAoY;AAApY;EAAA,kBAAoY;EAApY;AAAoY;AAApY;EAAA,kBAAoY;EAApY;AAAoY;AAApY;EAAA,2BAAoY;EAApY,+LAAoY;EAApY,mBAAoY;EAApY,oBAAoY;EAApY;AAAoY;AAApY;EAAA,SAAoY;EAApY,uBAAoY;EAApY,+LAAoY;EAApY,oBAAoY;EAApY,qBAAoY;EAApY,kBAAoY;EAApY;AAAoY;AAApY;EAAA,uBAAoY;EAApY,+LAAoY;EAApY,kBAAoY;EAApY;AAAoY;AAApY;EAAA,SAAoY;EAApY,uBAAoY;EAApY,+LAAoY;EAApY,oBAAoY;EAApY,qBAAoY;EAApY,kBAAoY;EAApY;AAAoY;AAApY;EAAA,uBAAoY;EAApY,+LAAoY;EAApY,kBAAoY;EAApY;AAAoY;AAApY;EAAA,mBAAoY;EAApY;AAAoY;AAGpY;EAAA,SAAgE;EAAhE,qBAAgE;EAAhE,+LAAgE;EAAhE;AAAgE;AAAhE;EAAA,qBAAgE;EAAhE;AAAgE;AAAhE;EAAA,qBAAgE;EAAhE;AAAgE;AAGhE;EAAA;AAAkN;AAAlN;EAAA,gBAAkN;EAAlN,sBAAkN;EAAlN,cAAkN;EAAlN,WAAkN;EAAlN,wBAAkN;KAAlN,qBAAkN;UAAlN,gBAAkN;EAAlN,mCAAkN;EAAlN,8CAAkN;EAAlN,uCAAkN;EAAlN,kBAAkN;EAAlN,4DAAkN;EAAlN,eAAkN;EAAlN,gBAAkN;EAAlN;AAAkN;AAAlN;EAAA;AAAkN;AAAlN;EAAA,gBAAkN;EAAlN,qBAAkN;EAAlN;AAAkN;AAAlN;EAAA,gBAAkN;EAAlN,qBAAkN;EAAlN;AAAkN;AAGlN;EAAA;AAAkB;AAAlB;EAAA;AAAkB;AAGlB;EAAA,kBAA4G;EAA5G,WAA4G;EAA5G,UAA4G;EAA5G,mBAA4G;EAA5G,2BAA4G;EAA5G,+LAA4G;EAA5G,gBAA4G;EAA5G,uBAA4G;EAA5G,mBAA4G;EAA5G,oBAA4G;EAA5G,qBAA4G;EAA5G;AAA4G;AAA5G;EAAA,SAA4G;EAA5G,kBAA4G;EAA5G;AAA4G;AAA5G;EAAA,SAA4G;EAA5G,kBAA4G;EAA5G;AAA4G;AAO5G;;;;EAAA,eAAqD;EAArD;AAAqD;AAArD;;;;EAAA,iBAAqD;EAArD;AAAqD;AAArD;;;;EAAA,kBAAqD;EAArD;AAAqD;AAIrD;EAAA;AAA8M;AAA9M;;EAAA,0BAA8M;EAA9M,oCAA8M;EAA9M,+BAA8M;EAA9M;AAA8M;AAA9M;EAAA,kBAA8M;EAA9M,mBAA8M;EAA9M,oBAA8M;EAA9M,oBAA8M;EAA9M,YAA8M;EAA9M,aAA8M;EAA9M,cAA8M;EAA9M,eAA8M;EAA9M,qBAA8M;EAA9M,uCAA8M;EAA9M,wCAA8M;EAA9M,wCAA8M;EAA9M,iCAA8M;EAA9M,yCAA8M;EAA9M,kHAA8M;EAA9M,wBAA8M;EAA9M,0BAA8M;EAA9M;AAA8M;AAA9M;EAAA,YAA8M;EAA9M;AAA8M;AAA9M;EAAA,YAA8M;EAA9M;AAA8M;AAI9M;EAAA,gDAAwD;EAAxD;AAAwD;AAIxD;EAAA;AAAyB;AAAzB;EAAA;AAAyB;AAD3B;IAEE,oDAAoD;EACtD;AAHA;IAEE,+DAAoD;EACtD;AAGE;;EAAA,0BAA+I;EAA/I,oCAA+I;EAA/I,+BAA+I;EAA/I;AAA+I;AAA/I;EAAA,gBAA+I;EAA/I,mBAA+I;EAA/I,qBAA+I;EAA/I,aAA+I;EAA/I,cAA+I;EAA/I,0BAA+I;EAA/I,+LAA+I;EAA/I,qBAA+I;EAA/I,0CAA+I;EAA/I,wBAA+I;EAA/I,0BAA+I;EAA/I;AAA+I;AAA/I;EAAA,sBAA+I;EAA/I;AAA+I;AAA/I;EAAA,sBAA+I;EAA/I;AAA+I;AAI/I;EAAA,0BAAoD;EAApD,+LAAoD;EAApD;AAAoD;AAApD;EAAA,0BAAoD;EAApD,+LAAoD;EAApD;AAAoD;AAIpD;EAAA,6BAAoC;EAApC;AAAoC;AAApC;EAAA,6BAAoC;EAApC;AAAoC;AAIpC;EAAA,cAAa;EAAb;AAAa;AAAb;EAAA,cAAa;EAAb;AAAa;AAIb;EAAA,0BAA6B;EAA7B;AAA6B;AAA7B;EAAA,0BAA6B;EAA7B;AAA6B;AAA7B;EAAA,0BAA6B;EAA7B;AAA6B;AAI7B;EAAA,oBAAgF;EAAhF,0CAAgF;EAAhF,6CAAgF;EAAhF;AAAgF;AAGlF;IACE,cAAc;EAChB;AAEA;;IAEE,cAAc;EAChB;AAGE;EAAA,gBAAsE;EAAtE,oBAAsE;EAAtE,4BAAsE;EAAtE,qBAAsE;EAAtE,8BAAsE;EAAtE,YAAsE;EAAtE,mBAAsE;EAAtE,2BAAsE;EAAtE;AAAsE;AAAtE;EAAA;AAAsE;AAAtE;EAAA;AAAsE;AAItE;EAAA,6DAAoK;EAApK,6DAAoK;EAApK,wDAAoK;EAApK,6CAAoK;EAApK;AAAoK;AAApK;EAAA;AAAoK;AAIpK;EAAA;AAAwC;AAIxC;EAAA,eAA2M;EAA3M,WAA2M;EAA3M,SAA2M;EAA3M,UAA2M;EAA3M,WAA2M;EAA3M,6BAA2M;EAA3M,aAA2M;EAA3M,WAA2M;EAA3M,mBAA2M;EAA3M,uBAA2M;EAA3M,kBAA2M;EAA3M,4DAA2M;EAA3M,qBAA2M;EAA3M,sBAA2M;EAA3M,wDAA2M;EAA3M;AAA2M;AAA3M;EAAA,kBAA2M;EAA3M,mBAA2M;EAA3M;AAA2M;AAA3M;EAAA,kBAA2M;EAA3M,mBAA2M;EAA3M,iBAA2M;EAA3M,wCAA2M;EAA3M,6BAA2M;EAA3M;AAA2M;AAG7M;IACE,WAAW;IACX,kBAA8E;IAA9E,aAA8E;IAA9E,cAA8E;IAA9E,QAA8E;IAA9E,WAA8E;IAA9E,sBAA8E;IAA9E,4CAA8E;EAChF;AADE;EAAA,UAA8E;EAA9E;AAA8E;AAA9E;EAAA,UAA8E;EAA9E;AAA8E;AAI9E;EAAA;AAAgB;AAKhB;;EAAA;AAAgB;AAElB;IACE,WAAW;IACX,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU;IACV,sEAA6E;IAA7E,wEAA6E;IAA7E,kEAA6E;IAA7E,mEAA6E;IAA7E,mEAA6E;IAA7E,sHAA6E;IAA7E,+BAA6E;IAA7E,kEAA6E;EAC/E;AAEA;IACE,WAAW;IACX,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,WAAW;IACX,mEAA6E;IAA7E,wEAA6E;IAA7E,kEAA6E;IAA7E,mEAA6E;IAA7E,mEAA6E;IAA7E,sHAA6E;IAA7E,+BAA6E;IAA7E,kEAA6E;EAC/E;AAEE;EAAA,aAAwD;EAAxD,WAAwD;EAAxD,gDAAwD;EAAxD;AAAwD;AAAxD;EAAA;AAAwD;AAAxD;EAAA,aAAwD;EAAxD,WAAwD;EAAxD,gDAAwD;EAAxD;AAAwD;AAAxD;EAAA;AAAwD;AAGxD;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAIpE;EAAA,YAAwF;EAAxF,gBAAwF;EAAxF,oBAAwF;EAAxF,qBAAwF;EAAxF,oBAAwF;EAAxF;AAAwF;AAAxF;EAAA,kBAAwF;EAAxF,mBAAwF;EAAxF,oBAAwF;EAAxF;AAAwF;AAAxF;EAAA,kBAAwF;EAAxF,mBAAwF;EAAxF,oBAAwF;EAAxF;AAAwF;AAAxF;;EAAA;IAAA;EAAwF;AAAA;AAIxF;EAAA,kBAAiD;EAAjD,aAAiD;EAAjD,WAAiD;EAAjD,sBAAiD;EAAjD;AAAiD;AAIjD;EAAA;AAAW;AAIX;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAGpE;EAAA;AAAkB;AAIlB;EAAA;AAAa;AAIb;IAAA,8BAA+E;EAAA;AAA/E;EAAA,aAA+E;EAA/E,mBAA+E;EAA/E,iBAA+E;EAA/E,+CAA+E;EAA/E,aAA+E;EAA/E,oBAA+E;EAA/E;AAA+E;AAA/E;EAAA;AAA+E;AAA/E;EAAA;AAA+E;AADjF;IAEE,mBAAmB;IACnB,0FAA0F;EAC5F;AAGE;EAAA;AAAmB;AAWnB;;;;;;;;EAAA,0BAA0D;EAA1D,oCAA0D;EAA1D,+BAA0D;EAA1D;AAA0D;AAG5D;;;;;;IAME,0DAA0D;IAC1D,uBAAuB;IACvB,gCAAgC;IAChC,gCAAgC;EAClC;AAEA;IACE,0BAA0B;EAC5B;AAGE;EAAA,gCAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAG9B;EAAA,eAAgB;EAAhB,kBAAgB;EAAhB;AAAgB;AAGhB;EAAA;AAAa;AAGb;EAAA;AAAc;AAGd;EAAA,oCAAkD;EAAlD;AAAkD;AAIlD;EAAA;AAA8B;AAI9B;EAAA;AAAc;AAId;EAAA;AAAyB;AAGzB;EAAA,kBAAuB;EAAvB;AAAuB;AAGvB;EAAA,eAAW;EAAX;AAAW;AAGX;EAAA,oBAAoF;EAApF,qBAAoF;EAApF,8BAAoF;EAApF,6BAAoF;EAApF,qBAAoF;EAApF,4CAAoF;EAApF;AAAoF;AAGpF;EAAA,kBAA2B;EAA3B,4DAA2B;EAA3B;AAA2B;AAG3B;EAAA,gDAA2F;EAA3F,+CAA2F;EAA3F,8DAA2F;EAA3F;AAA2F;AAG7F;IAEI;IAAA,kBAAyB;IAAzB,iBAAyB;IAAzB,kBAAyB;IAAzB;EAAyB;;MAEzB;QACE,aAAa;MACf;IAGA;IAAA;EAAW;IAGX;IAAA;EAAY;IAGZ;IAAA;EAAqB;IAArB;IAAA;EAAqB;IAGrB;IAAA;EAAY;IAhBZ;IAAA,kBAAyB;IAAzB,iBAAyB;IAAzB,kBAAyB;IAAzB,iBAAyB;QAGvB;EAHuB;IAOzB;IAAA;EAAW;IAGX;IAAA,iBAAY;IAGZ;EAHY;IAGZ;IAAA;EAAqB;IAGrB;IAAA,wBAAY;IAhBZ,kBAAyB;IAAzB,iBAAyB;IAAzB,kBAAyB;QAGvB,wBAAa;QAIf,mBAAW;QAGX,iBAAY;QAGZ;EAGY;IAHZ;IAAA;EAAqB;IAGrB;IAAA;EAAY;EAEhB;AAGE;EAAA,YAA0B;EAA1B;AAA0B;AAA1B;;EAAA;IAAA;EAA0B;AAAA;AAK5B;IACE,sBAAsB;EACxB;AAGE;EAAA;AAAa;AAIb;EAAA,WAAyB;EAAzB;AAAyB;AAG3B;IACE;MACE,8BAA8B;MAC9B,mBAAmB;IACrB;EACF;AACA;IAEI;IAAA;EAAW;IAGX;IAAA,kBAAoB;IAApB,iBAAoB;IAApB;EAAoB;IAHpB;IAAA;EAAW;IAGX;IAAA,kBAAoB;IAApB,iBAAoB;IAApB;EAAoB;EAExB;AAEA;IAEI;IAAA,gCAAwB;IAAxB,iCAAwB;IAAxB,yBAAwB;IAAxB;EAAwB;EAE5B;AAEA;IACE;MACE,WAAW;MACX,mBAAmB;MACnB,WAAW;IACb;IACA;MACE,cAAc;MACd,WAAW;MACX,WAAW;IACb;EACF;AAEA,6BAA6B;AAC7B,gCAAgC;AAChC;;IAEE,wBAAwB;IACxB,SAAS;EACX;AAEA,YAAY;AACZ;IACE,0BAA0B;EAC5B;AAEA,6CAA6C;AAC7C;IACE,2BAA2B;EAC7B;AAGE;;EAAA,0BAAiG;EAAjG,oCAAiG;EAAjG,+BAAiG;EAAjG;AAAiG;AAAjG;EAAA,kBAAiG;EAAjG,SAAiG;EAAjG,UAAiG;EAAjG,WAAiG;EAAjG,SAAiG;EAAjG,YAAiG;EAAjG,UAAiG;EAAjG,wBAAiG;EAAjG,wDAAiG;EAAjG,0BAAiG;EAAjG;AAAiG;AAGjG;EAAA,WAAkC;EAAlC,YAAkC;EAAlC,UAAkC;IAClC,UAAU;IACV;AAFkC;AAMlC;;EAAA,0BAAuD;EAAvD,oCAAuD;EAAvD,+BAAuD;EAAvD;AAAuD;AAAvD;EAAA,UAAuD;EAAvD,wBAAuD;EAAvD,wDAAuD;EAAvD,0BAAuD;EAAvD;AAAuD;AAGvD;EAAA;AAAgB;AAIhB;EAAA;AAAa;AAGf;IACE;;MAEE,UAAU;IACZ;IACA;;MAEE,YAAY;IACd;IACA;;MAEE,UAAU;IACZ;EACF;AAMA;IACE,gHAAqG;EACvG;AC9bF;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,4BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,0BAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8FAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,0GAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8GAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;ACuWnB,cAAc;AAEd;EACE,wBAAwB;EACxB;qHACoE;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;2HAC0E;EAC1E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;2HAC0E;EAC1E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;iIACgF;EAChF,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;sHACqE;EACrE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;4HAC2E;EAC3E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;wHACuE;EACvE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;uHACsE;EACtE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;uHACsE;EACtE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;6HAC4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;+HAC8E;EAC9E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;yHACwE;EACxE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;qHACoE;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;2HAC0E;EAC1E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;0HACyE;EACzE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;gIAC+E;EAC/E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;sHACqE;EACrE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB;4HAC2E;EAC3E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA,iBAAiB;AAEjB;EACE,2BAA2B;EAC3B;uHACsE;EACtE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,2BAA2B;EAC3B;6HAC4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,2BAA2B;EAC3B;wHACuE;EACvE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,2BAA2B;EAC3B;0HACyE;EACzE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,2BAA2B;EAC3B;yHACwE;EACxE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,2BAA2B;EAC3B;2HAC0E;EAC1E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;IACI,2BAA2B;IAC3B;yHACsE;IACtE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;AAEA;IACI,2BAA2B;IAC3B;8HAC2E;IAC3E,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AAEA;IACI,2BAA2B;IAC3B;0HACuE;IACvE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AAEA,cAAc;AAEd;EACE,yBAAyB;EACzB,mHAAoE;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA,eAAe;AAEf;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,6IAA8F;AAClG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,4IAA6F;AACjG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iJAAkG;AACtG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kJAAmG;AACvG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,6IAA8F;AAClG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,8IAA+F;AACnG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+IAAgG;AACpG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gJAAiG;AACrG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,4IAA6F;AACjG;AAEA,eAAe;AAEf;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,6IAA8F;AAClG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,4IAA6F;AACjG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iJAAkG;AACtG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kJAAmG;AACvG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,6IAA8F;AAClG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,8IAA+F;AACnG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+IAAgG;AACpG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gJAAiG;AACrG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,4IAA6F;AACjG;AAEA,cAAc;AAEd;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,6IAA8F;AAClG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,4IAA6F;AACjG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iJAAkG;AACtG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kJAAmG;AACvG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,6IAA8F;AAClG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,8IAA+F;AACnG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,+IAAgG;AACpG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gJAAiG;AACrG;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,4IAA6F;AACjG;AC1pBA;IACI,0BAA0B;IAC1B;;;;2IAIuG,EAAE,yBAAyB;AACtI;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB;;;;iJAI6G,EAAE,yBAAyB;AAC5I;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB;;;;4IAIwG,EAAE,yBAAyB;AACvI;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB;;;;kJAI8G,EAAE,yBAAyB;AAC7I;AACA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB;;;;wIAIoG,EAAE,yBAAyB;AACnI;ACnFA;IACI,0BAA0B;IAC1B;;;;sIAIkG,EAAE,yBAAyB;AACjI;AAGA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB;;;;uIAImG,EAAE,yBAAyB;AAClI;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB;;;;mIAI+F,EAAE,yBAAyB;AAC9H;AJgSE;EAAA,kBAA0E;EAA1E,kBAA0E;EAA1E,qBAA0E;EAA1E,iBAA0E;EAA1E,kBAA0E;EAA1E,sBAA0E;EAA1E,cAA0E;EAA1E,WAA0E;EAA1E,YAA0E;EAA1E,qBAA0E;EAA1E,kBAA0E;EAA1E,4DAA0E;EAC1E,qCAAqC;EACrC;AAF0E;AAI1E;IACE,kDAAkD;EACpD;AAGF;EAEI;IAAA,kBAAe;IAAf,4DAAe;IACf;EADe;EAIf;IAAA,yCAAoB;IACpB;EADoB;EAIpB;IAAA,kBAAe;IAAf,4DAAe;IACf;EADe;AAGnB;AAEA;EAEI;IAAA,kBAAe;IAAf,4DAAe;IACf;EADe;EAIf;IAAA,kDAAwB;IACxB;EADwB;EAIxB;IAAA,kBAAe;IAAf,4DAAe;IACf;EADe;AAGnB;AA5RE;IK3MF,2BAAA;IL4MI,aAAwD;IAAxD,WAAwD;IAAxD,gDAAwD;IAAxD,oBAAwD;EAC1D;AADE;EAAA;AAAwD;AAE1D;IK9MF,2BAAA;IL+MI,sBAAoE;EACtE;AADE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AA0GtE;IAQE;MKjUJ,2BAAA;MLkUM,mBAAW;IACb;EAUF;AA0BA;IACE;MKxWJ,2BAAA;MLyWM,mBAAW;IACb;EAIF;AAnKA;IK3MF,2BAAA;IL4MI,aAAwD;IAAxD,WAAwD;IAAxD,gDAAwD;IAAxD,oBAAwD;EAC1D;AADE;EAAA;AAAwD;AAE1D;IK9MF,2BAAA;IL+MI,sBAAoE;EACtE;AADE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AAApE;EAAA;AAAoE;AA0GtE;IAQE;MKjUJ,2BAAA;MLkUM,mBAAW;IACb;EAUF;AA0BA;IACE;MKxWJ,2BAAA;MLyWM,mBAAW;IACb;EAIF;AA9WF;EAAA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,gBAweA;EAxeA;AAweA;AAxeA;EAAA,wBAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;;EAAA;IAAA,0BAweA;IAxeA,mBAweA;IAxeA;EAweA;AAAA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,gBAweA;EAxeA;AAweA;AAxeA;EAAA,yBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,8BAweA;EAxeA,qDAweA;EAxeA;AAweA;AAxeA;EAAA,8BAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,sBAweA;EAxeA,8BAweA;EAxeA;AAweA;AAxeA;EAAA,6BAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,qBAweA;EAxeA;AAweA;AAxeA;;EAAA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;AAAA;AAxeA;EAAA,gCAweA;EAxeA;AAweA;AAxeA;EAAA,8BAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA,eAweA;EAxeA;AAweA;AAxeA;EAAA,gBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,gBAweA;EAxeA;AAweA;AAxeA;EAAA,gBAweA;EAxeA;AAweA;AAxeA;EAAA,gBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,aAweA;EAxeA;AAweA;AAxeA;EAAA,WAweA;EAxeA;AAweA;AAxeA;EAAA,aAweA;EAxeA;AAweA;AAxeA;EAAA,WAweA;EAxeA;AAweA;AAxeA;EAAA,WAweA;EAxeA;AAweA;AAxeA;EAAA,WAweA;EAxeA;AAweA;AAxeA;EAAA,WAweA;EAxeA;AAweA;AAxeA;EAAA,YAweA;EAxeA;AAweA;AAxeA;EAAA,YAweA;EAxeA;AAweA;AAxeA;EAAA,aAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,oCAweA;EAxeA;AAweA;AAxeA;EAAA,yBAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,yBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,8BAweA;EAxeA;AAweA;AAxeA;EAAA,oBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,oBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,qBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,4BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,8BAweA;EAxeA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,eAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA,eAweA;EAxeA;AAweA;AAxeA;EAAA,eAweA;EAxeA;AAweA;AAxeA;EAAA,eAweA;EAxeA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA,yBAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,qBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA,eAweA;EAxeA;AAweA;AAxeA;EAAA,gBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,gBAweA;EAxeA;AAweA;AAxeA;EAAA,gBAweA;EAxeA;AAweA;AAxeA;EAAA,gBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,aAweA;EAxeA;AAweA;AAxeA;EAAA,WAweA;EAxeA;AAweA;AAxeA;EAAA,aAweA;EAxeA;AAweA;AAxeA;EAAA,WAweA;EAxeA;AAweA;AAxeA;EAAA,WAweA;EAxeA;AAweA;AAxeA;EAAA,WAweA;EAxeA;AAweA;AAxeA;EAAA,WAweA;EAxeA;AAweA;AAxeA;EAAA,YAweA;EAxeA;AAweA;AAxeA;EAAA,YAweA;EAxeA;AAweA;AAxeA;EAAA,aAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,oCAweA;EAxeA;AAweA;AAxeA;EAAA,yBAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,yBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,8BAweA;EAxeA;AAweA;AAxeA;EAAA,oBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,oBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,qBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,4BAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,8BAweA;EAxeA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,eAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA,eAweA;EAxeA;AAweA;AAxeA;EAAA,eAweA;EAxeA;AAweA;AAxeA;EAAA,eAweA;EAxeA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA,yBAweA;EAxeA;AAweA;AAxeA;EAAA,0BAweA;EAxeA;AAweA;AAxeA;EAAA,qBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,gBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,aAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA,qBAweA;EAxeA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA,mBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,iBAweA;EAxeA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;;EAAA;IAAA,iBAweA;IAxeA;EAweA;;EAxeA;IAAA,kBAweA;IAxeA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA,eAweA;IAxeA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;AAAA;AAxeA;;EAAA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;AAAA;AAxeA;;EAAA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;AAAA;AAxeA;;EAAA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA,kBAweA;IAxeA;EAweA;AAAA;AAxeA;;EAAA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;IAAA;EAweA;;EAxeA;;IAAA;MAAA;IAweA;EAAA;AAAA;AAxeA;;EAAA;;IAAA;MAAA;IAweA;EAAA;AAAA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,6BAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,sBAweA;EAxeA;AAweA;AAxeA;EAAA,yBAweA;EAxeA;AAweA;AAxeA;EAAA,yBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,oBAweA;EAxeA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA;AAweA;AAxeA;EAAA,kBAweA;EAxeA;AAweA;AAxeA;EAAA,0CAweA;EAxeA,uDAweA;EAxeA;AAweA","sourcesContent":["@tailwind base;\n","@tailwind components;\n","@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n@import './variables.css';\n@import './themes/index.css';\n\n@layer components {\n  i {\n    font-style: normal;\n  }\n  *hover i {\n    text-decoration: none;\n  }\n  *:focus {\n    @apply outline-outline-color;\n  }\n  html,\n  body {\n    @apply font-theme touch-none touch-pan-x touch-pan-y bg-white;\n    font-optical-sizing: auto;\n  }\n\n  .header-icon{\n    @apply fill-default;\n  }\n\n  .header-home .header-icon{\n    @apply fill-icon-home;\n  }\n\n  h1,\n  h1 a,\n  h1 span {\n    @apply xs:text-xl text-2xl font-bold leading-10 kiosk:text-6xl kioskSharebox:text-4xl text-default;\n  }\n  h1.home {\n    @apply text-center mt-6 xs:text-base font-normal text-xl kiosk:text-5xl kioskSharebox:text-4xl text-inverse;\n  }\n\n  h2,\n  h2 a,\n  h2 span {\n    @apply font-bold xs:text-lg text-xl leading-10 kiosk:text-5xl kioskSharebox:text-3xl text-default;\n  }\n  h2.home {\n    @apply text-center mt-1 break-keep-title xs:text-lg text-2xl kiosk:text-6xl kioskSharebox:text-5xl kiosk:mt-3 text-inverse;\n  }\n  h2.title_card {\n    @apply text-base text-default flex items-start flex-col kiosk:text-2xl kioskSharebox:text-xl;\n  }\n  h3 {\n    @apply font-bold text-xl leading-10 text-default kiosk:text-3xl kioskSharebox:text-2xl;\n  }\n  h4 {\n    @apply font-bold text-lg leading-10 text-default kiosk:text-xl kioskSharebox:text-lg;\n  }\n  p,\n  a,\n  span,\n  h2.title_card span,\n  label {\n    @apply text-base xs:text-sm kiosk:text-3xl kioskSharebox:text-xl;\n  }\n\n  p.small {\n    @apply kiosk:text-xl kioskSharebox:text-lg;\n  }\n\n  span,\n  p {\n    @apply text-low;\n  }\n\n  p span.font-bold,\n  p strong {\n    @apply text-default;\n  }\n\n  .input {\n    @apply block px-5 kiosk:px-10 w-full pt-6 pb-2 kiosk:pt-14 kiosk:pb-8 text-default font-semibold bg-transparent appearance-none border-input-border-size border-input-border hover:border-input-border-hover rounded-input;\n  }\n  input[disabled].text-black {\n    -webkit-text-fill-color: black;\n  }\n  .input-label {\n    @apply absolute left-0 right-0 px-5 kiosk:px-10 truncate z-0 text-input-label duration-300 transform -translate-y-2.5 kiosk:-translate-y-4 text-sm kiosk:text-xl kioskSharebox:text-lg top-4 kiosk:top-12 origin-[0] peer-placeholder-shown:label-no-value peer-focus:text-sm kiosk:peer-focus:text-xl peer-focus:-translate-y-2.5 kiosk:peer-focus:-translate-y-4 peer-focus:text-input-focus-label;\n  }\n  .label-no-value {\n    @apply left-0 text-input-label translate-y-0 kiosk:translate-y-0;\n  }\n  .textarea {\n    @apply block w-full mt-12 kiosk:mt-24 mb-5 border-input-border-size border-input-border hover:border-input-border-hover kiosk:mb-10 p-2 kiosk:p-4 text-input-text font-bold bg-white appearance-none rounded-input;\n  }\n  .textarea::placeholder {\n    @apply font-normal;\n  }\n  .textarea-label {\n    @apply absolute px-2 kiosk:px-4 truncate z-0 -translate-y-2.5 top-6 kiosk:top-12 origin-[0] text-input-label;\n  }\n\n  .input,\n  .label-no-value,\n  .textarea,\n  .textarea-label {\n    @apply text-base kiosk:text-2xl kioskSharebox:text-xl;\n  }\n\n  .switch {\n    @apply relative inline-flex h-8 w-14 kiosk:h-16 kiosk:w-28 mx-2 shrink-0 cursor-pointer rounded-full transition-all duration-200 ease-in-out bg-switch-bg border-switch-border border-switch-size !shadow-none;\n  }\n\n  .switch[aria-checked='true'] {\n    @apply bg-switch-checked-bg border-switch-checked-border;\n  }\n\n  .switch.disabled {\n    @apply cursor-not-allowed;\n    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.05));\n  }\n\n  .switch > span {\n    @apply inline-block my-auto size-6 kiosk:!size-12 transform rounded-full bg-switch-span transition-all duration-200 ease-in-out translate-x-0.5;\n  }\n\n  .switch > span.checked {\n    @apply translate-x-[1.625rem] bg-switch-checked-span;\n  }\n\n  .switch.small {\n    @apply h-switch-small w-switch-small;\n  }\n\n  .switch.small > span {\n    @apply size-5;\n  }\n\n  .switch.small > span.checked {\n    @apply translate-x-[1.375rem];\n  }\n\n  button:focus-visible {\n    @apply outline outline-offset-default outline-outline-color outline-default-size;\n  }\n\n  button p {\n    color: inherit;\n  }\n\n  button div > span,\n  button > span {\n    color: inherit;\n  }\n\n  button.footer-button {\n    @apply w-96 kiosk:justify-center !py-0 h-btn items-center line-clamp-2;\n  }\n\n  .btn-home-primary{\n    @apply !text-btn-home-primary-text !border-btn-home-primary-border !bg-btn-home-primary-bg !p-btn-home-primary !text-button-home hover:!bg-btn-home-primary-hover-bg;\n  }\n\n  .btn-header {\n    @apply !border-btn-header-secondary-size;\n  }\n\n  .nextButton {\n    @apply fixed bottom-0 left-0 right-0 flex items-center justify-center w-full pb-bottom-screen pt-4 kiosk:pt-8 px-7 z-20 kiosk:px-12 bg-white kioskSharebox:bg-white/90 kioskSharebox:backdrop-blur-sm !mb-0;\n  }\n\n  .nextButton::before {\n    content: '';\n    @apply absolute inset-x-7 kiosk:inset-x-12 top-0 bg-header-border h-px rounded;\n  }\n\n  a {\n    @apply underline;\n  }\n\n  .main-content,\n  .homePage {\n    @apply min-h-svh;\n  }\n  .homePage:after {\n    content: '';\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 0;\n    @apply bg-gradient-to-b from-gray-900/80 via-gray-900/0 via-70% to-gray-900/0;\n  }\n\n  .homePage:before {\n    content: '';\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 10;\n    @apply bg-gradient-to-t from-gray-900/80 via-gray-900/0 via-70% to-gray-900/0;\n  }\n  .content {\n    @apply grid grid-cols-1 w-full pb-32 kioskSharebox:pb-24;\n  }\n  .content > * {\n    @apply mb-5 last:mb-0 kiosk:mb-10 kiosk:last:mb-0 kioskSharebox:mb-6;\n  }\n\n  .main-content {\n    @apply max-w-4xl m-auto px-6 kiosk:px-12 pb-4 kiosk:pb-28 pt-16 kiosk:pt-44 lg:max-w-6xl;\n  }\n\n  main, .main-content {\n    @apply relative w-full flex flex-col items-center;\n  }\n\n  main > *:first-child{\n    @apply pt-6;\n  }\n\n  main > *, .main-content footer {\n    @apply mb-5 last:mb-0 kiosk:mb-10 kiosk:last:mb-0 kioskSharebox:mb-5;\n  }\n  main h1 {\n    @apply text-center;\n  }\n\n  .main-content_admin {\n    @apply !pt-88;\n  }\n\n  .warning-alert {\n    @apply p-4 kiosk:p-6 flex border border-warning-default text-black items-center;\n    border-radius: 30px;\n    background: linear-gradient(0deg, rgba(255, 183, 0, 0.1), rgba(255, 183, 0, 0.1)), #ffffff;\n  }\n\n  .no-cursor, .no-cursor *, .no-cursor a, .no-cursor button, .no-cursor .cursor-pointer {\n    @apply !cursor-none;\n  }\n\n  .no-transition,\n  .no-transition .transition,\n  .no-transition .transition-all,\n  .no-transition .transition-colors,\n  .no-transition .transition-shadow,\n  .no-transition .transition-opacity,\n  .no-transition *:not(.animate-spin),\n  .no-transition .transition-transform {\n    @apply !transition-none !duration-0 !delay-0 !animate-none;\n  }\n\n  .no-blur,\n  .no-blur *,\n  .no-blur [class^=\"blur-\"],\n  .no-blur [class^=\"shadow-\"],\n  .no-blur [class^=\"backdrop-\"],\n  .no-blur [class^=\"drop-shadow-\"] {\n    /* Do not use tailwind classname to avoid recursive call */\n    filter: none !important;\n    box-shadow: 0 0 #0000 !important;\n    backdrop-filter: none !important;\n  }\n\n  .messages {\n    height: calc(50vh - 106px);\n  }\n\n  .carousel:not(.carousel-card).multiMedia:not(.fixed){\n    @apply my-carousel pb-carousel;\n  }\n  .carousel.carousel-card{\n    @apply my-0 pb-0;\n  }\n  .carousel .carousel-leftArrow{\n    @apply left-3;\n  }\n  .carousel .carousel-rightArrow{\n    @apply right-3;\n  }\n  .carousel:not(.fixed):not(.carousel-card) .carousel-leftArrow{\n    @apply left-arrow-left-left right-arrow-left-right;\n  }\n\n  .carousel:not(.fixed):not(.carousel-card) .carousel-rightArrow{\n    @apply right-arrow-right-right;\n  }\n\n  .carousel .navigation{\n    @apply top-1/2;\n  }\n\n  .carousel:not(.fixed):not(.carousel-card) .navigation{\n    @apply top-navigation-top;\n  }\n  .carousel:not(.fixed):not(.carousel-card) .carousel-footer{\n    @apply absolute bg-none;\n  }\n  .carousel.carousel-card .carousel-footer{\n    @apply my-0;\n  }\n  .carousel .carousel-footer .step-indicator {\n    @apply bg-carousel-step opacity-30 rounded-full w-carousel-step h-carousel-step mx-1;\n  }\n  .carousel.carousel-card .carousel-footer .step-indicator {\n    @apply bg-white opacity-100;\n  }\n  .carousel .carousel-footer .step-indicator.active{\n    @apply !w-carousel-step-active !h-carousel-step-active !bg-carousel-step-active opacity-100;\n  }\n\n  @media screen and (max-height: 552px) {\n    .nextButton {\n      @apply relative pt-4 px-0;\n\n      .scrollBtn {\n        display: none;\n      }\n    }\n    .content {\n      @apply pb-0;\n    }\n    .main-content {\n      @apply pt-20;\n    }\n    main > *, .main-content footer {\n      @apply mb-5 last:mb-0;\n    }\n    .signature {\n      @apply !h-60;\n    }\n  }\n\n  .logo-home {\n    @apply w-20 h-auto md:w-28;\n  }\n  .break-keep-title {\n    word-break: keep-all;\n  }\n  .break-word {\n    word-break: break-word;\n  }\n\n  .modal {\n    @apply w-full;\n  }\n\n  .modal-large {\n    @apply w-full max-w-modal;\n  }\n\n  @media (min-width: 768px) {\n    .modal {\n      width: min(100% - 40px, 896px);\n      margin-inline: auto;\n    }\n  }\n  @media (max-width: 932px) and (orientation: landscape) {\n    .content {\n      @apply pb-0;\n    }\n    .nextButton {\n      @apply relative px-0;\n    }\n  }\n\n  @media (max-width: 420px) {\n    .step-indicator {\n      @apply !mx-0.5 !w-2 !h-2;\n    }\n  }\n\n  @supports not (aspect-ratio: 16 / 9) {\n    .aspect-video::before {\n      float: left;\n      padding-top: 56.25%;\n      content: '';\n    }\n    .aspect-video::after {\n      display: block;\n      content: '';\n      clear: both;\n    }\n  }\n\n  /* Hide number input arrows */\n  /* Chrome, Safari, Edge, Opera */\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  /* Firefox */\n  input[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  /* Hide input number for the admin pin code */\n  input[type='number'].adminPinCode {\n    -webkit-text-security: disc;\n  }\n\n  .key-modal-transition--slide-up {\n    @apply transition-all ease-out duration-500 inset-x-0 bottom-0 opacity-0 absolute top-full h-auto;\n  }\n  .key-modal-transition--slide-up-enter {\n    @apply opacity-100 bottom-0 h-auto;\n    top: 450px;\n    min-height: calc(100vh - 450px);\n  }\n\n  .admin-content-transition--fade-out {\n    @apply transition-all ease-out duration-500 opacity-100;\n  }\n  .admin-content-transition--fade-out-leave {\n    @apply opacity-0;\n  }\n\n  .hide-play-button .play-button {\n    @apply hidden;\n  }\n\n  @keyframes vertical-pulse {\n    0%,\n    100% {\n      opacity: 0;\n    }\n    20%,\n    80% {\n      opacity: 0.5;\n    }\n    40%,\n    60% {\n      opacity: 1;\n    }\n  }\n\n  .modal-title-px-0 > div {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .text-shadow-lg{\n    text-shadow: 0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1), 0px 4px 8px rgb(0 0 0 / 0.1);\n  }\n}\n\n.loader {\n  @apply relative block size-8 my-6 mx-auto rounded-full bg-white box-border;\n  box-shadow: -58px 0 #fff, 58px 0 #fff;\n  animation: shadowPulse 2s linear infinite;\n\n  &.emergency {\n    animation: emergencyShadowPulse 2s linear infinite;\n  }\n}\n\n@keyframes shadowPulse {\n  33% {\n    @apply bg-white;\n    box-shadow: -58px 0 var(--color-brand-high), 58px 0 #fff;\n  }\n  66% {\n    @apply bg-brand-high;\n    box-shadow: -58px 0 #fff, 58px 0 #fff;\n  }\n  100% {\n    @apply bg-white;\n    box-shadow: -58px 0 #fff, 58px 0 var(--color-brand-high);\n  }\n}\n\n@keyframes emergencyShadowPulse {\n  33% {\n    @apply bg-white;\n    box-shadow: -58px 0 var(--color-danger-default), 58px 0 #fff;\n  }\n  66% {\n    @apply bg-danger-default;\n    box-shadow: -58px 0 #fff, 58px 0 #fff;\n  }\n  100% {\n    @apply bg-white;\n    box-shadow: -58px 0 #fff, 58px 0 var(--color-danger-default);\n  }\n}\n","@tailwind utilities;\n","@import './tokens.css';\n\n@layer base {\n    :root {\n        --font-theme: 'Noto Sans', 'Noto Sans JP', 'NotoSansKR', 'NotoSansTC', 'NotoSansHK', 'sans-serif';\n\n        --spacing-3xs:  0.25rem;\n        --spacing-2xs: 0.5rem;\n        --spacing-xs: 0.75rem;\n        --spacing-s: 1rem;\n        --spacing-m: 1.25rem;\n        --spacing-l: 1.5rem;\n        --spacing-xl: 1.75rem;\n        --spacing-2xl: 2rem;\n        --spacing-4xl: 3rem;\n        --spacing-5xl: 7rem;\n\n        --height-small-button: 36px;\n        --height-normal-button: 56px;\n\n        --text-xxxs: 0.625rem;\n        --text-xxs: 0.75rem;\n        --text-xs: 0.875rem;\n        --text-s: 1rem;\n        --text-m: 1.125rem;\n\n        --text-icon: 1.5rem;\n\n        --spacing-basket-items-top: 0;\n        --spacing-basket-items-right: 0;\n\n        --text-button-xs: var(--text-xs);\n        --text-button-s: var(--text-s);\n        --text-button-home: var(--text-m) ;\n\n        --line-height-button: var(--spacing-s);\n\n        --modal-max-width: 600px;\n        --modal-max-height: 600px;\n\n        /* COMMON COLORS */\n        /** Colors neutral **/\n        --color-neutral-white: var(--color-light-100);\n        --color-neutral-lowest: var(--color-neutral-0);\n        --color-neutral-default: var(--color-neutral-100);\n        --color-neutral-high: var(--color-neutral-blue-100);\n        --color-neutral-higher: var(--color-neutral-blue-200);\n        --color-neutral-highest: var(--color-neutral-1100);\n        --color-neutral-dark: var(--color-dark-100);\n\n        /** Colors brand **/\n        --color-brand-lowest: var(--color-brand-50-200);\n        --color-brand-low: var(--color-neutral-higher);\n        --color-brand-default: var(--color-brand-600);\n        --color-brand-high: var(--color-brand-800);\n        --color-brand-highest: var(--color-brand-1000);\n\n        /** Colors text **/\n        --color-default: var(--color-neutral-1100);\n        --color-low: var(--color-neutral-900);\n        --color-lowest: var(--color-neutral-800);\n        --color-inverse: var(--color-light-100);\n\n        /** Colors success **/\n        --color-success-lowest: var(--color-green-200);\n        --color-success-default: var(--color-green-700);\n\n        /** Colors warning **/\n        --color-warning-lowest: var(--color-orange-200);\n        --color-warning-default: var(--color-orange-700);\n\n        /** Colors danger **/\n        --color-danger-lowest: var(--color-red-100);\n        --color-danger-lower: var(--color-red-200);\n        --color-danger-low: var(--color-red-300);\n        --color-danger-default: var(--color-red-700);\n        --color-danger-high: var(--color-red-800);\n        --color-danger-highest: var(--color-red-900);\n\n        --color-emergency-gradient-from: var(--color-red-400);\n        --color-emergency-gradient-to: var(--color-red-700);\n\n        /** Colors background **/\n        --color-overlay: var(--color-neutral-default);\n\n        /** Colors border **/\n        --color-border-low: var(--color-neutral-100);\n        --color-border-default: var(--color-neutral-blue-100);\n\n        /* HOME */\n        --color-logo-home: var(--color-neutral-white);\n        --color-icon-home: var(--color-default);\n\n        /* HEADER */\n        --color-header-border: var(--color-border-low);\n        --color-header-border-progress: var(--color-brand-high);\n\n        /* BUTTONS */\n        --size-btn-height: 56px;\n        --size-refused-min-width: 112px;\n\n        /** Button primary **/\n        --color-btn-primary-bg: var(--color-neutral-white);\n        --color-btn-primary-text: var(--color-default);\n        --color-btn-primary-icon-text: var(--color-default);\n        --color-btn-primary-icon-bg: var(--color-neutral-default);\n        --color-btn-primary-hover-text: var(--color-default);\n        --color-btn-primary-hover-bg: var(--color-neutral-white);\n        --color-btn-primary-disabled-text: var(--color-default);\n        --color-btn-primary-disabled-bg: rgba(255,255,255, .50);\n\n        /** Button home **/\n        --color-btn-home-primary-bg: var(--color-neutral-white);\n        --color-btn-home-primary-text: var(--color-default);\n        --color-btn-home-primary-icon-text: var(--color-default);\n        --color-btn-home-primary-border: var(--color-neutral-white);\n        --color-btn-home-primary-hover-bg: var(--color-neutral-white);\n\n        --size-padding-btn-home-primary: var(--spacing-xl);\n\n        /** Button secondary **/\n        --color-btn-secondary-bg: var(--color-neutral-default);\n        --color-btn-secondary-text: var(--color-default);\n        --color-btn-secondary-border: var(--color-neutral-default);\n        --color-btn-secondary-hover-bg: var(--color-neutral-high);\n        --color-btn-secondary-hover-text: var(--color-brand-highest);\n        --color-btn-secondary-hover-border: var(--color-neutral-default);\n        --color-btn-secondary-disabled-text: var(--color-default);\n        --color-btn-secondary-disabled-bg: var(--color-neutral-lowest);\n        --color-btn-secondary-disabled-border: var(--color-neutral-default);\n\n        /** Button tertiary **/\n        --color-btn-tertiary-bg: var(--color-brand-high);\n        --color-btn-tertiary-text: var(--color-neutral-white);\n        --color-btn-tertiary-hover-bg: var(--color-brand-highest);\n        --color-btn-tertiary-disabled-bg: var(--color-brand-low);\n        --color-btn-tertiary-disabled-text: var(--color-neutral-white);\n\n        /** Button error **/\n        --color-btn-error-hover-bg: var(--color-red-800);\n        --color-btn-error-disabled-bg: var(--color-red-300);\n\n        --rounded-button: 9999px;\n        --border-btn-primary-size: 0;\n        --border-btn-secondary-size: 0;\n        --border-btn-header-secondary-size: var(--border-btn-secondary-size);\n        --font-btn-weight: 700;\n        --size-btn-primary-icon-home: 80px;\n\n        /** Card Radio Bullet **/\n        --color-card-radio-bg: var(--color-neutral-white);\n        --color-card-radio-title: var(--color-default);\n        --color-card-radio-description: var(--color-default);\n        --color-card-radio-border: var(--color-border-default);\n        --color-card-radio-hover-bg: var(--color-brand-50-800);\n        --color-card-radio-active-title: var(--color-inverse);\n        --color-card-radio-active-description: var(--color-inverse);\n        --color-card-radio-active-bg: var(--color-brand-high);\n        --border-card-radio-size: 1px;\n\n        /** Outline CTA **/\n        --outline-default-size: 4px;\n        --color-outline-color: var(--color-border-default);\n        --outline-offset-default: 0px;\n\n        /* FORM */\n        /** Input **/\n        --color-input-bg: var(--color-neutral-default);\n        --color-input-label: var(--color-brand-800);\n        --color-input-focus-label: var(--color-brand-high);\n        --color-input-text: var(--color-low);\n        --color-input-border: var(--color-neutral-default);\n        --color-input-border-hover: var(--color-neutral-default);\n\n        --color-input-multiple-tag-bg: var(--color-neutral-white);\n        --color-input-multiple-tag-label: var(--color-low);\n\n        --p-select-spacing: 0px;\n        --rounded-select: 0px;\n        --ring-select-border: var(--color-border-low);\n\n        --rounded-input: 8px;\n        --spacing-input-border-size: 0;\n\n        /** Switch **/\n        --color-switch-bg: var(--color-neutral-default);\n        --color-switch-border: var(--color-neutral-default);\n        --color-switch-span: var(--color-neutral-white);\n        --border-switch-size: 2px;\n\n        --color-switch-checked-bg: var(--color-brand-high);\n        --color-switch-checked-border: var(--color-brand-high);\n        --color-switch-checked-span: var(--color-neutral-white);\n\n        --w-switch-small: 48px;\n        --h-switch-small: 28px;\n\n        /** Radio **/\n        --color-radio-border: var(--color-default);\n        --color-radio-active-bg: var(--color-inverse);\n        --color-radio-active-border: var(--color-inverse);\n        --color-radio-active-dot: var(--color-brand-high);\n\n        --color-radio-secondary-border: var(--color-default);\n        --color-radio-secondary-active-bg: var(--color-brand-high);\n        --color-radio-secondary-active-border: var(--color-brand-high);\n        --color-radio-secondary-active-dot: var(--color-neutral-white);\n        --color-radio-secondary-active-text: var(--color-default);\n        --color-radio-secondary-hover-border: var(--color-brand-high);\n\n        --border-radio-size: 2px;\n\n        /* CARDS */\n        --rounded-card: 8px;\n        --color-card-bg: var(--color-overlay);\n\n        /* POPUP */\n        --color-popup-bg: var(--color-neutral-white);\n\n        /* MODALS */\n        --rounded-t-modal: 1rem 1rem 0 0;\n        --rounded-modal: 1rem;\n\n        /* BUTTON LIST */\n        --rounded-button-list: 42px;\n\n        /* PANEL OPENING */\n        --rounded-t-panel-opening: 228px;\n\n        /* Chat */\n        --rounded-chat: 1.5rem;\n\n        /* Admin */\n        --rounded-admin-card: 85px;\n        --color-slot-number: var(--color-card-bg);\n\n        /* Carousel */\n        --color-carousel-step: var(--color-neutral-higher);\n        --color-carousel-step-active: var(--color-default);\n        --w-carousel-step: 0.375rem;\n        --h-carousel-step: 0.375rem;\n        --w-carousel-step-active: 0.625rem;\n        --h-carousel-step-active: 0.625rem;\n        --size-carousel: 40px;\n        --size-carousel-footer: -40px;\n        --spacing-navigation-top: 50%;\n        --spacing-arrow-left-left: 12px;\n        --spacing-arrow-left-right: inherit;\n        --spacing-arrow-right-right: 12px;\n\n        /* Scroll button */\n        --spacing-scroll-button: 36px;\n\n        --content-max-width: 768px;\n\n        /* SCREENSAVER ANIMATION */\n        /* Duration of the animations. It MUST BE in milliseconds */\n        --screensaver-animation-duration: 600ms;\n        /* Default delay before showing the 'out' animation */\n        --screensaver-animation-out-delay: calc(20s - var(--screensaver-animation-duration));\n\n    }\n\n    :root[data-origin=\"KIOSK\"] {\n\n        --spacing-3xs:  0.5rem;\n        --spacing-2xs: 1rem;\n        --spacing-xs: 1.5rem;\n        --spacing-s: 2rem;\n        --spacing-m: 2.5rem;\n        --spacing-l: 3rem;\n        --spacing-xl: 3.5rem;\n        --spacing-2xl: 4rem;\n        --spacing-4xl: 6rem;\n        --spacing-5xl: 14rem;\n\n        --height-small-button: 72px;\n        --height-normal-button: 112px;\n\n        --text-xxxs: 1rem;\n        --text-xxs: 1.25rem;\n        --text-xs: 1.5rem;\n        --text-s: 1.75rem;\n        --text-m: 2rem;\n\n        --text-icon: 2.5rem;\n\n        --text-button-xs: var(--text-xxs);\n        --text-button-s: var(--text-xs);\n\n        --line-height-button: var(--spacing-s);\n\n        --modal-max-width: 900px;\n        --modal-max-height: 1200px;\n\n        --size-btn-height: 112px;\n\n        --rounded-input: 16px;\n\n        --rounded-modal: 85px;\n\n        --rounded-card: 16px;\n\n        --rounded-button-list: 72px;\n\n        --spacing-scroll-button: 74px;\n\n        --content-max-width: 100vw;\n\n        --size-refused-min-width: 168px;\n    }\n\n    :root[data-origin=\"SHAREBOX_INDOOR_KIOSK\"] {\n\n        --spacing-3xs:  0.375rem;\n        --spacing-2xs: 0.75rem;\n        --spacing-xs: 1rem;\n        --spacing-s: 1.5rem;\n        --spacing-m: 2rem;\n        --spacing-l: 2.25rem;\n        --spacing-xl: 2.5rem;\n        --spacing-2xl: 3rem;\n        --spacing-4xl: 5rem;\n        --spacing-5xl: 10rem;\n\n        --height-small-button: 54px;\n        --height-nrmal-button: 84px;\n\n        --text-xxxs: 0.875rem;\n        --text-xxs: 1rem;\n        --text-xs: 1.25rem;\n        --text-s: 1.5rem;\n        --text-m: 1.75rem;\n\n        --text-icon: 2.25rem;\n\n        --text-button-xs: var(--text-xxs);\n        --text-button-s: var(--text-xs);\n\n        --line-height-button: var(--spacing-s);\n\n        --modal-max-width: 900px;\n        --modal-max-height: 000px;\n\n        --size-btn-height: 76px;\n\n        --rounded-input: 16px;\n\n        --rounded-card: 16px;\n\n        --rounded-modal: 1.5rem;\n\n        --spacing-scroll-button: 50px;\n\n        --content-max-width: 768px;\n        --size-refused-min-width: 168px;\n    }\n  }\n\n/* Noto Sans */\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-Thin.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-Thin.woff') format('woff');\n  font-weight: 100;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-ThinItalic.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-ThinItalic.woff') format('woff');\n  font-weight: 100;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-ExtraLight.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-ExtraLight.woff') format('woff');\n  font-weight: 200;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-ExtraLightItalic.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-ExtraLightItalic.woff') format('woff');\n  font-weight: 200;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-Light.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-Light.woff') format('woff');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-LightItalic.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-LightItalic.woff') format('woff');\n  font-weight: 300;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-Regular.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-Regular.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-Italic.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-Italic.woff') format('woff');\n  font-weight: normal;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-Medium.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-Medium.woff') format('woff');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-MediumItalic.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-MediumItalic.woff') format('woff');\n  font-weight: 500;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-SemiBoldItalic.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-SemiBoldItalic.woff') format('woff');\n  font-weight: 600;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-SemiBold.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-SemiBold.woff') format('woff');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-Bold.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-Bold.woff') format('woff');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-BoldItalic.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-BoldItalic.woff') format('woff');\n  font-weight: 700;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-ExtraBold.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-ExtraBold.woff') format('woff');\n  font-weight: 800;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-ExtraBoldItalic.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-ExtraBoldItalic.woff') format('woff');\n  font-weight: 800;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-Black.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-Black.woff') format('woff');\n  font-weight: 900;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: rewrite-url('/fonts/NotoSans/NotoSans-BlackItalic.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSans-BlackItalic.woff') format('woff');\n  font-weight: 900;\n  font-style: italic;\n  font-display: swap;\n}\n\n/* Noto Sans JP */\n\n@font-face {\n  font-family: 'Noto Sans JP';\n  src: rewrite-url('/fonts/NotoSans/NotoSansJP-Thin.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSansJP-Thin.woff') format('woff');\n  font-weight: 100;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans JP';\n  src: rewrite-url('/fonts/NotoSans/NotoSansJP-ExtraLight.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSansJP-ExtraLight.woff') format('woff');\n  font-weight: 200;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans JP';\n  src: rewrite-url('/fonts/NotoSans/NotoSansJP-Light.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSansJP-Light.woff') format('woff');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans JP';\n  src: rewrite-url('/fonts/NotoSans/NotoSansJP-Regular.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSansJP-Regular.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans JP';\n  src: rewrite-url('/fonts/NotoSans/NotoSansJP-Medium.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSansJP-Medium.woff') format('woff');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans JP';\n  src: rewrite-url('/fonts/NotoSans/NotoSansJP-SemiBold.woff2') format('woff2'),\n      rewrite-url('/fonts/NotoSans/NotoSansJP-SemiBold.woff') format('woff');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n    font-family: 'Noto Sans JP';\n    src: rewrite-url('/fonts/NotoSans/NotoSansJP-Bold.woff2') format('woff2'),\n        rewrite-url('/fonts/NotoSans/NotoSansJP-Bold.woff') format('woff');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Noto Sans JP';\n    src: rewrite-url('/fonts/NotoSans/NotoSansJP-ExtraBold.woff2') format('woff2'),\n        rewrite-url('/fonts/NotoSans/NotoSansJP-ExtraBold.woff') format('woff');\n    font-weight: 800;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Noto Sans JP';\n    src: rewrite-url('/fonts/NotoSans/NotoSansJP-Black.woff2') format('woff2'),\n        rewrite-url('/fonts/NotoSans/NotoSansJP-Black.woff') format('woff');\n    font-weight: 900;\n    font-style: normal;\n    font-display: swap;\n}\n\n/* Oooh Baby */\n\n@font-face {\n  font-family: 'Ooooh Baby';\n  src: rewrite-url('/fonts/OooohBaby/OoohBaby.ttf') format('TrueType');\n  font-weight: 100;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* NotoSansKR */\n\n@font-face {\n    font-family: 'NotoSansKR';\n    font-display: swap;\n    font-weight: 900;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_KR/NotoSansKR-Black.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansKR';\n    font-display: swap;\n    font-weight: 700;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_KR/NotoSansKR-Bold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansKR';\n    font-display: swap;\n    font-weight: 800;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_KR/NotoSansKR-ExtraBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansKR';\n    font-display: swap;\n    font-weight: 200;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_KR/NotoSansKR-ExtraLight.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansKR';\n    font-display: swap;\n    font-weight: 300;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_KR/NotoSansKR-Light.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansKR';\n    font-display: swap;\n    font-weight: 500;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_KR/NotoSansKR-Medium.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansKR';\n    font-display: swap;\n    font-weight: 400;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_KR/NotoSansKR-Regular.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansKR';\n    font-display: swap;\n    font-weight: 600;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_KR/NotoSansKR-SemiBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansKR';\n    font-display: swap;\n    font-weight: 100;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_KR/NotoSansKR-Thin.ttf') format('truetype');\n}\n\n/* NotoSansTC */\n\n@font-face {\n    font-family: 'NotoSansTC';\n    font-display: swap;\n    font-weight: 900;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_TC/NotoSansTC-Black.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansTC';\n    font-display: swap;\n    font-weight: 700;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_TC/NotoSansTC-Bold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansTC';\n    font-display: swap;\n    font-weight: 800;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_TC/NotoSansTC-ExtraBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansTC';\n    font-display: swap;\n    font-weight: 200;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_TC/NotoSansTC-ExtraLight.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansTC';\n    font-display: swap;\n    font-weight: 300;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_TC/NotoSansTC-Light.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansTC';\n    font-display: swap;\n    font-weight: 500;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_TC/NotoSansTC-Medium.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansTC';\n    font-display: swap;\n    font-weight: 400;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_TC/NotoSansTC-Regular.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansTC';\n    font-display: swap;\n    font-weight: 600;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_TC/NotoSansTC-SemiBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansTC';\n    font-display: swap;\n    font-weight: 100;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_TC/NotoSansTC-Thin.ttf') format('truetype');\n}\n\n/*NotoSansHK */\n\n@font-face {\n    font-family: 'NotoSansHK';\n    font-display: swap;\n    font-weight: 900;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_HK/NotoSansHK-Black.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansHK';\n    font-display: swap;\n    font-weight: 700;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_HK/NotoSansHK-Bold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansHK';\n    font-display: swap;\n    font-weight: 800;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_HK/NotoSansHK-ExtraBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansHK';\n    font-display: swap;\n    font-weight: 200;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_HK/NotoSansHK-ExtraLight.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansHK';\n    font-display: swap;\n    font-weight: 300;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_HK/NotoSansHK-Light.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansHK';\n    font-display: swap;\n    font-weight: 500;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_HK/NotoSansHK-Medium.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansHK';\n    font-display: swap;\n    font-weight: 400;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_HK/NotoSansHK-Regular.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansHK';\n    font-display: swap;\n    font-weight: 600;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_HK/NotoSansHK-SemiBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'NotoSansHK';\n    font-display: swap;\n    font-weight: 100;\n    font-style: normal;\n    src: rewrite-url('/themes/default/fonts/Noto_Sans_HK/NotoSansHK-Thin.ttf') format('truetype');\n}","@layer base {\n    :root[data-theme=\"PORSCHE\"] {\n        --font-theme: 'PorscheNext', 'Heiti SC', 'SimHei', 'sans-serif';\n\n        --spacing-basket-items-top: -4px;\n        --spacing-basket-items-right: -4px;\n\n        /* COMMON COLORS */\n        /** Colors neutral **/\n        --color-neutral-white: #ffffff;\n        --color-neutral-lowest: #D8D8DB;\n        --color-neutral-lowest-rgb: 216, 216, 219;\n        --color-neutral-default: #A2A2A9;\n        --color-neutral-high: #949598;\n        --color-neutral-high-rgb: 148, 149, 152;\n        --color-neutral-higher: #6B6D70;\n        --color-neutral-highest: #535457;\n        --color-neutral-dark: #010205;\n        --color-transparent: rgba(255,255,255, 0);\n        --color-notification-success: #197E10;\n        --color-notification-success-rgb: 25 126 16;\n        --color-outline: #1a44ea;\n        --color-neutral-1100: #010205;\n\n        /* Colors brand */\n        --color-brand-transparent-lowest: rgba(var(--color-neutral-lowest-rgb), .35);\n        --color-brand-transparent-low: rgba(var(--color-neutral-high-rgb), .18);\n        --color-brand-default: var(--color-neutral-higher);\n        --color-brand-high: var(--color-neutral-highest);\n        --color-brand-highest: var(--color-neutral-dark);\n\n        /** Colors success **/\n        --color-success-default: var(--color-notification-success-rgb);\n\n        /** Colors background **/\n        --color-overlay: var(--color-brand-transparent-lowest);\n\n        /** Colors border **/\n        --color-border-low: var(--color-brand-transparent-low);\n\n        /* HOME */\n        --color-logo-home: rgba(255,255,255,0);\n        --color-icon-home: var(--color-neutral-white);\n\n        /*BUTTONS */\n        /** Button primary **/\n        --color-btn-primary-bg: var(--color-neutral-white);\n        --color-btn-primary-text: var(--color-brand-highest);\n        --color-btn-primary-icon-text: var(--color-default);\n        --color-btn-primary-icon-bg: var(--color-transparent);\n        --color-btn-primary-border: var(--color-neutral-dark);\n        --color-btn-primary-hover-bg: var(--color-brand-transparent-low);\n        --color-btn-primary-hover-text: var(--color-brand-highest);\n        --color-btn-primary-disabled-text: var(--color-brand-low);\n        --color-btn-primary-hover-border: var(--color-neutral-higher);\n        --color-btn-primary-disabled-bg: var(--color-neutral-white);\n\n        --color-btn-home-primary-bg: var(--color-transparent);\n        --color-btn-home-primary-text: var(--color-inverse);\n        --color-btn-home-primary-icon-text: var(--color-inverse);\n        --color-btn-home-primary-border: var(--color-neutral-white);\n        --color-btn-home-primary-hover-bg:  var(--color-transparent);\n\n        /** Button secondary **/\n        --color-btn-secondary-bg: var(--color-brand-transparent-lowest);\n        --color-btn-secondary-text: var(--color-brand-highest);\n        --color-btn-secondary-border: var(--color-brand-transparent-lowest);\n        --color-btn-secondary-hover-bg: var(--color-neutral-lowest);\n        --color-btn-secondary-hover-border: var(--color-neutral-lowest);\n        --color-btn-secondary-disabled-text: var(var(--color-brand-low));\n        --color-btn-secondary-disabled-bg: var(--color-brand-transparent-lowest);\n        --color-btn-secondary-disabled-border: var(--color-brand-transparent-lowest);\n\n        /** Button tertiary **/\n        --color-btn-tertiary-bg: var(--color-brand-highest);\n        --color-btn-tertiary-hover-bg: var(--color-brand-high);\n\n        --rounded-button: 4px;\n        --border-btn-primary-size: 2px;\n        --border-btn-secondary-size: 0px;\n        --border-btn-header-secondary-size: var(--border-btn-secondary-size);\n        --font-btn-weight: 400;\n        --size-btn-primary-icon-home: 40px;\n\n\n        /** Card Radio Bullet **/\n        --color-card-radio-bg: var(--color-neutral-white);\n        --color-card-radio-border: var(--color-neutral-lowest);\n        --color-card-radio-hover-bg: var(--color-neutral-white);\n        --color-card-radio-active-bg: var(--color-neutral-white);\n        --color-card-radio-active-title: var(--color-default);\n        --color-card-radio-active-description: var(--color-default);\n\n        /** Outline CTA **/\n        --outline-default-size: 2px;\n        --color-outline-color: var(--color-outline);\n        --outline-offset-default: 2px;\n\n        /* FORM */\n        /** Input **/\n        --color-input-bg: var(--color-neutral-white);\n        --color-input-label: var(--color-neutral-dark);\n        --color-input-focus-label: var(--color-brand-high);\n        --color-input-text: var(--color-neutral-dark);\n        --color-input-border: var(--color-neutral-higher);\n        --color-input-border-hover: var(--color-neutral-dark);\n\n        --p-select-spacing: 6px;\n        --ring-select-border: var(--color-neutral-lowest);\n\n        --rounded-input: 4px;\n        --rounded-select: 4px;\n        --spacing-input-border-size: 2px;\n\n        /** Switch **/\n        --color-switch-bg: var(--color-transparent);\n        --color-switch-border: var(--color-neutral-higher);\n        --color-switch-span: var(--color-neutral-dark);\n        --border-switch-size: 2px;\n\n        --color-switch-checked-bg: var(--color-notification-success);\n        --color-switch-checked-border: var(--color-notification-success);\n        --color-switch-checked-span: var(--color-neutral-white);\n\n        /** Radio **/\n        --color-radio-border: var(--color-neutral-higher);\n        --color-radio-active-bg: var(--color-default);\n        --color-radio-active-border: var(--color-default);\n        --color-radio-active-dot: var(--color-inverse);\n        --color-radio-secondary-border: var(--color-neutral-higher);\n        --color-radio-secondary-active-bg: var(--color-default);\n        --color-radio-secondary-active-border: var(--color-default);\n        --color-radio-secondary-hover-border: var(--color-neutral-higher);\n\n        /* CARDS */\n        --rounded-card: 4px;\n        --color-card-bg: var(--color-overlay);\n\n        /* MODALS */\n        --rounded-t-modal: 8px 8px 0 0;\n        --rounded-modal: 8px;\n\n        /* BUTTON LIST */\n        --rounded-button-list: 4px;\n\n        /* PANEL OPENING */\n        --rounded-t-panel-opening: 8px;\n\n        /* Chat */\n        --rounded-chat: 4px;\n\n        /* Admin */\n        --rounded-admin-card: 4px;\n        --color-slot-number: var(--color-neutral-white);\n\n        /* Carousel */\n        --color-carousel-step: var(--color-neutral-higher);\n        --w-carousel-step: 0.5rem;\n        --h-carousel-step: 0.5rem;\n        --w-carousel-step-active: 1.25rem;\n        --h-carousel-step-active: 0.5rem;\n        --size-carousel: 40px;\n        --size-carousel-footer: -40px;\n        --spacing-navigation-top: -20px;\n        --spacing-arrow-left-left: inherit;\n        --spacing-arrow-left-right: 40px;\n        --spacing-arrow-right-right: 0px;\n    }\n}\n\n@font-face {\n    font-family: 'PorscheNext';\n    src:    local('PorscheNext'),\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-Regular.eot') format('embedded-opentype'), /* IE6-IE8 */\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-Regular.woff2') format('woff2'), /* Super Modern Browsers */\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-Regular.woff') format('woff'), /* Pretty Modern Browsers */\n            rewrite-url('theme-porsche://fonts/PorscheNextTT/PorscheNextTT-Regular.ttf') format('truetype'); /* Safari, Android, iOS */\n}\n\n@font-face {\n    font-family: 'PorscheNext';\n    font-style: italic;\n    src:    local('PorscheNext'),\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-RegularItalic.eot') format('embedded-opentype'), /* IE6-IE8 */\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-RegularItalic.woff2') format('woff2'), /* Super Modern Browsers */\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-RegularItalic.woff') format('woff'), /* Pretty Modern Browsers */\n            rewrite-url('theme-porsche://fonts/PorscheNextTT/PorscheNextTT-RegularItalic.ttf') format('truetype'); /* Safari, Android, iOS */\n}\n\n@font-face {\n    font-family: 'PorscheNext';\n    font-weight: 500;\n    src:    local('PorscheNext'),\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-SemiBold.eot') format('embedded-opentype'), /* IE6-IE8 */\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-SemiBold.woff2') format('woff2'), /* Super Modern Browsers */\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-SemiBold.woff') format('woff'), /* Pretty Modern Browsers */\n            rewrite-url('theme-porsche://fonts/PorscheNextTT/PorscheNextTT-SemiBold.ttf') format('truetype'); /* Safari, Android, iOS */\n}\n\n@font-face {\n    font-family: 'PorscheNext';\n    font-weight: 500;\n    font-style: italic;\n    src:    local('PorscheNext'),\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-SemiBoldItalic.eot') format('embedded-opentype'), /* IE6-IE8 */\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-SemiBoldItalic.woff2') format('woff2'), /* Super Modern Browsers */\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-SemiBoldItalic.woff') format('woff'), /* Pretty Modern Browsers */\n            rewrite-url('theme-porsche://fonts/PorscheNextTT/PorscheNextTT-SemiBoldItalic.ttf') format('truetype'); /* Safari, Android, iOS */\n}\n@font-face {\n    font-family: 'PorscheNext';\n    font-weight: 700;\n    src:    local('PorscheNext'),\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-Bold.eot') format('embedded-opentype'), /* IE6-IE8 */\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-Bold.woff2') format('woff2'), /* Super Modern Browsers */\n            rewrite-url('theme-porsche://fonts/PorscheNextWLa/PorscheNextWLa-Bold.woff') format('woff'), /* Pretty Modern Browsers */\n            rewrite-url('theme-porsche://fonts/PorscheNextTT/PorscheNextTT-Bold.ttf') format('truetype'); /* Safari, Android, iOS */\n}\n\n","@layer base {\n    :root[data-theme=\"FORD\"] {\n        --font-theme: 'FordAntenna', 'Helvetica', 'Arial', 'sans-serif';\n\n        /* COMMON COLORS */\n        /** Colors neutral **/\n        --color-neutral-white: #ffffff;\n        --color-neutral-lowest: #f1f1f1;\n        --color-neutral-default: #6e6e6e;\n        --color-neutral-high: #4d4d4d;\n        --color-neutral-high-rgb: 77, 77, 77;\n        --color-neutral-higher: #1700f4;\n        --color-neutral-highest: #00095b;\n        --color-transparent: rgba(255,255,255, 0);\n        --color-outline: #1700f4;\n\n        --color-low: var(--color-neutral-highest);\n        --color-default: var(--color-neutral-highest);\n\n        /* Colors brand */\n        --color-brand-transparent-lowest: var(--color-neutral-lowest);\n        --color-brand-transparent-low: rgba(var(--color-neutral-high-rgb), .18);\n        --color-brand-default: var(--color-neutral-higher);\n        --color-brand-high: var(--color-neutral-higher);\n        --color-brand-highest: var(--color-neutral-highest);\n\n        /** Colors Danger **/\n        --color-danger-default: 217 46 20;\n\n        /** Colors background **/\n        --color-overlay: var(--color-neutral-lowest);\n\n        /** Colors border **/\n        --color-border-low: var(--color-brand-transparent-low);\n\n        /* HOME */\n        --color-icon-home: #d92e14;\n\n        /*BUTTONS */\n        /** Button primary **/\n        --color-btn-primary-bg: var(--color-neutral-white);\n        --color-btn-primary-text: var(--color-brand-high);\n        --color-btn-primary-icon-text: var(--color-default);\n        --color-btn-primary-icon-bg: var(--color-transparent);\n        --color-btn-primary-border: var(--color-brand-high);\n        --color-btn-primary-hover-text: var(--color-neutral-white);\n        --color-btn-primary-hover-bg: var(--color-brand-highest);\n        --color-btn-primary-hover-border: var(--color-neutral-highest);\n        --color-btn-primary-disabled-text: var(--color-brand-low);\n        --color-btn-primary-disabled-bg: var(--color-neutral-white);\n\n        --color-btn-home-primary-text: var(--color-brand-high);\n        --color-btn-home-primary-icon-text: var(--color-brand-high);\n        --color-btn-home-primary-border: rgba(255,255,255,0);\n        --color-btn-home-primary-hover-bg: rgba(255,255,255,0.5);\n\n        /** Button secondary **/\n        --color-btn-secondary-bg: var(--color-neutral-white);\n        --color-btn-secondary-text: var(--color-brand-high);\n        --color-btn-secondary-border: var(--color-brand-high);\n        --color-btn-secondary-hover-bg: var(--color-brand-highest);\n        --color-btn-secondary-hover-text: var(--color-neutral-white);\n        --color-btn-secondary-hover-border: var(--color-brand-highest);\n        --color-btn-secondary-disabled-text: var(var(--color-brand-low));\n        --color-btn-secondary-disabled-bg: var(--color-brand-transparent-lowest);\n        --color-btn-secondary-disabled-border: var(--color-brand-transparent-lowest);\n\n        /** Button tertiary **/\n        --color-btn-tertiary-bg: var(--color-brand-high);\n        --color-btn-tertiary-hover-bg: var(--color-brand-highest);\n        --color-btn-tertiary-disabled-bg: #dedede;\n        --color-btn-tertiary-disabled-text: #808080;\n\n        --border-btn-primary-size: 2px;\n        --border-btn-secondary-size: 2px;\n        --border-btn-header-secondary-size: 0px;\n        --font-btn-weight: 600;\n        --size-btn-primary-icon-home: 80px;\n\n        /** Card Radio Bullet **/\n        --color-card-radio-hover-bg: var(--color-neutral-white);\n        --color-card-radio-active-bg: var(--color-neutral-white);\n        --color-card-radio-active-title: var(--color-brand-high);\n        --color-card-radio-active-description: var(--color-default);\n        --color-card-radio-active-border: var(--color-brand-high);\n\n        /** Outline CTA **/\n        --outline-default-size: 2px;\n        --color-outline-color: var(--color-outline);\n        --outline-offset-default: 2px;\n\n        /* FORM */\n        /** Input **/\n        --color-input-bg: var(--color-neutral-white);\n        --color-input-label: var(--color-brand-highest);\n        --color-input-focus-label: var(--color-brand-highest);\n        --color-input-text: var(--color-brand-highest);\n        --color-input-border: var(--color-neutral-default);\n        --color-input-border-hover: var(--color-neutral-dark);\n\n        --p-select-spacing: 6px;\n        --ring-select-border: var(--color-neutral-lowest);\n\n        --rounded-select: 4px;\n        --spacing-input-border-size: 2px;\n\n        /** Switch **/\n        --color-switch-bg: var(--color-overlay);\n        --color-switch-border: var(--color-overlay);\n\n        /** Radio **/\n        --color-radio-border: var(--color-brand-highest);\n        --color-radio-active-bg: var(--color-brand-high);\n        --color-radio-active-border: var(--color-brand-high);\n        --color-radio-active-dot: var(--color-inverse);\n        --color-radio-secondary-border: var(--color-card-radio-border);\n        --color-radio-secondary-active-text: var(--color-brand-default);\n\n        /* CARDS */\n        --rounded-card: 16px;\n\n        /* MODALS */\n        --rounded-t-modal: 20px 20px 0 0;\n        --rounded-modal: 20px;\n\n        /* BUTTON LIST */\n        --rounded-button-list: 20px;\n\n        /* PANEL OPENING */\n        --rounded-t-panel-opening: 8px;\n\n    }\n}\n\n@font-face {\n    font-family: 'FordAntenna';\n    src:    local('FordAntenna'),\n            rewrite-url('theme-ford://fonts/Ford-Antenna/Ford-Antenna-Regular.eot') format('embedded-opentype'), /* IE6-IE8 */\n            rewrite-url('theme-ford://fonts/Ford-Antenna/Ford-Antenna-Regular.woff2') format('woff2'), /* Super Modern Browsers */\n            rewrite-url('theme-ford://fonts/Ford-Antenna/Ford-Antenna-Regular.woff') format('woff'), /* Pretty Modern Browsers */\n            rewrite-url('theme-ford://fonts/Ford-Antenna/Ford-Antenna-Regular.ttf') format('truetype'); /* Safari, Android, iOS */\n}\n\n\n@font-face {\n    font-family: 'FordAntenna';\n    font-weight: 600;\n    src:    local('FordAntenna'),\n            rewrite-url('theme-ford://fonts/Ford-Antenna/Ford-Antenna-Semibold.eot') format('embedded-opentype'), /* IE6-IE8 */\n            rewrite-url('theme-ford://fonts/Ford-Antenna/Ford-Antenna-Semibold.woff2') format('woff2'), /* Super Modern Browsers */\n            rewrite-url('theme-ford://fonts/Ford-Antenna/Ford-Antenna-Semibold.woff') format('woff'), /* Pretty Modern Browsers */\n            rewrite-url('theme-ford://fonts/Ford-Antenna/Ford-Antenna-Semibold.ttf') format('truetype'); /* Safari, Android, iOS */\n}\n\n@font-face {\n    font-family: 'FordAntenna';\n    font-weight: 700;\n    src:    local('FordAntenna'),\n            rewrite-url('theme-ford://fonts/Ford-Antenna/Ford-Antenna-Bold.eot') format('embedded-opentype'), /* IE6-IE8 */\n            rewrite-url('theme-ford://fonts/Ford-Antenna/Ford-Antenna-Bold.woff2') format('woff2'), /* Super Modern Browsers */\n            rewrite-url('theme-ford://fonts/Ford-Antenna/Ford-Antenna-Bold.woff') format('woff'), /* Pretty Modern Browsers */\n            rewrite-url('theme-ford://fonts/Ford-Antenna/Ford-Antenna-Bold.ttf') format('truetype'); /* Safari, Android, iOS */\n}\n\n",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
